import PropTypes from 'prop-types';

export const CAMPAIGNTYPE_USERMANAGER = 'campaigntype.usermanager';
export const CAMPAIGNTYPE_SERVICEACCOUNT = 'campaigntype.serviceaccount';
export const CAMPAIGNTYPE_ROLEOWNER = 'campaigntype.roleowner';
export const CAMPAIGNTYPE_ENTITLEMENTOWNER = 'campaigntype.entitlementowner';
export const CAMPAIGNTYPE_SELF_CERTIFICATION = 'campaigntype.selfcertification';
export const CAMPAIGNTYPE_ORGANIZATION = 'campaigntype.organization';
export const CAMPAIGNTYPE_APPLICATION_OWNER = 'campaigntype.applicationowner';
export const CAMPAIGNTYPE_APPLICATIONOWNER_METADATA =
  'campaigntype.applicationowner.metadata';

export const CAMPAIGN_TYPES = {
  1: CAMPAIGNTYPE_ENTITLEMENTOWNER,
  2: CAMPAIGNTYPE_USERMANAGER,
  3: CAMPAIGNTYPE_SELF_CERTIFICATION,
  5: CAMPAIGNTYPE_ROLEOWNER,
  6: CAMPAIGNTYPE_SERVICEACCOUNT,
  7: CAMPAIGNTYPE_ORGANIZATION,
  8: CAMPAIGNTYPE_APPLICATION_OWNER,
  9: CAMPAIGNTYPE_APPLICATIONOWNER_METADATA,
};

export const CERTIFICATION_PREVEIW_STATUS_CODE = 6; // preview status code
export const REDIRECT_FLAG = 'certificationDetailToList';

export const ITEMS_API_OFFSET = 20;

/**
 * Returns a dynamic batch size based on active tab count.
 * Larger datasets use bigger batches to reduce the number of API calls.
 */

// Need to remove
// export const getItemsApiOffset = () => ITEMS_API_OFFSET;
export const getItemsApiOffset = (
  activeTabCount // eslint-disable-line no-unused-vars
) =>
  // // CR-21520- enable when dynamic offset required
  // if (activeTabCount > 50000) return 200;
  // if (activeTabCount > 20000) return 150;
  // if (activeTabCount > 10000) return 100;
  // if (activeTabCount > 5000) return 75;
  // if (activeTabCount > 1000) return 50;
  // if (activeTabCount > 500) return 30;
  // if (activeTabCount > 100) return 25;

  ITEMS_API_OFFSET;

export const LIST_PAGE_DATA_OFFSET = 20;
export const SYSTEM_DATA_THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const PREDEFINED_COMMENTS_PAGE_FETCH = {
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  WORKS_FOR_ME: 'CONFIRM',
  DOES_NOT_WORK_FOR_ME: 'DOESNOTWORKFORMEWITHREASSIGNMENT',
  REASSIGN: 'REASSIGNACCESS',
  CONSULT: 'CONSULT',
  BULKACTION: 'BULKACTION',
};

/**
 * Provides a guide for UX design breakpoints and their corresponding naming structure.
 * This is a reference for responsive design, indicating the pixel width and associated
 * designations for various device sizes.
 *
 * Mobile:
 * - 360px: 140 MobileXSmall (This is below our minimum, but it’s a common Android size, adding it here just in case)
 * - 375px: 130 MobileSmall
 * - 480px: 120 MobileLarge
 * - 600px: 110 MobileXLarge
 *
 * Tablet:
 * - 768px: 100 TabletXSmall
 * - 834px: 90 TabletSmall
 * - 900px: 80 TabletMedium
 * - 960px: 70 TabletLarge
 * - 1024px: 60 TabletXLarge
 *
 * Desktop:
 * - 1280px: 50 DesktopSmall
 * - 1366px: 40 DesktopMedium
 * - 1440px: 30 DesktopLarge
 * - 1600px: 20 DesktopXLarge
 * - 1920px: 10 DesktopXXLarge
 */
export const SCREEN_SIZE_MOBILE_LARGE = 'MobileLarge';
export const SCREEN_SIZE_MOBILE_XLARGE = 'MobileXLarge';
export const SCREEN_SIZE_TABLET_XSMALL = 'TabletXSmall';
export const SCREEN_SIZE_TABLET_SMALL = 'TabletSmall';
export const SCREEN_SIZE_TABLET_MEDIUM = 'TabletMedium';
export const SCREEN_SIZE_TABLET_LARGE = 'TabletLarge';
export const SCREEN_SIZE_DESKTOP_SMALL = 'DesktopSmall';

// Add to these SCREEN_WIDTH_QUERIES as needed for certs responsivness
export const SCREEN_WIDTH_QUERIES = [
  { query: '(max-width: 479px)', value: 120, label: SCREEN_SIZE_MOBILE_LARGE },
  { query: '(max-width: 599px)', value: 110, label: SCREEN_SIZE_MOBILE_XLARGE },
  { query: '(max-width: 767px)', value: 100, label: SCREEN_SIZE_TABLET_XSMALL },
  { query: '(max-width: 833px)', value: 90, label: SCREEN_SIZE_TABLET_SMALL },
  { query: '(max-width: 899px)', value: 80, label: SCREEN_SIZE_TABLET_MEDIUM },
  { query: '(max-width: 959px)', value: 80, label: SCREEN_SIZE_TABLET_LARGE },
  { query: '(max-width: 1279px)', value: 50, label: SCREEN_SIZE_DESKTOP_SMALL },
];

export const MODAL_SIDEPANEL_DIRECTION = {
  UP: 'up',
  DOWN: 'down',
};

export const ALERT_THEMES = {
  SUCCESS: 'Success',
  CRITICAL: 'Critical',
};

export const REF_PROP = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
]);

export const PERCENTAGE_100 = 100;

export const DATE_COLUMNS = [
  'Account_CREATED_ON',
  'Role_UPDATEDATE',
  'Account_LASTLOGONDATE',
  'User_STARTDATE',
  'User_ENDDATE',
  'Account_PASSWORDLOCKDATE',
  'Ent_LASTSCANDATE',
  'Account_UPDATEDATE',
  'User_EXTENDEDENDDATE',
  'UPDATEDATE',
  'CREATEDATE',
  'LASTREVIEWEDDATE',
  'LASTCERTIFIED',
  'Ent_LASTREVIEWEDDATE',
  'Ent_UPDATEDATE',
  'User_UPDATEDATE',
  'User_CREATEDATE',
  'User_TERMDATE',
  'User_SOURCELASTLOGINDATE',
  'User_LASTSYNCDATE',
  'LASTUSEDENDDATE',
  'User_LASTCERTIFIEDDATE',
  'enddate',
];

export const SANITIZED_DATE_FORMATS_MAPPING = {
  'MM/dd/yyyy HH:mm:ss': 'MM/DD/yyyy HH:mm:ss',
  'MM/dd/yy': 'MM/DD/YY',
  'EEE MMM dd HH:mm:ss z yyyy': 'ddd MMM DD HH:mm:ss [UTC] YYYY',
};

export const GROUP_BY_USER_VALUE = 'user';
export const GROUP_BY_APP_VALUE = 'application';

export const INITIAL_GROUP_BY_OPTIONS = [
  {
    label: 'Default',
    value: GROUP_BY_USER_VALUE,
    isChecked: true,
    isDisabled: false,
  },
  {
    label: 'Application',
    value: GROUP_BY_APP_VALUE,
    isChecked: false,
    isDisabled: false,
  },
];

export const msgs = {
  certs: {
    // Custom Keys added
    NOT_PROVIDED: {
      ATTESTATIONS: {
        id: 'NOT_PROVIDED.ATTESTATIONS',
        defaultMessage: 'Not Provided',
      },
    },
    userName: {
      ATTESTATIONS: {
        id: 'userName.ATTESTATIONS',
        defaultMessage: 'User Name',
      },
    },
    entitlement_value: {
      ATTESTATIONS: {
        id: 'entitlement_value.ATTESTATIONS',
        defaultMessage: 'Entitlement Value',
      },
    },
    entitlement_glossary: {
      ATTESTATIONS: {
        id: 'entitlement_glossary.ATTESTATIONS',
        defaultMessage: 'Entitlement Glossary',
      },
    },
    entitlement_type: {
      ATTESTATIONS: {
        id: 'entitlement_type.ATTESTATIONS',
        defaultMessage: 'Entitlement Type',
      },
    },
    systemname: {
      ATTESTATIONS: {
        id: 'systemname.ATTESTATIONS',
        defaultMessage: 'System Name',
      },
    },
    endpointname: {
      ATTESTATIONS: {
        id: 'endpointname.ATTESTATIONS',
        defaultMessage: 'Endpoint Name',
      },
    },
    customproperty1: {
      ATTESTATIONS: {
        id: 'customproperty1.ATTESTATIONS',
        defaultMessage: 'Custom Property 1',
      },
    },
    'Certificatipn.Unresponded.label': {
      ATTESTATIONS: {
        id: 'Certificatipn.Unresponded.label',
        defaultMessage: 'Unresponded',
      },
    },
    'Certification.Unresponded.label': {
      ATTESTATIONS: {
        id: 'Certification.Unresponded.label',
        defaultMessage: 'Unresponded',
      },
    },
    'CR.JRM.NO_RULES_FOUND.Reason.Default.label': {
      ATTESTATIONS: {
        id: 'TCR.JRM.NO_RULES_FOUND.Reason.Default.label',
        defaultMessage:
          "None of the user's attributes correspond to this entitlement",
      },
    },
    'TM.OOB.Unsure.label': {
      ATTESTATIONS: {
        id: 'TM.OOB.Unsure.label',
        defaultMessage: 'Access provided Outside of Saviynt',
      },
    },
    'TM.OOB.label': {
      ATTESTATIONS: {
        id: 'TM.OOB.label',
        defaultMessage: 'Access provided from Saviynt',
      },
    },
    'TM.LastCert.Less3months.label': {
      ATTESTATIONS: {
        id: 'TM.LastCert.Less3months.label',
        defaultMessage: 'Certified within last 3 months',
      },
    },
    'TM.LastCert.Greater3monthsAndLess6months.label': {
      ATTESTATIONS: {
        id: 'TM.LastCert.Greater3monthsAndLess6months.label',
        defaultMessage: 'Certified within last 6 months',
      },
    },
    'TM.LastCert.Greater6monthsAndLess9months': {
      ATTESTATIONS: {
        id: 'TM.LastCert.Greater6monthsAndLess9months.label',
        defaultMessage: 'Certified within last 9 months',
      },
    },
    'TM.LastCert.Greater9monthsAndLess12months.label': {
      ATTESTATIONS: {
        id: 'TM.LastCert.Greater9monthsAndLess12months.label',
        defaultMessage: 'Certified within last year',
      },
    },
    'TM.LastCert.0monthsDiff.label': {
      ATTESTATIONS: {
        id: 'TM.LastCert.0monthsDiff.label',
        defaultMessage: 'Certified more than a year ago',
      },
    },
    'TM.Certified.Year.Ago': {
      ATTESTATIONS: {
        id: 'TM.Certified.Year.Ago',
        defaultMessage: 'Certified more than a year ago',
      },
    },
    'TM.LastCert.Unsure.label': {
      ATTESTATIONS: {
        id: 'TM.LastCert.Unsure.label',
        defaultMessage: 'Data not available for last certified',
      },
    },
    'TM.PAA.label': {
      ATTESTATIONS: {
        id: 'TM.PAA.label',
        defaultMessage: '{0} Confidence of Peer Access',
      },
    },
    'TM.PAA.NoData.Unsure.label': {
      ATTESTATIONS: {
        id: 'TM.PAA.NoData.Unsure.label',
        defaultMessage:
          'Data not available to calculate Peer Access Confidence',
      },
    },
    'TM.SOX.Unsure.label': {
      ATTESTATIONS: {
        id: 'TM.SOX.Unsure.label',
        defaultMessage: 'Data not available for Sox Criticality',
      },
    },
    'TM.SOX.VeryHigh.label': {
      ATTESTATIONS: {
        id: 'TM.SOX.VeryHigh.label',
        defaultMessage: 'Very High SOX Criticality',
      },
    },
    'TM.SOX.High.label': {
      ATTESTATIONS: {
        id: 'TM.SOX.High.label',
        defaultMessage: 'High SOX Criticality',
      },
    },
    'TM.SOX.Medium.label': {
      ATTESTATIONS: {
        id: 'TM.SOX.Medium.label',
        defaultMessage: 'Medium SOX Criticality',
      },
    },
    'TM.SOX.Low.label': {
      ATTESTATIONS: {
        id: 'TM.SOX.Low.label',
        defaultMessage: 'Low SOX Criticality',
      },
    },
    'TM.SOX.VeryLow.label': {
      ATTESTATIONS: {
        id: 'TM.SOX.VeryLow.label',
        defaultMessage: 'Very Low SOX Criticality',
      },
    },
    'TM.SOD.NoEntitlement.label': {
      ATTESTATIONS: {
        id: 'TM.SOD.NoEntitlement.label',
        defaultMessage: 'No SOD found for this Entitlement',
      },
    },
    'TM.SOD.MitigatedLowRisk.label': {
      ATTESTATIONS: {
        id: 'TM.SOD.MitigatedLowRisk.label',
        defaultMessage: 'Mitigated Low SOD Risk',
      },
    },
    'TM.SOX.MitigatedMediumRisk.label': {
      ATTESTATIONS: {
        id: 'TM.SOX.MitigatedMediumRisk.label',
        defaultMessage: 'Mitigated Medium SOX Risk',
      },
    },
    'TM.SOD.MitigatedHighRisk.label': {
      ATTESTATIONS: {
        id: 'TM.SOD.MitigatedHighRisk.label',
        defaultMessage: 'Mitigated High SOD Risk',
      },
    },
    'TM.SOD.MitigatedCriticalRisk.label': {
      ATTESTATIONS: {
        id: 'TM.SOD.MitigatedCriticalRisk.label',
        defaultMessage: 'Mitigated Critical SOD Risk',
      },
    },
    'TM.SOX.OpenLowRisk.label': {
      ATTESTATIONS: {
        id: 'TM.SOX.OpenLowRisk.label',
        defaultMessage: 'Open Low SOX Risk',
      },
    },
    'TM.SOX.OpenMediumRisk.label': {
      ATTESTATIONS: {
        id: 'TM.SOX.OpenMediumRisk.label',
        defaultMessage: 'Open Medium SOX Risk',
      },
    },
    'TM.SOX.OpenHighRisk.label': {
      ATTESTATIONS: {
        id: 'TM.SOX.OpenHighRisk.label',
        defaultMessage: 'Open High SOX Risk',
      },
    },
    'TM.SOX.OpenCriticalRisk.label': {
      ATTESTATIONS: {
        id: 'TM.SOX.OpenCriticalRisk.label',
        defaultMessage: 'Open Critical SOX Risk',
      },
    },
    'TM.SOD.DataNotAvailable.label': {
      ATTESTATIONS: {
        id: 'TM.SOD.DataNotAvailable.label',
        defaultMessage: 'Data not available for SOD Risk',
      },
    },
    'TM.RUA.BeyondEndDate.beyond.label': {
      ATTESTATIONS: {
        id: 'TM.RUA.BeyondEndDate.beyond.label',
        defaultMessage: 'Role Access available beyond Enddate',
      },
    },
    'TM.RUA.BeyondEndDate.within.label': {
      ATTESTATIONS: {
        id: 'TM.RUA.BeyondEndDate.within.label',
        defaultMessage: 'Role Access available within Enddate',
      },
    },
    'TM.RUA.RAC.minscore.label': {
      ATTESTATIONS: {
        id: 'TM.RUA.RAC.minscore.label',
        defaultMessage: 'Role Access Composition score is {0}',
      },
    },
    'TM.RUA.RAC.nodata.label': {
      ATTESTATIONS: {
        id: 'TM.RUA.RAC.nodata.label',
        defaultMessage: 'Role Access Composition score is not available',
      },
    },
    'syscritical.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'syscritical.ATTESTATIONS',
        defaultMessage: 'Syscritical',
      },
    },
    'entitlement_valuekey.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'entitlement_valuekey.ATTESTATIONS',
        defaultMessage: 'Entitlement Value Key',
      },
    },
    'endpointKey.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'endpointKey.ATTESTATIONS',
        defaultMessage: 'Endpoint Key',
      },
    },
    'createdate.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'createdate.ATTESTATIONS',
        defaultMessage: 'Create Date',
      },
    },
    'entitlementOwner.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'entitlementOwner.ATTESTATIONS',
        defaultMessage: 'Entitlement Owner',
      },
    },
    'entitlementTypeName.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'entitlementTypeName.ATTESTATIONS',
        defaultMessage: 'Entitlement Type Name',
      },
    },
    'entitlementType.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'entitlementType.ATTESTATIONS',
        defaultMessage: 'Entitlement Type',
      },
    },
    'entitlementTypeKey.ATTESTATION': {
      ATTESTATIONS: {
        id: 'entitlement_glossary.ATTESTATIONS',
        defaultMessage: 'Entitlement Type Key',
      },
    },
    'endpoint.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'endpoint.ATTESTATIONS',
        defaultMessage: 'Endpoint',
      },
    },
    'updatedate.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'updatedate.ATTESTATIONS',
        defaultMessage: 'Update Date',
      },
    },
    'requestForm.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'requestForm.ATTESTATIONS',
        defaultMessage: 'Request Form',
      },
    },
    'displayname.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'displayname.ATTESTATIONS',
        defaultMessage: 'Display Name',
      },
    },
    'soxcritical.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'soxcritical.ATTESTATIONS',
        defaultMessage: 'Sox Critical',
      },
    },
    'entitlement_value.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'entitlement_value.ATTESTATIONS',
        defaultMessage: 'Entitlement Value',
      },
    },
    'status.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'status.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    'V2.ARS.Review.Requests.Request.assignee.label': {
      ATTESTATIONS: {
        id: 'V2.ARS.Review.Requests.Request.assignee.label',
        defaultMessage: 'Assigned to',
      },
    },
    'V2.ARS.Request.Review.Approved.By.label': {
      ATTESTATIONS: {
        id: 'V2.ARS.Request.Review.Approved.By.label',
        defaultMessage: 'Approved to',
      },
    },
    'NewAccountRequest.Default.label': {
      ATTESTATIONS: {
        id: 'NewAccountRequest.Default.label',
        defaultMessage: 'New Account',
      },
    },
    'AddAccessRequest.Default.label': {
      ATTESTATIONS: {
        id: 'AddAccessRequest.Default.label',
        defaultMessage: 'Add Access',
      },
    },
    'completedV2.Default.label': {
      ATTESTATIONS: {
        id: 'completedV2.Default.label',
        defaultMessage: 'Complete',
      },
    },
    'V2.ARS.Request.Task.History.GroupApprovals.Default.Label': {
      ATTESTATIONS: {
        id: 'V2.ARS.Request.Task.History.GroupApprovals.Default.Label',
        defaultMessage: 'Group Approvals',
      },
    },
    'Usergroup.label': {
      ATTESTATIONS: {
        id: 'Usergroup.label',
        defaultMessage: 'User Group',
      },
    },
    AutoApprove: {
      ATTESTATIONS: {
        id: 'AutoApprove',
        defaultMessage: 'AutoApprove',
      },
    },
    MangerApprove: {
      ATTESTATIONS: {
        id: 'MangerApprove',
        defaultMessage: 'ManagerApprove',
      },
    },
    ManagerApprove: {
      ATTESTATIONS: {
        id: 'ManagerApprove',
        defaultMessage: 'ManagerApprove',
      },
    },
    manager: {
      ATTESTATIONS: {
        id: 'manager',
        defaultMessage: 'manager',
      },
    },
    'RequestId.Default.label': {
      ATTESTATIONS: {
        id: 'RequestId.Default.label',
        defaultMessage: 'Request ID',
      },
    },
    'Requested.Default.label': {
      ATTESTATIONS: {
        id: 'Requested.Default.label',
        defaultMessage: 'Requested',
      },
    },
    'MultipleApprovals.Default.label': {
      ATTESTATIONS: {
        id: 'MultipleApprovals.Default.label',
        defaultMessage: 'Multiple Approvals',
      },
    },
    'REQUEST.ACCESS.STATUS.APPROVED': {
      ATTESTATIONS: {
        id: 'REQUEST.ACCESS.STATUS.APPROVED',
        defaultMessage: 'Approved',
      },
    },
    'V2.Application.label': {
      ATTESTATIONS: {
        id: 'V2.Application.label',
        defaultMessage: 'Application',
      },
    },
    'Search.Label.Application': {
      ATTESTATIONS: {
        id: 'Search.Label.Application',
        defaultMessage: 'Application',
      },
    },
    'RequestType.Default.label': {
      ATTESTATIONS: {
        id: 'RequestType.Default.label',
        defaultMessage: 'Request Type',
      },
    },
    'SystemName.Default.label': {
      ATTESTATIONS: {
        id: 'RequestType.Default.label',
        defaultMessage: 'System Name',
      },
    },
    'Role.Default.label': {
      ATTESTATIONS: {
        id: 'Role.Default.label',
        defaultMessage: 'Role',
      },
    },
    'Entitlement.Default.label': {
      ATTESTATIONS: {
        id: 'Entitlement.Default.label',
        defaultMessage: 'Entitlement',
      },
    },
    'AccountName.Default.label': {
      ATTESTATIONS: {
        id: 'AccountName.Default.label',
        defaultMessage: 'Account Name',
      },
    },
    'RequestedBy.Default.label': {
      ATTESTATIONS: {
        id: 'RequestedBy.Default.label',
        defaultMessage: 'Requested By',
      },
    },
    'RequestedFor.Default.label': {
      ATTESTATIONS: {
        id: 'RequestedFor.Default.label',
        defaultMessage: 'Requested For',
      },
    },
    'V2.ARS.Request.Review.Justification.Title': {
      ATTESTATIONS: {
        id: 'V2.ARS.Request.Review.Justification.Title',
        defaultMessage: 'Justification',
      },
    },
    'V2.ARS.Request.Task.History.Time.Label': {
      ATTESTATIONS: {
        id: 'V2.ARS.Request.Task.History.Time.Label',
        defaultMessage: 'Time',
      },
    },
    'V2.ReviewMethod.Label': {
      ATTESTATIONS: {
        id: 'V2.ReviewMethod.Label',
        defaultMessage: 'Review Method',
      },
    },
    'TaskId.Default.label': {
      ATTESTATIONS: {
        id: 'TaskId.Default.label',
        defaultMessage: 'Task ID',
      },
    },
    'parenttaskid.Default.label': {
      ATTESTATIONS: {
        id: 'parenttaskid.Default.label',
        defaultMessage: 'Parent Task ID',
      },
    },
    'V2.ARS.Request.Review.Assigned.To.Label': {
      ATTESTATIONS: {
        id: 'V2.ARS.Request.Review.Assigned.To.Label',
        defaultMessage: 'Assigned to',
      },
    },
    'Tasktype.Default.label': {
      ATTESTATIONS: {
        id: 'TaskId.Default',
        defaultMessage: 'Task Type',
      },
    },
    DEFAULT: {
      ATTESTATIONS: {
        id: 'DEFAULT.ATTESTATIONS',
        defaultMessage: 'Custom Property',
      },
    },
    // Custom keys addition ends here...
    COULD_NOT_LOAD: {
      ATTESTATIONS: {
        id: 'COULD_NOT_LOAD',
        defaultMessage: "Couldn't Load",
      },
    },
    Refresh: {
      ATTESTATIONS: {
        id: 'Refresh',
        defaultMessage: 'Refresh',
      },
    },
    'Refresh.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Refresh.ATTESTATIONS',
        defaultMessage: 'Refresh',
      },
    },
    CloseLabel: {
      ATTESTATIONS: {
        id: 'CloseLabel',
        defaultMessage: 'Close',
      },
    },
    'Failed.HISTORY': {
      ATTESTATIONS: {
        id: 'FAILED.HISTORY',
        defaultMessage:
          "The History didn't load properly due to a network issue. Please refresh or try again later.",
      },
    },
    'ARS.TITLE': {
      ATTESTATIONS: {
        id: 'ARS.TITLE',
        defaultMessage: 'Access Request History',
      },
    },
    'ARS.button.label': {
      ATTESTATIONS: {
        id: 'ARS.button.label',
        defaultMessage: 'Access Request',
      },
    },
    'ARS.redirectLink.label': {
      ATTESTATIONS: {
        id: 'ARS.redirectLink.label',
        defaultMessage: 'View Request History',
      },
    },
    'SIDEPANEL.breadCrumb.drawer.title': {
      ATTESTATIONS: {
        id: 'SIDEPANEL.breadCrumb.drawer.title',
        defaultMessage: 'Relational Hierarchy',
      },
    },
    CancelLabel: {
      ATTESTATIONS: {
        id: 'CancelLabel',
        defaultMessage: 'Cancel',
      },
    },
    'Approve.all': {
      ATTESTATIONS: {
        id: 'Approve.all',
        defaultMessage: 'Approve All',
      },
    },
    Terminate: {
      ATTESTATIONS: {
        id: 'Terminate',
        defaultMessage: 'Terminate',
      },
    },
    'Reject.all': {
      ATTESTATIONS: {
        id: 'Reject.all',
        defaultMessage: 'Reject All',
      },
    },
    'Required.field': {
      ATTESTATIONS: {
        id: 'Required.field',
        defaultMessage: 'This required field is incomplete',
      },
    },
    'BULKACTION.confirm.message': {
      ATTESTATIONS: {
        id: 'BULKACTION.confirm.message',
        defaultMessage: 'I confirm I have reviewed all items',
      },
    },
    'BULKACTION.common.reject.INLINE_MESSAGE': {
      ATTESTATIONS: {
        id: 'BULKACTION.common.reject.INLINE_MESSAGE',
        defaultMessage:
          'Users associated with these access items will automatically be approved.',
      },
    },
    'BULKACTION.common.reject.INLINE_MESSAGE_EO': {
      ATTESTATIONS: {
        id: 'BULKACTION.common.reject.INLINE_MESSAGE_EO',
        defaultMessage:
          'Entitlements associated with these access items will automatically be approved.',
      },
    },
    SubmitLabel: {
      ATTESTATIONS: {
        id: 'SubmitLabel',
        defaultMessage: 'Submit',
      },
    },
    'Failed.MODAL': {
      ATTESTATIONS: {
        id: 'Failed.MODAL',
        defaultMessage:
          "The Modal didn't load properly due to a network issue. Please refresh or try again later.",
      },
    },
    'BULKACTION.consult.title': {
      ATTESTATIONS: {
        id: 'BULKACTION.consult.title',
        defaultMessage: 'Consult with Peers',
      },
    },
    'BULKACTION.consult.subTitle': {
      ATTESTATIONS: {
        id: 'BULKACTION.consult.subTitle',
        defaultMessage:
          'Invite another user in your organization to review your certification items and advise on appropriate actions.',
      },
    },
    'BULKACTION.consult.with': {
      ATTESTATIONS: {
        id: 'BULKACTION.consult.with',
        defaultMessage: 'I want to consult with',
      },
    },
    'BULKACTION.choose.assignee': {
      ATTESTATIONS: {
        id: 'BULKACTION.choose.assignee',
        defaultMessage: 'Select a known or default reassignee',
      },
    },
    'Required.fields.missing': {
      ATTESTATIONS: {
        id: 'Required.fields.missing',
        defaultMessage: 'Required fields are missing.',
      },
    },
    'SaveLabel.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'SaveLabel.ATTESTATIONS',
        defaultMessage: 'Save',
      },
    },
    'BULKACTION.action.failed': {
      ATTESTATIONS: {
        id: 'BULKACTION.action.failed',
        defaultMessage: 'Not able to perform this action.',
      },
    },

    PARENTMENU: {
      ATTESTATIONS: {
        id: 'PARENTMENU.ATTESTATIONS',
        defaultMessage: 'Attestations',
      },
    },
    SUBMENU: {
      ATTESTATIONS: {
        id: 'SUBMENU.ATTESTATIONS.attestations_create',
        defaultMessage: 'Create New attestation',
      },
    },
    SAVLEVEL: {
      ATTESTATIONS: {
        id: 'SAVLEVEL.ATTESTATIONS',
        defaultMessage: 'SAV Level',
      },
    },
    PRIVILEGED: {
      ATTESTATIONS: {
        id: 'PRIVILEGED.ATTESTATIONS',
        defaultMessage: 'Privileged',
      },
    },
    parentmenu: {
      ATTESTATIONS: {
        id: 'parentmenu.ATTESTATION',
        defaultMessage: 'Attestations',
      },
    },
    Childent_CERT_ENTITLEMENT_VALUEKEY: {
      ATTESTATIONS: {
        id: 'Childent_CERT_ENTITLEMENT_VALUEKEY.ATTESTATIONS',
        defaultMessage: 'Certification Entitlement Value Key',
      },
    },
    Childent_ENTITLEMENT_VALUEKEY: {
      ATTESTATIONS: {
        id: 'Childent_ENTITLEMENT_VALUEKEY.ATTESTATIONS',
        defaultMessage: 'Entitlement Value Key',
      },
    },
    Childent_ENTITLEMENT_VALUE: {
      ATTESTATIONS: {
        id: 'Childent_ENTITLEMENT_VALUE.ATTESTATIONS',
        defaultMessage: 'Entitlement Value',
      },
    },
    Childent_ENTITLEMENTTYPEKEY: {
      ATTESTATIONS: {
        id: 'Childent_ENTITLEMENTTYPEKEY.ATTESTATIONS',
        defaultMessage: 'Entitlement Type Key',
      },
    },
    Childent_CUSTOMPROPERTY1: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY1.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 1',
      },
    },
    Childent_CUSTOMPROPERTY2: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY2.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 2',
      },
    },
    Childent_CUSTOMPROPERTY3: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY3.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 3',
      },
    },
    Childent_CUSTOMPROPERTY4: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY4.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 4',
      },
    },
    Childent_CUSTOMPROPERTY5: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY5.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 5',
      },
    },
    Childent_CUSTOMPROPERTY6: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY6.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 6',
      },
    },
    Childent_CUSTOMPROPERTY7: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY7.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 7',
      },
    },
    Childent_CUSTOMPROPERTY8: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY8.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 8',
      },
    },
    Childent_CUSTOMPROPERTY9: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY9.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 9',
      },
    },
    Childent_CUSTOMPROPERTY10: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY10.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 10',
      },
    },
    Childent_CUSTOMPROPERTY11: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY11.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 11',
      },
    },
    Childent_CUSTOMPROPERTY12: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY12.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 12',
      },
    },
    Childent_CUSTOMPROPERTY13: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY13.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 13',
      },
    },
    Childent_CUSTOMPROPERTY14: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY14.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 14',
      },
    },
    Childent_CUSTOMPROPERTY15: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY15.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 15',
      },
    },
    Childent_CUSTOMPROPERTY16: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY16.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 16',
      },
    },
    Childent_CUSTOMPROPERTY17: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY17.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 17',
      },
    },
    Childent_CUSTOMPROPERTY18: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY18.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 18',
      },
    },
    Childent_CUSTOMPROPERTY19: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY19.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 19',
      },
    },
    Childent_CUSTOMPROPERTY20: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY20.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 20',
      },
    },
    Childent_CUSTOMPROPERTY21: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY21.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 21',
      },
    },
    Childent_CUSTOMPROPERTY22: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY22.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 22',
      },
    },
    Childent_CUSTOMPROPERTY23: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY23.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 23',
      },
    },
    Childent_CUSTOMPROPERTY24: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY24.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 24',
      },
    },
    Childent_CUSTOMPROPERTY25: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY25.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 25',
      },
    },
    Childent_CUSTOMPROPERTY26: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY26.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 26',
      },
    },
    Childent_CUSTOMPROPERTY27: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY27.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 27',
      },
    },
    Childent_CUSTOMPROPERTY28: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY28.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 28',
      },
    },
    Childent_CUSTOMPROPERTY29: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY29.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 29',
      },
    },
    Childent_CUSTOMPROPERTY30: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY30.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 30',
      },
    },
    Childent_CUSTOMPROPERTY31: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY31.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 31',
      },
    },
    Childent_CUSTOMPROPERTY32: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY32.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 32',
      },
    },
    Childent_CUSTOMPROPERTY33: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY33.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 33',
      },
    },
    Childent_CUSTOMPROPERTY34: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY34.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 34',
      },
    },
    Childent_CUSTOMPROPERTY35: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY35.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 35',
      },
    },
    Childent_CUSTOMPROPERTY36: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY36.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 36',
      },
    },
    Childent_CUSTOMPROPERTY37: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY37.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 37',
      },
    },
    Childent_CUSTOMPROPERTY38: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY38.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 38',
      },
    },
    Childent_CUSTOMPROPERTY39: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY39.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 39',
      },
    },
    Childent_CUSTOMPROPERTY40: {
      ATTESTATIONS: {
        id: 'Childent_CUSTOMPROPERTY40.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 40',
      },
    },
    Childent_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'Childent_DESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Entitlement Description',
      },
    },
    Childent_GLOSSARY: {
      ATTESTATIONS: {
        id: 'Childent_GLOSSARY.ATTESTATIONS',
        defaultMessage: 'Entitlement Glossary',
      },
    },
    Childent_ENTITLEMENT_GLOSSARY: {
      ATTESTATIONS: {
        id: 'Childent_ENTITLEMENT_GLOSSARY.ATTESTATIONS',
        defaultMessage: 'Entitlement Glossary',
      },
    },
    Childent_STATUS: {
      ATTESTATIONS: {
        id: 'Childent_STATUS.ATTESTATIONS',
        defaultMessage: 'Entitlement Status',
      },
    },
    Childent_UPDATEUSER: {
      ATTESTATIONS: {
        id: 'Childent_UPDATEUSER.ATTESTATIONS',
        defaultMessage: 'Entitlement Update User',
      },
    },
    Childent_RISK: {
      ATTESTATIONS: {
        id: 'Childent_RISK.ATTESTATIONS',
        defaultMessage: 'Entitlement Risk',
      },
    },
    Childent_SOXCRITICAL: {
      ATTESTATIONS: {
        id: 'Childent_SOXCRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement SOX Critical',
      },
    },
    Childent_SYSCRITICAL: {
      ATTESTATIONS: {
        id: 'Childent_SYSCRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement Sys Critical',
      },
    },
    Childent_ORPHAN: {
      ATTESTATIONS: {
        id: 'Childent_ORPHAN.ATTESTATIONS',
        defaultMessage: 'Entitlement Orphan',
      },
    },
    Childent_UPDATEDATE: {
      ATTESTATIONS: {
        id: 'Childent_UPDATEDATE.ATTESTATIONS',
        defaultMessage: 'Entitlement Update Date',
      },
    },
    Childent_SAVLEVEL: {
      ATTESTATIONS: {
        id: 'Childent_SAVLEVEL.ATTESTATIONS',
        defaultMessage: 'Entitlement SAV Level',
      },
    },
    Childent_PRIVILIGED: {
      ATTESTATIONS: {
        id: 'Childent_PRIVILIGED.ATTESTATIONS',
        defaultMessage: 'Entitlement Privileged',
      },
    },
    Childent_CONFIDENTIALITY: {
      ATTESTATIONS: {
        id: 'Childent_CONFIDENTIALITY.ATTESTATIONS',
        defaultMessage: 'Entitlement Confidentiality',
      },
    },
    Childent_SOD: {
      ATTESTATIONS: {
        id: 'Childent_SOD.ATTESTATIONS',
        defaultMessage: 'Entitlement SOD',
      },
    },
    Childent_DISPLAYNAME: {
      ATTESTATIONS: {
        id: 'Childent_DISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'Entitlement Display Name',
      },
    },
    Childent_ENTITLEMENTID: {
      ATTESTATIONS: {
        id: 'Childent_ENTITLEMENTID.ATTESTATIONS',
        defaultMessage: 'Entitlement ID',
      },
    },
    Childent_PROGRAM: {
      ATTESTATIONS: {
        id: 'Childent_PROGRAM.ATTESTATIONS',
        defaultMessage: 'Entitlement Program',
      },
    },
    Childent_MODULE: {
      ATTESTATIONS: {
        id: 'Childent_MODULE.ATTESTATIONS',
        defaultMessage: 'Entitlement Module',
      },
    },
    Childent_ACCESS: {
      ATTESTATIONS: {
        id: 'Childent_ACCESS.ATTESTATIONS',
        defaultMessage: 'Entitlement Access',
      },
    },
    Childent_SCHEMANAME: {
      ATTESTATIONS: {
        id: 'Childent_SCHEMANAME.ATTESTATIONS',
        defaultMessage: 'Entitlement Schema Name',
      },
    },
    Childent_ENTCLASS: {
      ATTESTATIONS: {
        id: 'Childent_ENTCLASS.ATTESTATIONS',
        defaultMessage: 'Entitlement Classification',
      },
    },
    Childent_LASTSCANDATE: {
      ATTESTATIONS: {
        id: 'Childent_LASTSCANDATE.ATTESTATIONS',
        defaultMessage: 'Entitlement Last Scan Date',
      },
    },
    Childent_ENTITLEMGLOSSARY: {
      ATTESTATIONS: {
        id: 'Childent_ENTITLEMGLOSSARY.ATTESTATIONS',
        defaultMessage: 'Entitlement Glossary',
      },
    },
    Childent_JOBID: {
      ATTESTATIONS: {
        id: 'Childent_JOBID.ATTESTATIONS',
        defaultMessage: 'Entitlement Job ID',
      },
    },
    Childent_LASTUSEDENDDATE: {
      ATTESTATIONS: {
        id: 'Childent_LASTUSEDENDDATE.ATTESTATIONS',
        defaultMessage: 'Entitlement Last Used End Date',
      },
    },
    DASHBOARD: {
      ATTESTATIONS: {
        id: 'DASHBOARD.ATTESTATION',
        defaultMessage: 'Dashboard',
      },
    },
    ACCESSTHROUGH: {
      ATTESTATIONS: {
        id: 'ACCESSTHROUGH.ATTESTATIONS',
        defaultMessage: 'Granted Through',
      },
    },
    ENDPOINT: {
      ATTESTATIONS: {
        id: 'ENDPOINT.ATTESTATIONS',
        defaultMessage: 'Endpoint Name',
      },
    },
    LASTUSEDDATE: {
      ATTESTATIONS: {
        id: 'LASTUSEDDATE.ATTESTATIONS',
        defaultMessage: 'Last Used Date',
      },
    },
    Ent2_LASTUSEDDATE: {
      ATTESTATIONS: {
        id: 'Ent2_LASTUSEDDATE.ATTESTATIONS',
        defaultMessage: 'Last Used Date',
      },
    },
    USERNAME: {
      ATTESTATIONS: {
        id: 'USERNAME.ATTESTATIONS',
        defaultMessage: 'User ID',
      },
    },
    ENTITLEMENT_VALUE: {
      ATTESTATIONS: {
        id: 'ENTITLEMENT_VALUE.ATTESTATIONS',
        defaultMessage: 'Entitlement Value',
      },
    },
    ENTITLEMENTID: {
      ATTESTATIONS: {
        id: 'ENTITLEMENTID.ATTESTATIONS',
        defaultMessage: 'Entitlement ID',
      },
    },
    ENTITLEMENT_GLOSSARY: {
      ATTESTATIONS: {
        id: 'ENTITLEMENT_GLOSSARY.ATTESTATIONS',
        defaultMessage: 'Entitlement Glossary',
      },
    },
    JOB_ID: {
      ATTESTATIONS: {
        id: 'JOB_ID.ATTESTATIONS',
        defaultMessage: 'Entitlement Job ID',
      },
    },
    LASTREVIEWEDCAMPAIGNNAME: {
      ATTESTATIONS: {
        id: 'LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS',
        defaultMessage: 'Last Reviewed Campaign',
      },
    },
    LASTSCANDATE: {
      ATTESTATIONS: {
        id: 'LASTSCANDATE.ATTESTATIONS',
        defaultMessage: 'Entitlement Last Scan Date',
      },
    },
    ORPHAN: {
      ATTESTATIONS: {
        id: 'ORPHAN.ATTESTATIONS',
        defaultMessage: 'Entitlement Orphan',
      },
    },
    SOX_CRITICAL: {
      ATTESTATIONS: {
        id: 'SOX_CRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement SOX Critical',
      },
    },
    SYS_CRITICAL: {
      ATTESTATIONS: {
        id: 'SYS_CRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement Sys Critical',
      },
    },
    ACCOUNTNAME: {
      ATTESTATIONS: {
        id: 'ACCOUNTNAME.ATTESTATIONS',
        defaultMessage: 'Account Name',
      },
    },
    STATUS: {
      ATTESTATIONS: {
        id: 'STATUS.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    SYSTEMNAME: {
      ATTESTATIONS: {
        id: 'SYSTEMNAME.ATTESTATIONS',
        defaultMessage: 'System Name',
      },
    },
    'comments.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'comments.ATTESTATIONS',
        defaultMessage: 'Comments',
      },
    },
    HISTORY: {
      ATTESTATIONS: {
        id: 'HISTORY.ATTESTATIONS',
        defaultMessage: 'History',
      },
    },
    JRMRULES: {
      ATTESTATIONS: {
        id: 'JRMRULES.ATTESTATIONS.MESSAGE',
        defaultMessage: 'Outlier Analysis',
      },
    },
    NO_OPINION: {
      ATTESTATIONS: {
        id: 'JRMRULES.ATTESTATIONS.NO_OPINION',
        defaultMessage: 'No Opinion',
      },
    },
    JRMNORULES: {
      ATTESTATIONS: {
        id: 'JRMNORULES.ATTESTATIONS.MESSAGE',
        defaultMessage:
          'Less than 20% of users in the peer group have access to this data',
      },
    },
    LASTUSEDENDDATE: {
      ATTESTATIONS: {
        id: 'LASTUSEDENDDATE.ATTESTATIONS',
        defaultMessage: 'Last used',
      },
    },
    RISKS: {
      ATTESTATIONS: {
        id: 'RISKS.ATTESTATIONS',
        defaultMessage: 'SOD Risks',
      },
    },
    CERTIFICATION: {
      ATTESTATIONS: {
        id: 'CERTIFICATION.ATTESTATIONS',
        defaultMessage: 'Certification',
      },
    },
    CERTIFIER: {
      ATTESTATIONS: {
        id: 'CERTIFIER.ATTESTATIONS',
        defaultMessage: 'Certifier',
      },
    },
    Assign: {
      ATTESTATIONS: {
        id: 'Assign.ATTESTATIONS.label',
        defaultMessage: 'Consult',
      },
    },
    UPDATEDATE: {
      ATTESTATIONS: {
        id: 'UPDATEDATE.ATTESTATIONS',
        defaultMessage: 'Last Certified',
      },
    },
    'SELECTALL.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'SELECTALL.ATTESTATIONS',
        defaultMessage: 'Select All',
      },
    },
    ACTION: {
      ATTESTATIONS: {
        id: 'ACTION.ATTESTATIONS',
        defaultMessage: 'Action',
      },
    },
    JRMRULESAVAILABLE: {
      ATTESTATIONS: {
        id: 'JRMRULESAVAILABLE.ATTESTATIONS',
        defaultMessage: 'Outlier Analysis',
      },
    },
    RISKSAVAILABLE: {
      ATTESTATIONS: {
        id: 'RISKSAVAILABLE.ATTESTATIONS',
        defaultMessage: 'SOD Risks',
      },
    },
    LASTCERTIFIEDCAMPAIGNNAME: {
      ATTESTATIONS: {
        id: 'LASTCERTIFIEDCAMPAIGNNAME.ATTESTATIONS',
        defaultMessage: 'Last Certified Campaign',
      },
    },
    LASTCERTIFIED: {
      ATTESTATIONS: {
        id: 'LASTCERTIFIED.ATTESTATIONS',
        defaultMessage: 'Last Certified Date',
      },
    },
    AUDIT_TRAIL: {
      ATTESTATIONS: {
        id: 'AUDIT_TRAIL.ATTESTATIONS',
        defaultMessage: 'History',
      },
    },
    CRITICALITY: {
      ATTESTATIONS: {
        id: 'CRITICALITY.ATTESTATIONS',
        defaultMessage: 'Entitlement Criticality',
      },
    },
    CERTIFIED_Action: {
      ATTESTATIONS: {
        id: 'CERTIFIED_Action',
        defaultMessage: 'Action Filters',
      },
    },
    CERTIFIED: {
      ATTESTATIONS: {
        id: 'CERTIFIED.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    REASSIGNED: {
      ATTESTATIONS: {
        id: 'REASSIGNED.ATTESTATIONS',
        defaultMessage: 'Consulted',
      },
    },
    ENTITLEMENTTYPE: {
      ATTESTATIONS: {
        id: 'ENTITLEMENTTYPE.ATTESTATIONS',
        defaultMessage: 'Entitlement Type',
      },
    },
    Account_CERT_ACCOUNTKEY: {
      ATTESTATIONS: {
        id: 'Account_CERT_ACCOUNTKEY.ATTESTATIONS',
        defaultMessage: 'Account Certification Account Key',
      },
    },
    Account_ACCOUNTKEY: {
      ATTESTATIONS: {
        id: 'Account_ACCOUNTKEY.ATTESTATIONS',
        defaultMessage: 'Account Key',
      },
    },
    Account_NAME: {
      ATTESTATIONS: {
        id: 'Account_NAME.ATTESTATIONS',
        defaultMessage: 'Account Name',
      },
    },
    Account_REFERENCED_ACCOUNTKEY: {
      ATTESTATIONS: {
        id: 'Account_REFERENCED_ACCOUNTKEY.ATTESTATIONS',
        defaultMessage: 'Referenced Account',
      },
    },
    Account_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'Account_DESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Account Description',
      },
    },
    Account_COMMENTS: {
      ATTESTATIONS: {
        id: 'Account_COMMENTS.ATTESTATIONS',
        defaultMessage: 'Account Comments',
      },
    },
    Account_ACCOUNTTYPE: {
      ATTESTATIONS: {
        id: 'Account_ACCOUNTTYPE.ATTESTATIONS',
        defaultMessage: 'Account Type',
      },
    },
    Account_STATUS: {
      ATTESTATIONS: {
        id: 'Account_STATUS.ATTESTATIONS',
        defaultMessage: 'Account Status',
      },
    },
    Account_VALIDFROM: {
      ATTESTATIONS: {
        id: 'Account_VALIDFROM.ATTESTATIONS',
        defaultMessage: 'Account Valid From',
      },
    },
    Account_VALIDTHROUGH: {
      ATTESTATIONS: {
        id: 'Account_VALIDTHROUGH.ATTESTATIONS',
        defaultMessage: 'Account Valid Through',
      },
    },
    Account_USERLOCK: {
      ATTESTATIONS: {
        id: 'Account_USERLOCK.ATTESTATIONS',
        defaultMessage: 'Account User Lock',
      },
    },
    Account_CREATOR: {
      ATTESTATIONS: {
        id: 'Account_CREATOR.ATTESTATIONS',
        defaultMessage: 'Account Created By',
      },
    },
    Account_CREATED_ON: {
      ATTESTATIONS: {
        id: 'Account_CREATED_ON.ATTESTATIONS',
        defaultMessage: 'Account Created On',
      },
    },
    Account_LASTLOGONDATE: {
      ATTESTATIONS: {
        id: 'Account_LASTLOGONDATE.ATTESTATIONS',
        defaultMessage: 'Account Last Login Date',
      },
    },
    Account_ORPHAN: {
      ATTESTATIONS: {
        id: 'Account_ORPHAN.ATTESTATIONS',
        defaultMessage: 'Account Orphan',
      },
    },
    Account_JOBID: {
      ATTESTATIONS: {
        id: 'Account_JOBID.ATTESTATIONS',
        defaultMessage: 'Account Job ID',
      },
    },
    Account_PRIVILEGED: {
      ATTESTATIONS: {
        id: 'Account_PRIVILEGED.ATTESTATIONS',
        defaultMessage: 'Account Privileged',
      },
    },
    Account_ENDPOINTKEY: {
      ATTESTATIONS: {
        id: 'Account_ENDPOINTKEY.ATTESTATIONS',
        defaultMessage: 'Account Endpoint',
      },
    },
    Account_SYSTEMID: {
      ATTESTATIONS: {
        id: 'Account_SYSTEMID.ATTESTATIONS',
        defaultMessage: 'Account System',
      },
    },
    Account_INCORRECTLOGONS: {
      ATTESTATIONS: {
        id: 'Account_INCORRECTLOGONS.ATTESTATIONS',
        defaultMessage: 'Account Incorrect Logins',
      },
    },
    Account_LASTPASSWORDCHANGE: {
      ATTESTATIONS: {
        id: 'Account_LASTPASSWORDCHANGE.ATTESTATIONS',
        defaultMessage: 'Account Last Password Change',
      },
    },
    Account_PASSWORDLOCKDATE: {
      ATTESTATIONS: {
        id: 'Account_PASSWORDLOCKDATE.ATTESTATIONS',
        defaultMessage: 'Account Password Locked Date',
      },
    },
    Account_PASSWORDCHANGESTATUS: {
      ATTESTATIONS: {
        id: 'Account_PASSWORDCHANGESTATUS.ATTESTATIONS',
        defaultMessage: 'Account Password Change Status',
      },
    },
    Account_CUSTOMPROPERTY1: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY1.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 1',
      },
    },
    Account_CUSTOMPROPERTY2: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY2.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 2',
      },
    },
    Account_CUSTOMPROPERTY3: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY3.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 3',
      },
    },
    Account_CUSTOMPROPERTY4: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY4.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 4',
      },
    },
    Account_CUSTOMPROPERTY5: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY5.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 5',
      },
    },
    Account_CUSTOMPROPERTY6: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY6.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 6',
      },
    },
    Account_CUSTOMPROPERTY7: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY7.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 7',
      },
    },
    Account_CUSTOMPROPERTY8: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY8.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 8',
      },
    },
    Account_CUSTOMPROPERTY9: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY9.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 9',
      },
    },
    Account_CUSTOMPROPERTY10: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY10.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 10',
      },
    },
    Account_CUSTOMPROPERTY11: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY11.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 11',
      },
    },
    Account_CUSTOMPROPERTY12: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY12.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 12',
      },
    },
    Account_CUSTOMPROPERTY13: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY13.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 13',
      },
    },
    Account_CUSTOMPROPERTY14: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY14.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 14',
      },
    },
    Account_CUSTOMPROPERTY15: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY15.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 15',
      },
    },
    Account_CUSTOMPROPERTY16: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY16.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 16',
      },
    },
    Account_CUSTOMPROPERTY17: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY17.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 17',
      },
    },
    Account_CUSTOMPROPERTY18: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY18.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 18',
      },
    },
    Account_CUSTOMPROPERTY19: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY19.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 19',
      },
    },
    Account_CUSTOMPROPERTY20: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY20.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 20',
      },
    },
    Account_CUSTOMPROPERTY21: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY21.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 21',
      },
    },
    Account_CUSTOMPROPERTY22: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY22.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 22',
      },
    },
    Account_CUSTOMPROPERTY23: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY23.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 23',
      },
    },
    Account_CUSTOMPROPERTY24: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY24.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 24',
      },
    },
    Account_CUSTOMPROPERTY25: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY25.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 25',
      },
    },
    Account_CUSTOMPROPERTY26: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY26.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 26',
      },
    },
    Account_CUSTOMPROPERTY27: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY27.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 27',
      },
    },
    Account_CUSTOMPROPERTY28: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY28.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 28',
      },
    },
    Account_CUSTOMPROPERTY29: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY29.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 29',
      },
    },
    Account_CUSTOMPROPERTY30: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY30.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 30',
      },
    },
    Account_CUSTOMPROPERTY31: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY31.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 31',
      },
    },
    Account_CUSTOMPROPERTY32: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY32.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 32',
      },
    },
    Account_CUSTOMPROPERTY33: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY33.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 33',
      },
    },
    Account_CUSTOMPROPERTY34: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY34.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 34',
      },
    },
    Account_CUSTOMPROPERTY35: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY35.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 35',
      },
    },
    Account_CUSTOMPROPERTY36: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY36.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 36',
      },
    },
    Account_CUSTOMPROPERTY37: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY37.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 37',
      },
    },
    Account_CUSTOMPROPERTY38: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY38.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 38',
      },
    },
    Account_CUSTOMPROPERTY39: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY39.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 39',
      },
    },
    Account_CUSTOMPROPERTY40: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY40.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 40',
      },
    },
    Account_CUSTOMPROPERTY41: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY41.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 41',
      },
    },
    Account_CUSTOMPROPERTY42: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY42.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 42',
      },
    },
    Account_CUSTOMPROPERTY43: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY43.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 43',
      },
    },
    Account_CUSTOMPROPERTY44: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY44.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 44',
      },
    },
    Account_CUSTOMPROPERTY45: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY45.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 45',
      },
    },
    Account_CUSTOMPROPERTY46: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY46.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 46',
      },
    },
    Account_CUSTOMPROPERTY47: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY47.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 47',
      },
    },
    Account_CUSTOMPROPERTY48: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY48.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 48',
      },
    },
    Account_CUSTOMPROPERTY49: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY49.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 49',
      },
    },
    Account_CUSTOMPROPERTY50: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY50.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 50',
      },
    },
    Account_CUSTOMPROPERTY51: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY51.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 51',
      },
    },
    Account_CUSTOMPROPERTY52: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY52.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 52',
      },
    },
    Account_CUSTOMPROPERTY53: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY53.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 53',
      },
    },
    Account_CUSTOMPROPERTY54: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY54.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 54',
      },
    },
    Account_CUSTOMPROPERTY55: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY55.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 55',
      },
    },
    Account_CUSTOMPROPERTY56: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY56.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 56',
      },
    },
    Account_UPDATEDATE: {
      ATTESTATIONS: {
        id: 'Account_UPDATEDATE.ATTESTATIONS',
        defaultMessage: 'Account Update Date',
      },
    },
    Account_ACCOUNTID: {
      ATTESTATIONS: {
        id: 'Account_ACCOUNTID.ATTESTATIONS',
        defaultMessage: 'Account ID',
      },
    },
    'Account_DISPLAYNAME.CERTIFICATIONS': {
      ATTESTATIONS: {
        id: 'Account_DISPLAYNAME.CERTIFICATIONS',
        defaultMessage: 'Account',
      },
    },
    Account_REFERENCED_ACCOUNTNAME: {
      ATTESTATIONS: {
        id: 'Account_REFERENCED_ACCOUNTNAME.ATTESTATIONS',
        defaultMessage: 'Referenced Account Name',
      },
    },
    Account_ACCOUNTCLASS: {
      ATTESTATIONS: {
        id: 'Account_ACCOUNTCLASS.ATTESTATIONS',
        defaultMessage: 'Account Classification',
      },
    },
    Account_USERGROUP: {
      ATTESTATIONS: {
        id: 'Account_USERGROUP.ATTESTATIONS',
        defaultMessage: 'Account User Group',
      },
    },
    User_ACCOUNT_CERT_ACCOUNTKEY: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CERT_ACCOUNTKEY.ATTESTATIONS',
        defaultMessage: 'Account Certification Account Key',
      },
    },
    User_ACCOUNT_ACCOUNTKEY: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_ACCOUNTKEY.ATTESTATIONS',
        defaultMessage: 'Account Key',
      },
    },
    User_ACCOUNT_NAME: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_NAME.ATTESTATIONS',
        defaultMessage: 'Account Name',
      },
    },
    User_ACCOUNT_REFERENCED_ACCOUNTKEY: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_REFERENCED_ACCOUNTKEY.ATTESTATIONS',
        defaultMessage: 'Referenced Account',
      },
    },
    User_ACCOUNT_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_DESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Account Description',
      },
    },
    User_ACCOUNT_COMMENTS: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_COMMENTS.ATTESTATIONS',
        defaultMessage: 'Account Comments',
      },
    },
    User_ACCOUNT_ACCOUNTTYPE: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_ACCOUNTTYPE.ATTESTATIONS',
        defaultMessage: 'Account Type',
      },
    },
    User_ACCOUNT_STATUS: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_STATUS.ATTESTATIONS',
        defaultMessage: 'Account Status',
      },
    },
    User_ACCOUNT_VALIDFROM: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_VALIDFROM.ATTESTATIONS',
        defaultMessage: 'Account Valid From',
      },
    },
    User_ACCOUNT_VALIDTHROUGH: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_VALIDTHROUGH.ATTESTATIONS',
        defaultMessage: 'Account Valid Through',
      },
    },
    User_ACCOUNT_USERLOCK: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_USERLOCK.ATTESTATIONS',
        defaultMessage: 'Account User Lock',
      },
    },
    User_ACCOUNT_CREATOR: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CREATOR.ATTESTATIONS',
        defaultMessage: 'Account Created By',
      },
    },
    User_ACCOUNT_CREATED_ON: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CREATED_ON.ATTESTATIONS',
        defaultMessage: 'Account Created On',
      },
    },
    User_ACCOUNT_LASTLOGONDATE: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_LASTLOGONDATE.ATTESTATIONS',
        defaultMessage: 'Account Last Login Date',
      },
    },
    User_ACCOUNT_ORPHAN: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_ORPHAN.ATTESTATIONS',
        defaultMessage: 'Account Orphan',
      },
    },
    User_ACCOUNT_JOBID: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_JOBID.ATTESTATIONS',
        defaultMessage: 'Account Job ID',
      },
    },
    User_ACCOUNT_PRIVILEGED: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_PRIVILEGED.ATTESTATIONS',
        defaultMessage: 'Account Privileged',
      },
    },
    User_ACCOUNT_ENDPOINTKEY: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_ENDPOINTKEY.ATTESTATIONS',
        defaultMessage: 'Account Endpoint',
      },
    },
    User_ACCOUNT_SYSTEMID: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_SYSTEMID.ATTESTATIONS',
        defaultMessage: 'Account System',
      },
    },
    User_ACCOUNT_INCORRECTLOGONS: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_INCORRECTLOGONS.ATTESTATIONS',
        defaultMessage: 'Account Incorrect Logins',
      },
    },
    User_ACCOUNT_LASTPASSWORDCHANGE: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_LASTPASSWORDCHANGE.ATTESTATIONS',
        defaultMessage: 'Account Last Password Change',
      },
    },
    User_ACCOUNT_PASSWORDLOCKDATE: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_PASSWORDLOCKDATE.ATTESTATIONS',
        defaultMessage: 'Account Password Locked Date',
      },
    },
    User_ACCOUNT_PASSWORDCHANGESTATUS: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_PASSWORDCHANGESTATUS.ATTESTATIONS',
        defaultMessage: 'Account Password Change Status',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY1: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY1.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 1',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY2: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY2.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 2',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY3: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY3.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 3',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY4: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY4.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 4',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY5: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY5.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 5',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY6: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY6.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 6',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY7: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY7.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 7',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY8: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY8.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 8',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY9: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY9.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 9',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY10: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY10.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 10',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY11: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY11.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 11',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY12: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY12.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 12',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY13: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY13.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 13',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY14: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY14.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 14',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY15: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY15.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 15',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY16: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY16.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 16',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY17: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY17.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 17',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY18: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY18.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 18',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY19: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY19.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 19',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY20: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY20.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 20',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY21: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY21.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 21',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY22: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY22.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 22',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY23: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY23.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 23',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY24: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY24.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 24',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY25: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY25.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 25',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY26: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY26.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 26',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY27: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY27.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 27',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY28: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY28.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 28',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY29: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY29.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 29',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY30: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY30.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 30',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY31: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY31.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 31',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY32: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY32.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 32',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY33: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY33.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 33',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY34: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY34.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 34',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY35: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY35.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 35',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY36: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY36.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 36',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY37: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY37.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 37',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY38: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY38.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 38',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY39: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY39.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 39',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY40: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY40.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 40',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY41: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY41.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 41',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY42: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY42.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 42',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY43: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY43.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 43',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY44: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY44.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 44',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY45: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY45.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 45',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY46: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY46.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 46',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY47: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY47.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 47',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY48: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY48.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 48',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY49: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY49.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 49',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY50: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY50.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 50',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY51: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY51.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 51',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY52: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY52.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 52',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY53: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY53.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 53',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY54: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY54.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 54',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY55: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY55.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 55',
      },
    },
    User_ACCOUNT_CUSTOMPROPERTY56: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CUSTOMPROPERTY56.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 56',
      },
    },
    User_ACCOUNT_ACCOUNTSTATUS: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_ACCOUNTSTATUS.ATTESTATIONS',
        defaultMessage: 'Account Status',
      },
    },
    User_ACCOUNT_CREATEDON: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_CREATEDON.ATTESTATIONS',
        defaultMessage: 'Account Created On',
      },
    },
    User_ACCOUNT_OLDOWNER: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_OLDOWNER.ATTESTATIONS',
        defaultMessage: 'Account Old Owner',
      },
    },
    User_ACCOUNT_NEWOWNER: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_NEWOWNER.ATTESTATIONS',
        defaultMessage: 'Account New Owner',
      },
    },
    User_ACCOUNT_UPDATEDATE: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_UPDATEDATE.ATTESTATIONS',
        defaultMessage: 'Account Update Date',
      },
    },
    User_ACCOUNT_ACCOUNTID: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_ACCOUNTID.ATTESTATIONS',
        defaultMessage: 'Account ID',
      },
    },
    User_ACCOUNT_DISPLAYNAME: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_DISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'Account Display Name',
      },
    },
    User_ACCOUNT_REFERENCED_ACCOUNTNAME: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_REFERENCED_ACCOUNTNAME.ATTESTATIONS',
        defaultMessage: 'Referenced Account Name',
      },
    },
    User_ACCOUNT_ACCOUNTCLASS: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_ACCOUNTCLASS.ATTESTATIONS',
        defaultMessage: 'Account Classification',
      },
    },
    User_ACCOUNT_USERGROUP: {
      ATTESTATIONS: {
        id: 'User_ACCOUNT_USERGROUP.ATTESTATIONS',
        defaultMessage: 'Account User Group',
      },
    },
    Ent_CERT_ENTITLEMENT_VALUEKEY: {
      ATTESTATIONS: {
        id: 'Ent_CERT_ENTITLEMENT_VALUEKEY.ATTESTATIONS',
        defaultMessage: 'Certification Entitlement Value Key',
      },
    },
    Ent_ENTITLEMENT_VALUEKEY: {
      ATTESTATIONS: {
        id: 'Ent_ENTITLEMENT_VALUEKEY.ATTESTATIONS',
        defaultMessage: 'Entitlement Value Key',
      },
    },
    Ent_ENTITLEMENT_VALUE: {
      ATTESTATIONS: {
        id: 'Ent_ENTITLEMENT_VALUE.ATTESTATIONS',
        defaultMessage: 'Entitlement Value',
      },
    },
    Ent_ENTITLEMENTTYPEKEY: {
      ATTESTATIONS: {
        id: 'Ent_ENTITLEMENTTYPEKEY.ATTESTATIONS',
        defaultMessage: 'Entitlement Type Key',
      },
    },
    Ent_CUSTOMPROPERTY1: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY1.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 1',
      },
    },
    Ent_CUSTOMPROPERTY2: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY2.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 2',
      },
    },
    Ent_CUSTOMPROPERTY3: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY3.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 3',
      },
    },
    Ent_CUSTOMPROPERTY4: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY4.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 4',
      },
    },
    Ent_CUSTOMPROPERTY5: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY5.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 5',
      },
    },
    Ent_CUSTOMPROPERTY6: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY6.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 6',
      },
    },
    Ent_CUSTOMPROPERTY7: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY7.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 7',
      },
    },
    Ent_CUSTOMPROPERTY8: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY8.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 8',
      },
    },
    Ent_CUSTOMPROPERTY9: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY9.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 9',
      },
    },
    Ent_CUSTOMPROPERTY10: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY10.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 10',
      },
    },
    Ent_CUSTOMPROPERTY11: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY11.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 11',
      },
    },
    Ent_CUSTOMPROPERTY12: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY12.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 12',
      },
    },
    Ent_CUSTOMPROPERTY13: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY13.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 13',
      },
    },
    Ent_CUSTOMPROPERTY14: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY14.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 14',
      },
    },
    Ent_CUSTOMPROPERTY15: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY15.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 15',
      },
    },
    Ent_CUSTOMPROPERTY16: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY16.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 16',
      },
    },
    Ent_CUSTOMPROPERTY17: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY17.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 17',
      },
    },
    Ent_CUSTOMPROPERTY18: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY18.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 18',
      },
    },
    Ent_CUSTOMPROPERTY19: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY19.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 19',
      },
    },
    Ent_CUSTOMPROPERTY20: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY20.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 20',
      },
    },
    Ent_CUSTOMPROPERTY21: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY21.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 21',
      },
    },
    Ent_CUSTOMPROPERTY22: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY22.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 22',
      },
    },
    Ent_CUSTOMPROPERTY23: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY23.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 23',
      },
    },
    Ent_CUSTOMPROPERTY24: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY24.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 24',
      },
    },
    Ent_CUSTOMPROPERTY25: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY25.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 25',
      },
    },
    Ent_CUSTOMPROPERTY26: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY26.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 26',
      },
    },
    Ent_CUSTOMPROPERTY27: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY27.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 27',
      },
    },
    Ent_CUSTOMPROPERTY28: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY28.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 28',
      },
    },
    Ent_CUSTOMPROPERTY29: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY29.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 29',
      },
    },
    Ent_CUSTOMPROPERTY30: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY30.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 30',
      },
    },
    Ent_CUSTOMPROPERTY31: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY31.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 31',
      },
    },
    Ent_CUSTOMPROPERTY32: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY32.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 32',
      },
    },
    Ent_CUSTOMPROPERTY33: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY33.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 33',
      },
    },
    Ent_CUSTOMPROPERTY34: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY34.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 34',
      },
    },
    Ent_CUSTOMPROPERTY35: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY35.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 35',
      },
    },
    Ent_CUSTOMPROPERTY36: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY36.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 36',
      },
    },
    Ent_CUSTOMPROPERTY37: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY37.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 37',
      },
    },
    Ent_CUSTOMPROPERTY38: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY38.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 38',
      },
    },
    Ent_CUSTOMPROPERTY39: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY39.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 39',
      },
    },
    Ent_CUSTOMPROPERTY40: {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY40.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 40',
      },
    },
    Ent_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'Ent_DESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Entitlement Description',
      },
    },
    Ent_ENTITLEMENT_GLOSSARY: {
      ATTESTATIONS: {
        id: 'Ent_ENTITLEMENT_GLOSSARY.ATTESTATIONS',
        defaultMessage: 'Entitlement Glossary',
      },
    },
    Ent_STATUS: {
      ATTESTATIONS: {
        id: 'Ent_STATUS.ATTESTATIONS',
        defaultMessage: 'Entitlement Status',
      },
    },
    Ent_UPDATEUSER: {
      ATTESTATIONS: {
        id: 'Ent_UPDATEUSER.ATTESTATIONS',
        defaultMessage: 'Entitlement Update User',
      },
    },
    Ent_RISK: {
      ATTESTATIONS: {
        id: 'Ent_RISK.ATTESTATIONS',
        defaultMessage: 'Entitlement Risk',
      },
    },
    Ent_SOX_CRITICAL: {
      ATTESTATIONS: {
        id: 'Ent_SOX_CRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement SOX Critical',
      },
    },
    Ent_SYS_CRITICAL: {
      ATTESTATIONS: {
        id: 'Ent_SYS_CRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement Sys Critical',
      },
    },
    Ent_ORPHAN: {
      ATTESTATIONS: {
        id: 'Ent_ORPHAN.ATTESTATIONS',
        defaultMessage: 'Entitlement Orphan',
      },
    },
    Ent_UPDATEDATE: {
      ATTESTATIONS: {
        id: 'Ent_UPDATEDATE.ATTESTATIONS',
        defaultMessage: 'Entitlement Update Date',
      },
    },
    Ent_SAVLEVEL: {
      ATTESTATIONS: {
        id: 'Ent_SAVLEVEL.ATTESTATIONS',
        defaultMessage: 'Entitlement SAV Level',
      },
    },
    Ent_LEVEL: {
      ATTESTATIONS: {
        id: 'Ent_LEVEL.ATTESTATIONS',
        defaultMessage: 'Entitlement SAV Level',
      },
    },
    Ent_PRIVILEGED: {
      ATTESTATIONS: {
        id: 'Ent_PRIVILEGED.ATTESTATIONS',
        defaultMessage: 'Entitlement Privileged',
      },
    },
    Ent_CONFIDENTIALITY: {
      ATTESTATIONS: {
        id: 'Ent_CONFIDENTIALITY.ATTESTATIONS',
        defaultMessage: 'Entitlement Confidentiality',
      },
    },
    Ent_SOD: {
      ATTESTATIONS: {
        id: 'Ent_SOD.ATTESTATIONS',
        defaultMessage: 'Entitlement SOD',
      },
    },
    'Ent_DISPLAYNAME.CERTIFICATIONS': {
      ATTESTATIONS: {
        id: 'Ent_DISPLAYNAME.CERTIFICATIONS',
        defaultMessage: 'Entitlement',
      },
    },
    'ChildEnt_DISPLAYNAME.CERTIFICATIONS': {
      ATTESTATIONS: {
        id: 'ChildEnt_DISPLAYNAME.CERTIFICATIONS',
        defaultMessage: 'Child Entitlement',
      },
    },
    'Ent2_DISPLAYNAME.CERTIFICATIONS': {
      ATTESTATIONS: {
        id: 'Ent2_DISPLAYNAME.CERTIFICATIONS',
        defaultMessage: 'Child Entitlement',
      },
    },
    ChildEnt_DISPLAYNAME: {
      ATTESTATIONS: {
        id: 'ChildEnt_DISPLAYNAME',
        defaultMessage: 'Child Entitlement',
      },
    },
    Ent_ENTITLEMENTID: {
      ATTESTATIONS: {
        id: 'Ent_ENTITLEMENTID.ATTESTATIONS',
        defaultMessage: 'Entitlement ID',
      },
    },
    Ent_PROGRAM: {
      ATTESTATIONS: {
        id: 'Ent_PROGRAM.ATTESTATIONS',
        defaultMessage: 'Entitlement Program',
      },
    },
    Ent_MODULE: {
      ATTESTATIONS: {
        id: 'Ent_MODULE.ATTESTATIONS',
        defaultMessage: 'Entitlement Module',
      },
    },
    Ent_ACCESS: {
      ATTESTATIONS: {
        id: 'Ent_ACCESS.ATTESTATIONS',
        defaultMessage: 'Entitlement Access',
      },
    },
    Ent_SCHEMANAME: {
      ATTESTATIONS: {
        id: 'Ent_SCHEMANAME.ATTESTATIONS',
        defaultMessage: 'Entitlement Schema Name',
      },
    },
    Ent_ENTCLASS: {
      ATTESTATIONS: {
        id: 'Ent_ENTCLASS.ATTESTATIONS',
        defaultMessage: 'Entitlement Classification',
      },
    },
    Ent_LASTSCANDATE: {
      ATTESTATIONS: {
        id: 'Ent_LASTSCANDATE.ATTESTATIONS',
        defaultMessage: 'Entitlement Last Scan Date',
      },
    },
    Ent_ENTITLEMGLOSSARY: {
      ATTESTATIONS: {
        id: 'Ent_ENTITLEMGLOSSARY.ATTESTATIONS',
        defaultMessage: 'Entitlement Glossary',
      },
    },
    Ent_JOBID: {
      ATTESTATIONS: {
        id: 'Ent_JOBID.ATTESTATIONS',
        defaultMessage: 'Entitlement Job ID',
      },
    },
    Ent_SAVACCESS: {
      ATTESTATIONS: {
        id: 'Ent_SAVACCESS.ATTESTATIONS',
        defaultMessage: 'Entitlement Sav Access',
      },
    },
    User_CERT_USERKEY: {
      ATTESTATIONS: {
        id: 'User_CERT_USERKEY.ATTESTATIONS',
        defaultMessage: 'Certification User Key',
      },
    },
    'User_DISPLAYNAME.CERTIFICATIONS': {
      ATTESTATIONS: {
        id: 'User_DISPLAYNAME.CERTIFICATIONS',
        defaultMessage: 'User',
      },
    },
    User_USERKEY: {
      ATTESTATIONS: {
        id: 'User_USERKEY.ATTESTATIONS',
        defaultMessage: 'User Key',
      },
    },
    User_USERNAME: {
      ATTESTATIONS: {
        id: 'User_USERNAME.ATTESTATIONS',
        defaultMessage: 'Username',
      },
    },
    User_TERMDATE: {
      ATTESTATIONS: {
        id: 'User_TERMDATE.ATTESTATIONS',
        defaultMessage: 'User Term Date',
      },
    },
    User_FIRSTNAME: {
      ATTESTATIONS: {
        id: 'User_FIRSTNAME.ATTESTATIONS',
        defaultMessage: 'User First Name',
      },
    },
    User_TOTALACCOUNTS: {
      ATTESTATIONS: {
        id: 'User_TOTALACCOUNTS.ATTESTATIONS',
        defaultMessage: 'Total Accounts',
      },
    },
    User_AUDITTRAIL: {
      ATTESTATIONS: {
        id: 'User_AUDITTRAIL.ATTESTATIONS',
        defaultMessage: 'History',
      },
    },
    User_UPDATEUSER: {
      ATTESTATIONS: {
        id: 'User_UPDATEUSER.ATTESTATIONS',
        defaultMessage: 'Update User',
      },
    },
    User_CERTIFIED: {
      ATTESTATIONS: {
        id: 'User_CERTIFIED.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    User_LASTNAME: {
      ATTESTATIONS: {
        id: 'User_LASTNAME.ATTESTATIONS',
        defaultMessage: 'User Last Name',
      },
    },
    User_MIDDLENAME: {
      ATTESTATIONS: {
        id: 'User_MIDDLENAME.ATTESTATIONS',
        defaultMessage: 'User Middle Name',
      },
    },
    User_STREET: {
      ATTESTATIONS: {
        id: 'User_STREET.ATTESTATIONS',
        defaultMessage: 'User Street',
      },
    },
    User_CITY: {
      ATTESTATIONS: {
        id: 'User_CITY.ATTESTATIONS',
        defaultMessage: 'User City',
      },
    },
    User_EMAIL: {
      ATTESTATIONS: {
        id: 'User_EMAIL.ATTESTATIONS',
        defaultMessage: 'User Email',
      },
    },
    User_COMMENTS: {
      ATTESTATIONS: {
        id: 'User_COMMENTS.ATTESTATIONS',
        defaultMessage: 'User Comments',
      },
    },
    User_STATUSKEY: {
      ATTESTATIONS: {
        id: 'User_STATUSKEY.ATTESTATIONS',
        defaultMessage: 'User Status',
      },
    },
    User_STARTDATE: {
      ATTESTATIONS: {
        id: 'User_STARTDATE.ATTESTATIONS',
        defaultMessage: 'User Start Date',
      },
    },
    User_ENDDATE: {
      ATTESTATIONS: {
        id: 'User_ENDDATE.ATTESTATIONS',
        defaultMessage: 'User End Date',
      },
    },
    User_MANAGER: {
      ATTESTATIONS: {
        id: 'User_MANAGER.ATTESTATIONS',
        defaultMessage: 'User Manager',
      },
    },
    User_PASSWORD: {
      ATTESTATIONS: {
        id: 'User_PASSWORD.ATTESTATIONS',
        defaultMessage: 'User Password',
      },
    },
    User_ENABLED: {
      ATTESTATIONS: {
        id: 'User_ENABLED.ATTESTATIONS',
        defaultMessage: 'User Enabled',
      },
    },
    User_LOCATION: {
      ATTESTATIONS: {
        id: 'User_LOCATION.ATTESTATIONS',
        defaultMessage: 'User Location',
      },
    },
    User_JOBCODE: {
      ATTESTATIONS: {
        id: 'User_JOBCODE.ATTESTATIONS',
        defaultMessage: 'User Job Code',
      },
    },
    User_JOBDESCRIPTION: {
      ATTESTATIONS: {
        id: 'User_JOBDESCRIPTION.ATTESTATIONS',
        defaultMessage: 'User Job Description',
      },
    },
    User_EMPLOYEETYPE: {
      ATTESTATIONS: {
        id: 'User_EMPLOYEETYPE.ATTESTATIONS',
        defaultMessage: 'User Employee Type',
      },
    },
    User_SYSTEMUSERNAME: {
      ATTESTATIONS: {
        id: 'User_SYSTEMUSERNAME.ATTESTATIONS',
        defaultMessage: 'User System Username',
      },
    },
    User_DEPARTMENTNUMBER: {
      ATTESTATIONS: {
        id: 'User_DEPARTMENTNUMBER.ATTESTATIONS',
        defaultMessage: 'User Department Number',
      },
    },
    User_TITLE: {
      ATTESTATIONS: {
        id: 'User_TITLE.ATTESTATIONS',
        defaultMessage: 'User Title',
      },
    },
    User_STATE: {
      ATTESTATIONS: {
        id: 'User_STATE.ATTESTATIONS',
        defaultMessage: 'User State',
      },
    },
    User_COMPANYNAME: {
      ATTESTATIONS: {
        id: 'User_COMPANYNAME.ATTESTATIONS',
        defaultMessage: 'User Company Name',
      },
    },
    User_COSTCENTER: {
      ATTESTATIONS: {
        id: 'User_COSTCENTER.ATTESTATIONS',
        defaultMessage: 'User Cost Centre',
      },
    },
    User_DEPARTMENTNAME: {
      ATTESTATIONS: {
        id: 'User_DEPARTMENTNAME.ATTESTATIONS',
        defaultMessage: 'User Department Name',
      },
    },
    User_EMPLOYEECLASS: {
      ATTESTATIONS: {
        id: 'User_EMPLOYEECLASS.ATTESTATIONS',
        defaultMessage: 'User Employee Class',
      },
    },
    User_ENTITY: {
      ATTESTATIONS: {
        id: 'User_ENTITY.ATTESTATIONS',
        defaultMessage: 'User Entity',
      },
    },
    User_JOBCODEDESC: {
      ATTESTATIONS: {
        id: 'User_JOBCODEDESC.ATTESTATIONS',
        defaultMessage: 'User Job Code Description',
      },
    },
    User_LOCATIONDESC: {
      ATTESTATIONS: {
        id: 'User_LOCATIONDESC.ATTESTATIONS',
        defaultMessage: 'User Location Description',
      },
    },
    User_LOCATIONNUMBER: {
      ATTESTATIONS: {
        id: 'User_LOCATIONNUMBER.ATTESTATIONS',
        defaultMessage: 'User Location Number',
      },
    },
    User_SITEID: {
      ATTESTATIONS: {
        id: 'User_SITEID.ATTESTATIONS',
        defaultMessage: 'User Site',
      },
    },
    User_ORGUNITID: {
      ATTESTATIONS: {
        id: 'User_ORGUNITID.ATTESTATIONS',
        defaultMessage: 'User Organization Unit',
      },
    },
    User_REGION: {
      ATTESTATIONS: {
        id: 'User_REGION.ATTESTATIONS',
        defaultMessage: 'User Region',
      },
    },
    User_REGIONCODE: {
      ATTESTATIONS: {
        id: 'User_REGIONCODE.ATTESTATIONS',
        defaultMessage: 'User Region Code',
      },
    },
    User_OWNER: {
      ATTESTATIONS: {
        id: 'User_OWNER.ATTESTATIONS',
        defaultMessage: 'User Owner',
      },
    },
    User_EMPLOYEEID: {
      ATTESTATIONS: {
        id: 'User_EMPLOYEEID.ATTESTATIONS',
        defaultMessage: 'User Employee',
      },
    },
    User_LASTSYNCDATE: {
      ATTESTATIONS: {
        id: 'User_LASTSYNCDATE.ATTESTATIONS',
        defaultMessage: 'User Last Sync Date',
      },
    },
    User_PHONENUMBER: {
      ATTESTATIONS: {
        id: 'User_PHONENUMBER.ATTESTATIONS',
        defaultMessage: 'User Phone Number',
      },
    },
    User_COUNTRY: {
      ATTESTATIONS: {
        id: 'User_COUNTRY.ATTESTATIONS',
        defaultMessage: 'User Country',
      },
    },
    User_ACCOUNTEXPIRED: {
      ATTESTATIONS: {
        id: 'User_ACCOUNTEXPIRED.ATTESTATIONS',
        defaultMessage: 'User Account Expired',
      },
    },
    User_ACCOUNTLOCKED: {
      ATTESTATIONS: {
        id: 'User_ACCOUNTLOCKED.ATTESTATIONS',
        defaultMessage: 'User Account Locked',
      },
    },
    User_PASSWORDEXPIRED: {
      ATTESTATIONS: {
        id: 'User_PASSWORDEXPIRED.ATTESTATIONS',
        defaultMessage: 'User Password Expired',
      },
    },
    User_JOB_FUNCTION: {
      ATTESTATIONS: {
        id: 'User_JOB_FUNCTION.ATTESTATIONS',
        defaultMessage: 'User Job Function',
      },
    },
    User_DONOTDISTURBDELEGATE: {
      ATTESTATIONS: {
        id: 'User_DONOTDISTURBDELEGATE.ATTESTATIONS',
        defaultMessage: 'User Do Not Disturb Delegate',
      },
    },
    User_CUSTOMPROPERTY1: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY1.ATTESTATIONS',
        defaultMessage: 'User Custom Property 1',
      },
    },
    User_CUSTOMPROPERTY2: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY2.ATTESTATIONS',
        defaultMessage: 'User Custom Property 2',
      },
    },
    User_CUSTOMPROPERTY3: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY3.ATTESTATIONS',
        defaultMessage: 'User Custom Property 3',
      },
    },
    User_CUSTOMPROPERTY4: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY4.ATTESTATIONS',
        defaultMessage: 'User Custom Property 4',
      },
    },
    User_CUSTOMPROPERTY5: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY5.ATTESTATIONS',
        defaultMessage: 'User Custom Property 5',
      },
    },
    User_CUSTOMPROPERTY6: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY6.ATTESTATIONS',
        defaultMessage: 'User Custom Property 6',
      },
    },
    User_CUSTOMPROPERTY7: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY7.ATTESTATIONS',
        defaultMessage: 'User Custom Property 7',
      },
    },
    User_CUSTOMPROPERTY8: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY8.ATTESTATIONS',
        defaultMessage: 'User Custom Property 8',
      },
    },
    User_CUSTOMPROPERTY9: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY9.ATTESTATIONS',
        defaultMessage: 'User Custom Property 9',
      },
    },
    User_CUSTOMPROPERTY10: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY10.ATTESTATIONS',
        defaultMessage: 'User Custom Property 10',
      },
    },
    User_CUSTOMPROPERTY11: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY11.ATTESTATIONS',
        defaultMessage: 'User Custom Property 11',
      },
    },
    User_CUSTOMPROPERTY12: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY12.ATTESTATIONS',
        defaultMessage: 'User Custom Property 12',
      },
    },
    User_CUSTOMPROPERTY13: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY13.ATTESTATIONS',
        defaultMessage: 'User Custom Property 13',
      },
    },
    User_CUSTOMPROPERTY14: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY14.ATTESTATIONS',
        defaultMessage: 'User Custom Property 14',
      },
    },
    User_CUSTOMPROPERTY15: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY15.ATTESTATIONS',
        defaultMessage: 'User Custom Property 15',
      },
    },
    User_CUSTOMPROPERTY16: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY16.ATTESTATIONS',
        defaultMessage: 'User Custom Property 16',
      },
    },
    User_CUSTOMPROPERTY17: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY17.ATTESTATIONS',
        defaultMessage: 'User Custom Property 17',
      },
    },
    User_CUSTOMPROPERTY18: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY18.ATTESTATIONS',
        defaultMessage: 'User Custom Property 18',
      },
    },
    User_CUSTOMPROPERTY19: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY19.ATTESTATIONS',
        defaultMessage: 'User Custom Property 19',
      },
    },
    User_CUSTOMPROPERTY20: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY20.ATTESTATIONS',
        defaultMessage: 'User Custom Property 20',
      },
    },
    User_CUSTOMPROPERTY21: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY21.ATTESTATIONS',
        defaultMessage: 'User Custom Property 21',
      },
    },
    User_CUSTOMPROPERTY22: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY22.ATTESTATIONS',
        defaultMessage: 'User Custom Property 22',
      },
    },
    User_CUSTOMPROPERTY23: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY23.ATTESTATIONS',
        defaultMessage: 'User Custom Property 23',
      },
    },
    User_CUSTOMPROPERTY24: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY24.ATTESTATIONS',
        defaultMessage: 'User Custom Property 24',
      },
    },
    User_CUSTOMPROPERTY25: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY25.ATTESTATIONS',
        defaultMessage: 'User Custom Property 25',
      },
    },
    User_CUSTOMPROPERTY26: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY26.ATTESTATIONS',
        defaultMessage: 'User Custom Property 26',
      },
    },
    User_CUSTOMPROPERTY27: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY27.ATTESTATIONS',
        defaultMessage: 'User Custom Property 27',
      },
    },
    User_CUSTOMPROPERTY28: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY28.ATTESTATIONS',
        defaultMessage: 'User Custom Property 28',
      },
    },
    User_CUSTOMPROPERTY29: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY29.ATTESTATIONS',
        defaultMessage: 'User Custom Property 29',
      },
    },
    User_CUSTOMPROPERTY30: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY30.ATTESTATIONS',
        defaultMessage: 'User Custom Property 30',
      },
    },
    User_CUSTOMPROPERTY31: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY31.ATTESTATIONS',
        defaultMessage: 'User Custom Property 31',
      },
    },
    User_CUSTOMPROPERTY32: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY32.ATTESTATIONS',
        defaultMessage: 'User Custom Property 32',
      },
    },
    User_CUSTOMPROPERTY33: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY33.ATTESTATIONS',
        defaultMessage: 'User Custom Property 33',
      },
    },
    User_CUSTOMPROPERTY34: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY34.ATTESTATIONS',
        defaultMessage: 'User Custom Property 34',
      },
    },
    User_CUSTOMPROPERTY35: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY35.ATTESTATIONS',
        defaultMessage: 'User Custom Property 35',
      },
    },
    User_CUSTOMPROPERTY36: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY36.ATTESTATIONS',
        defaultMessage: 'User Custom Property 36',
      },
    },
    User_CUSTOMPROPERTY37: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY37.ATTESTATIONS',
        defaultMessage: 'User Custom Property 37',
      },
    },
    User_CUSTOMPROPERTY38: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY38.ATTESTATIONS',
        defaultMessage: 'User Custom Property 38',
      },
    },
    User_CUSTOMPROPERTY39: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY39.ATTESTATIONS',
        defaultMessage: 'User Custom Property 39',
      },
    },
    User_CUSTOMPROPERTY40: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY40.ATTESTATIONS',
        defaultMessage: 'User Custom Property 40',
      },
    },
    User_RISKSCORE: {
      ATTESTATIONS: {
        id: 'User_RISKSCORE.ATTESTATIONS',
        defaultMessage: 'User Risk Score',
      },
    },
    User_EXTENDEDENDDATE: {
      ATTESTATIONS: {
        id: 'User_EXTENDEDENDDATE.ATTESTATIONS',
        defaultMessage: 'User Extended Date',
      },
    },
    User_LASTCERTIFIEDCAMPAIGNNAME: {
      ATTESTATIONS: {
        id: 'User_LASTCERTIFIEDCAMPAIGNNAME.ATTESTATIONS',
        defaultMessage: 'Last Certified Campaign',
      },
    },
    User_LASTCERTIFIEDDATE: {
      ATTESTATIONS: {
        id: 'User_LASTCERTIFIEDDATE.ATTESTATIONS',
        defaultMessage: 'Last Certified Date',
      },
    },
    User_LASTCERTIFIEDUSER: {
      ATTESTATIONS: {
        id: 'User_LASTCERTIFIEDUSER.ATTESTATIONS',
        defaultMessage: 'Last Certified User',
      },
    },
    ACCDESCRIPTION: {
      ATTESTATIONS: {
        id: 'ACCDESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Account Description',
      },
    },
    ENTDESCRIPTION: {
      ATTESTATIONS: {
        id: 'ENTDESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Entitlement Description',
      },
    },
    LASTCERTIFIEDUSER: {
      ATTESTATIONS: {
        id: 'LASTCERTIFIEDUSER.ATTESTATIONS',
        defaultMessage: 'Last Certified User',
      },
    },
    name: {
      ATTESTATIONS: {
        id: 'name.ATTESTATIONS',
        defaultMessage: 'Account Name',
      },
    },
    displayName: {
      ATTESTATIONS: {
        id: 'displayName.ATTESTATIONS',
        defaultMessage: 'DisplayName',
      },
    },
    comments: {
      ATTESTATIONS: {
        id: 'comments.ATTESTATIONS',
        defaultMessage: 'Comments',
      },
    },
    securitysystem: {
      ATTESTATIONS: {
        id: 'securitysystem.ATTESTATIONS',
        defaultMessage: 'Security System',
      },
    },
    auditTrail: {
      ATTESTATIONS: {
        id: 'auditTrail.ATTESTATIONS',
        defaultMessage: 'History',
      },
    },
    endpoints: {
      ATTESTATIONS: {
        id: 'endpoints.ATTESTATIONS',
        defaultMessage: 'Endpoints',
      },
    },
    description: {
      ATTESTATIONS: {
        id: 'description.ATTESTATIONS',
        defaultMessage: 'Description',
      },
    },
    enddate: {
      ATTESTATIONS: {
        id: 'enddate.ATTESTATIONS',
        defaultMessage: 'End Date',
      },
    },
    status: {
      ATTESTATIONS: {
        id: 'status.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    TASKID: {
      ATTESTATIONS: {
        id: 'TASKID.ATTESTATIONS',
        defaultMessage: 'Task Id',
      },
    },
    not_consulted: {
      ATTESTATIONS: {
        id: 'not_consulted.ATTESTATIONS.label',
        defaultMessage: 'Not Consulted',
      },
    },
    'reassigned.ATTESTATIONS.label': {
      ATTESTATIONS: {
        id: 'reassigned.ATTESTATIONS.label',
        defaultMessage: 'Reassigned',
      },
    },
    consulted: {
      ATTESTATIONS: {
        id: 'consulted..ATTESTATIONS.label',
        defaultMessage: 'Consulted',
      },
    },
    IsConsulted: {
      ATTESTATIONS: {
        id: 'IsConsulted.ATTESTATIONS',
        defaultMessage: 'IsConsulted',
      },
    },
    Ent_NEWENTITLEMENTOWNER: {
      ATTESTATIONS: {
        id: 'Ent_NEWENTITLEMENTOWNER.ATTESTATIONS',
        defaultMessage: 'New Entitlement Owner',
      },
    },
    Role_RISK: {
      ATTESTATIONS: {
        id: 'Role_RISK.ATTESTATIONS',
        defaultMessage: 'Risk',
      },
    },
    Role_UPDATEDATE: {
      ATTESTATIONS: {
        id: 'Role_UPDATEDATE.ATTESTATIONS',
        defaultMessage: 'Role Update Date',
      },
    },
    Role_ENDDATE: {
      ATTESTATIONS: {
        id: 'Role_ENDDATE.ATTESTATIONS',
        defaultMessage: 'Role End Date',
      },
    },
    Role_GLOSSARY: {
      ATTESTATIONS: {
        id: 'Role_GLOSSARY.ATTESTATIONS',
        defaultMessage: 'Glossary',
      },
    },
    Role_SOXCRITICAL: {
      ATTESTATIONS: {
        id: 'Role_SOXCRITICAL.ATTESTATIONS',
        defaultMessage: 'SOX Critical',
      },
    },
    Role_SYSCRITICAL: {
      ATTESTATIONS: {
        id: 'Role_SYSCRITICAL.ATTESTATIONS',
        defaultMessage: 'Sys Critical',
      },
    },
    Role_PRIVILIGED: {
      ATTESTATIONS: {
        id: 'Role_PRIVILIGED.ATTESTATIONS',
        defaultMessage: 'Privileged',
      },
    },
    Role_CONFIDENTIALITY: {
      ATTESTATIONS: {
        id: 'Role_CONFIDENTIALITY.ATTESTATIONS',
        defaultMessage: 'Confidentiality',
      },
    },
    Role_DEFAULTTIMEFRAMEHRS: {
      ATTESTATIONS: {
        id: 'Role_DEFAULTTIMEFRAMEHRS.ATTESTATIONS',
        defaultMessage: 'Default Time Frame',
      },
    },
    Role_REQUESTABLE: {
      ATTESTATIONS: {
        id: 'Role_REQUESTABLE.ATTESTATIONS',
        defaultMessage: 'Requestable',
      },
    },
    Role_ROLETYPE: {
      ATTESTATIONS: {
        id: 'Role_ROLETYPE.ATTESTATIONS',
        defaultMessage: 'Role Type',
      },
    },
    Role_ROLESTATE: {
      ATTESTATIONS: {
        id: 'Role_ROLESTATE.ATTESTATIONS',
        defaultMessage: 'Role State',
      },
    },
    Role_CUSTOMPROPERTY1: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY1.ATTESTATIONS',
        defaultMessage: 'Custom Property 1',
      },
    },
    Role_CUSTOMPROPERTY10: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY10.ATTESTATIONS',
        defaultMessage: 'Custom Property 10',
      },
    },
    Role_CUSTOMPROPERTY11: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY11.ATTESTATIONS',
        defaultMessage: 'Custom Property 11',
      },
    },
    Role_CUSTOMPROPERTY12: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY12.ATTESTATIONS',
        defaultMessage: 'Custom Property 12',
      },
    },
    Role_CUSTOMPROPERTY13: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY13.ATTESTATIONS',
        defaultMessage: 'Custom Property 13',
      },
    },
    Role_CUSTOMPROPERTY14: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY14.ATTESTATIONS',
        defaultMessage: 'Custom Property 14',
      },
    },
    Role_CUSTOMPROPERTY15: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY15.ATTESTATIONS',
        defaultMessage: 'Custom Property 15',
      },
    },
    Role_CUSTOMPROPERTY16: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY16.ATTESTATIONS',
        defaultMessage: 'Custom Property 16',
      },
    },
    Role_CUSTOMPROPERTY17: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY17.ATTESTATIONS',
        defaultMessage: 'Custom Property 17',
      },
    },
    Role_CUSTOMPROPERTY18: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY18.ATTESTATIONS',
        defaultMessage: 'Custom Property 18',
      },
    },
    Role_CUSTOMPROPERTY19: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY19.ATTESTATIONS',
        defaultMessage: 'Custom Property 19',
      },
    },
    Role_CUSTOMPROPERTY2: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY2.ATTESTATIONS',
        defaultMessage: 'Custom Property 2',
      },
    },
    Role_CUSTOMPROPERTY20: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY20.ATTESTATIONS',
        defaultMessage: 'Custom Property 20',
      },
    },
    Role_CUSTOMPROPERTY3: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY3.ATTESTATIONS',
        defaultMessage: 'Custom Property 3',
      },
    },
    Role_CUSTOMPROPERTY4: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY4.ATTESTATIONS',
        defaultMessage: 'Custom Property 4',
      },
    },
    Role_CUSTOMPROPERTY5: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY5.ATTESTATIONS',
        defaultMessage: 'Custom Property 5',
      },
    },
    Role_CUSTOMPROPERTY6: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY6.ATTESTATIONS',
        defaultMessage: 'Custom Property 6',
      },
    },
    Role_CUSTOMPROPERTY7: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY7.ATTESTATIONS',
        defaultMessage: 'Custom Property 7',
      },
    },
    Role_CUSTOMPROPERTY8: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY8.ATTESTATIONS',
        defaultMessage: 'Custom Property 8',
      },
    },
    Role_CUSTOMPROPERTY9: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY9.ATTESTATIONS',
        defaultMessage: 'Custom Property 9',
      },
    },
    Role_CUSTOMPROPERTY21: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY21.ATTESTATIONS',
        defaultMessage: 'Custom Property 21',
      },
    },
    Role_CUSTOMPROPERTY22: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY22.ATTESTATIONS',
        defaultMessage: 'Custom Property 22',
      },
    },
    Role_CUSTOMPROPERTY23: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY23.ATTESTATIONS',
        defaultMessage: 'Custom Property 23',
      },
    },
    Role_CUSTOMPROPERTY24: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY24.ATTESTATIONS',
        defaultMessage: 'Custom Property 24',
      },
    },
    Role_CUSTOMPROPERTY25: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY25.ATTESTATIONS',
        defaultMessage: 'Custom Property 25',
      },
    },
    Role_CUSTOMPROPERTY26: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY26.ATTESTATIONS',
        defaultMessage: 'Custom Property 26',
      },
    },
    Role_CUSTOMPROPERTY27: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY27.ATTESTATIONS',
        defaultMessage: 'Custom Property 27',
      },
    },
    Role_CUSTOMPROPERTY28: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY28.ATTESTATIONS',
        defaultMessage: 'Custom Property 28',
      },
    },
    Role_CUSTOMPROPERTY29: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY29.ATTESTATIONS',
        defaultMessage: 'Custom Property 29',
      },
    },
    Role_CUSTOMPROPERTY30: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY30.ATTESTATIONS',
        defaultMessage: 'Custom Property 30',
      },
    },
    Role_CUSTOMPROPERTY31: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY31.ATTESTATIONS',
        defaultMessage: 'Custom Property 31',
      },
    },
    Role_CUSTOMPROPERTY32: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY32.ATTESTATIONS',
        defaultMessage: 'Custom Property 32',
      },
    },
    Role_CUSTOMPROPERTY33: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY33.ATTESTATIONS',
        defaultMessage: 'Custom Property 33',
      },
    },
    Role_CUSTOMPROPERTY34: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY34.ATTESTATIONS',
        defaultMessage: 'Custom Property 34',
      },
    },
    Role_CUSTOMPROPERTY35: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY35.ATTESTATIONS',
        defaultMessage: 'Custom Property 35',
      },
    },
    Role_CUSTOMPROPERTY36: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY36.ATTESTATIONS',
        defaultMessage: 'Custom Property 36',
      },
    },
    Role_CUSTOMPROPERTY37: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY37.ATTESTATIONS',
        defaultMessage: 'Custom Property 37',
      },
    },
    Role_CUSTOMPROPERTY38: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY38.ATTESTATIONS',
        defaultMessage: 'Custom Property 38',
      },
    },
    Role_CUSTOMPROPERTY39: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY39.ATTESTATIONS',
        defaultMessage: 'Custom Property 39',
      },
    },
    Role_CUSTOMPROPERTY40: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY40.ATTESTATIONS',
        defaultMessage: 'Custom Property 40',
      },
    },
    Organization_LOGONAME: {
      ATTESTATIONS: {
        id: 'Organization_LOGONAME.ATTESTATIONS',
        defaultMessage: 'Logoname',
      },
    },
    Organization_LOCATION: {
      ATTESTATIONS: {
        id: 'Organization_LOCATION.ATTESTATIONS',
        defaultMessage: 'Location',
      },
    },
    Organization_PRIMARYVENDORCONTACT: {
      ATTESTATIONS: {
        id: 'Organization_PRIMARYVENDORCONTACT.ATTESTATIONS',
        defaultMessage: 'Primary Vendor Contact',
      },
    },
    Organization_CUSTOMPROPERTY1: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY1.ATTESTATIONS',
        defaultMessage: 'Custom Property 1',
      },
    },
    Organization_CUSTOMPROPERTY10: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY10.ATTESTATIONS',
        defaultMessage: 'Custom Property 10',
      },
    },
    Organization_CUSTOMPROPERTY11: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY11.ATTESTATIONS',
        defaultMessage: 'Custom Property 11',
      },
    },
    Organization_CUSTOMPROPERTY12: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY12.ATTESTATIONS',
        defaultMessage: 'Custom Property 12',
      },
    },
    Organization_CUSTOMPROPERTY13: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY13.ATTESTATIONS',
        defaultMessage: 'Custom Property 13',
      },
    },
    Organization_CUSTOMPROPERTY14: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY14.ATTESTATIONS',
        defaultMessage: 'Custom Property 14',
      },
    },
    Organization_CUSTOMPROPERTY15: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY15.ATTESTATIONS',
        defaultMessage: 'Custom Property 15',
      },
    },
    Organization_CUSTOMPROPERTY16: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY16.ATTESTATIONS',
        defaultMessage: 'Custom Property 16',
      },
    },
    Organization_CUSTOMPROPERTY17: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY17.ATTESTATIONS',
        defaultMessage: 'Custom Property 17',
      },
    },
    Organization_CUSTOMPROPERTY18: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY18.ATTESTATIONS',
        defaultMessage: 'Custom Property 18',
      },
    },
    Organization_CUSTOMPROPERTY19: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY19.ATTESTATIONS',
        defaultMessage: 'Custom Property 19',
      },
    },
    Organization_CUSTOMPROPERTY2: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY2.ATTESTATIONS',
        defaultMessage: 'Custom Property 2',
      },
    },
    Organization_CUSTOMPROPERTY20: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY20.ATTESTATIONS',
        defaultMessage: 'Custom Property 20',
      },
    },
    Organization_CUSTOMPROPERTY3: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY3.ATTESTATIONS',
        defaultMessage: 'Custom Property 3',
      },
    },
    Organization_CUSTOMPROPERTY4: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY4.ATTESTATIONS',
        defaultMessage: 'Custom Property 4',
      },
    },
    Organization_CUSTOMPROPERTY5: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY5.ATTESTATIONS',
        defaultMessage: 'Custom Property 5',
      },
    },
    Organization_CUSTOMPROPERTY6: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY6.ATTESTATIONS',
        defaultMessage: 'Custom Property 6',
      },
    },
    Organization_CUSTOMPROPERTY7: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY7.ATTESTATIONS',
        defaultMessage: 'Custom Property 7',
      },
    },
    Organization_CUSTOMPROPERTY8: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY8.ATTESTATIONS',
        defaultMessage: 'Custom Property 8',
      },
    },
    Organization_CUSTOMPROPERTY9: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY9.ATTESTATIONS',
        defaultMessage: 'Custom Property 9',
      },
    },
    Organization_CUSTOMPROPERTY21: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY21.ATTESTATIONS',
        defaultMessage: 'Custom Property 21',
      },
    },
    Organization_CUSTOMPROPERTY22: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY22.ATTESTATIONS',
        defaultMessage: 'Custom Property 22',
      },
    },
    Organization_CUSTOMPROPERTY23: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY23.ATTESTATIONS',
        defaultMessage: 'Custom Property 23',
      },
    },
    Organization_CUSTOMPROPERTY24: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY24.ATTESTATIONS',
        defaultMessage: 'Custom Property 24',
      },
    },
    Organization_CUSTOMPROPERTY25: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY25.ATTESTATIONS',
        defaultMessage: 'Custom Property 25',
      },
    },
    Organization_CUSTOMPROPERTY26: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY26.ATTESTATIONS',
        defaultMessage: 'Custom Property 26',
      },
    },
    Organization_CUSTOMPROPERTY27: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY27.ATTESTATIONS',
        defaultMessage: 'Custom Property 27',
      },
    },
    Organization_CUSTOMPROPERTY28: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMPROPERTY28.ATTESTATIONS',
        defaultMessage: 'Custom Property 28',
      },
    },
    Organization_COMMENTS: {
      ATTESTATIONS: {
        id: 'Organization_COMMENTS.ATTESTATIONS',
        defaultMessage: 'Comments',
      },
    },
    Organization_CUSTOMERCODE: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMERCODE.ATTESTATIONS',
        defaultMessage: 'Organization Code',
      },
    },
    Organization_CUSTOMERNAME: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMERNAME.ATTESTATIONS',
        defaultMessage: 'Organization Name',
      },
    },
    Organization_CUSTOMERNUMBER: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMERNUMBER.ATTESTATIONS',
        defaultMessage: 'Organization Number',
      },
    },
    Organization_CUSTOMERTYPE: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMERTYPE.ATTESTATIONS',
        defaultMessage: 'Organization Type',
      },
    },
    Organization_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'Organization_DESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Description',
      },
    },
    Organization_ENDDATE: {
      ATTESTATIONS: {
        id: 'Organization_ENDDATE.ATTESTATIONS',
        defaultMessage: 'End Date',
      },
    },
    Organization_LASTCERTIFICATIONDATE: {
      ATTESTATIONS: {
        id: 'Organization_LASTCERTIFICATIONDATE.ATTESTATIONS',
        defaultMessage: 'Last Certification Date',
      },
    },
    Organization_PHONENUMBER: {
      ATTESTATIONS: {
        id: 'Organization_PHONENUMBER.ATTESTATIONS',
        defaultMessage: 'Phone Number',
      },
    },
    Organization_RISK: {
      ATTESTATIONS: {
        id: 'Organization_RISK.ATTESTATIONS',
        defaultMessage: 'Risk',
      },
    },
    Organization_SCORE: {
      ATTESTATIONS: {
        id: 'Organization_SCORE.ATTESTATIONS',
        defaultMessage: 'Score',
      },
    },
    Organization_STARTDATE: {
      ATTESTATIONS: {
        id: 'Organization_STARTDATE.ATTESTATIONS',
        defaultMessage: 'Start Date',
      },
    },
    Organization_STATUS: {
      ATTESTATIONS: {
        id: 'Organization_STATUS.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    Organization_PARENTCUSTOMER: {
      ATTESTATIONS: {
        id: 'Organization_PARENTCUSTOMER.ATTESTATIONS',
        defaultMessage: 'Parent Organization',
      },
    },
    Organization_UPDATEUSER: {
      ATTESTATIONS: {
        id: 'Organization_UPDATEUSER.ATTESTATIONS',
        defaultMessage: 'Update User',
      },
    },
    Organization_VENDORMANAGER: {
      ATTESTATIONS: {
        id: 'Organization_VENDORMANAGER.ATTESTATIONS',
        defaultMessage: 'Vendor Manager',
      },
    },
    Organization_CREATEUSER: {
      ATTESTATIONS: {
        id: 'Organization_CREATEUSER.ATTESTATIONS',
        defaultMessage: 'Create User',
      },
    },
    Organization_EVENTSOURCE: {
      ATTESTATIONS: {
        id: 'Organization_EVENTSOURCE.ATTESTATIONS',
        defaultMessage: 'Event Source',
      },
    },
    Organization_LASTREVIEWEDDATE: {
      ATTESTATIONS: {
        id: 'Organization_LASTREVIEWEDDATE.ATTESTATIONS',
        defaultMessage: 'Last Reviewed Date',
      },
    },
    Organization_LASTREVIEWEDBY: {
      ATTESTATIONS: {
        id: 'Organization_LASTREVIEWEDBY.ATTESTATIONS',
        defaultMessage: 'Last Viewed By',
      },
    },
    Organization_LASTREVIEWEDCAMPAIGNNAME: {
      ATTESTATIONS: {
        id: 'Organization_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS',
        defaultMessage: 'Last Viewed Campaign',
      },
    },
    Organization_SAVCREATEDATE: {
      ATTESTATIONS: {
        id: 'Organization_SAVCREATEDATE.ATTESTATIONS',
        defaultMessage: 'SAV Create Date',
      },
    },
    Organization_SAVUPDATEDATE: {
      ATTESTATIONS: {
        id: 'Organization_SAVUPDATEDATE.ATTESTATIONS',
        defaultMessage: 'SAV Update Date',
      },
    },
    Organization_JOBID: {
      ATTESTATIONS: {
        id: 'Organization_JOBID.ATTESTATIONS',
        defaultMessage: 'Job ID',
      },
    },
    Organization_ORGOWNERS: {
      ATTESTATIONS: {
        id: 'Organization_ORGOWNERS.ATTESTATIONS',
        defaultMessage: 'Organization Owners',
      },
    },
    Organization_DISPLAYNAME: {
      ATTESTATIONS: {
        id: 'Organization_DISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'Display Name',
      },
    },
    Organization_CUSTOMER_TARGET_UNIQUE: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMER_TARGET_UNIQUE.ATTESTATIONS',
        defaultMessage: 'Target Customer',
      },
    },
    Organization_CUSTOMER_SOURCE: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMER_SOURCE.ATTESTATIONS',
        defaultMessage: 'Customer Source',
      },
    },
    Organization_CUSTOMERSOURCE: {
      ATTESTATIONS: {
        id: 'Organization_CUSTOMERSOURCE.ATTESTATIONS',
        defaultMessage: 'Customer Source',
      },
    },
    LeftDefault_ENTITLEMENTTYPE: {
      ATTESTATIONS: {
        id: 'LeftDefault_ENTITLEMENTTYPE.ATTESTATIONS',
        defaultMessage: 'Entitlement Type',
      },
    },
    LeftDefault_ENDPOINT: {
      ATTESTATIONS: {
        id: 'LeftDefault_ENDPOINT.ATTESTATIONS',
        defaultMessage: 'Endpoint',
      },
    },
    LeftDefault_SYSTEMNAME: {
      ATTESTATIONS: {
        id: 'LeftDefault_SYSTEMNAME.ATTESTATIONS',
        defaultMessage: 'System Name',
      },
    },
    LeftDefault_RISKS: {
      ATTESTATIONS: {
        id: 'LeftDefault_RISKS.ATTESTATIONS',
        defaultMessage: 'Risks',
      },
    },
    LeftDefault_LASTUSEDENDDATE: {
      ATTESTATIONS: {
        id: 'LeftDefault_LASTUSEDENDDATE.ATTESTATIONS',
        defaultMessage: 'Last Used End Date',
      },
    },
    LeftDefault_LASTCERTIFIEDCAMPAIGNNAME: {
      ATTESTATIONS: {
        id: 'LeftDefault_LASTCERTIFIEDCAMPAIGNNAME.ATTESTATIONS',
        defaultMessage: 'Last Certified Campaign Name',
      },
    },
    LeftDefault_ACCESSTHROUGH: {
      ATTESTATIONS: {
        id: 'LeftDefault_ACCESSTHROUGH.ATTESTATIONS',
        defaultMessage: 'Acces Through',
      },
    },
    LeftDefault_JRMRULES: {
      ATTESTATIONS: {
        id: 'LeftDefault_JRMRULES.ATTESTATIONS',
        defaultMessage: 'Outlier Analysis',
      },
    },
    ShowAttStep1Default_AUDITTRAIL: {
      ATTESTATIONS: {
        id: 'ShowAttStep1Default_AUDITTRAIL.ATTESTATIONS',
        defaultMessage: 'History',
      },
    },
    ShowAttStep1Default_TOTALACCOUNTS: {
      ATTESTATIONS: {
        id: 'ShowAttStep1Default_TOTALACCOUNTS.ATTESTATIONS',
        defaultMessage: 'Total Accounts',
      },
    },
    ShowAttStep1Default_EXTENDEDENDDATE: {
      ATTESTATIONS: {
        id: 'ShowAttStep1Default_EXTENDEDENDDATE.ATTESTATIONS',
        defaultMessage: 'Extended End Date',
      },
    },
    ShowAttStep1Default_UPDATEUSER: {
      ATTESTATIONS: {
        id: 'ShowAttStep1Default_UPDATEUSER.ATTESTATIONS',
        defaultMessage: 'Update User',
      },
    },
    ShowAttStep1Default_COMMENTS: {
      ATTESTATIONS: {
        id: 'ShowAttStep1Default_COMMENTS.ATTESTATIONS',
        defaultMessage: 'Comments',
      },
    },
    ShowAttStep1Default_CERTIFIED: {
      ATTESTATIONS: {
        id: 'ShowAttStep1Default_CERTIFIED.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    ShowAttStep1Default_ENDDATE: {
      ATTESTATIONS: {
        id: 'ShowAttStep1Default_ENDDATE.ATTESTATIONS',
        defaultMessage: 'End Date',
      },
    },
    'REASSIGNSTEP2.ATTESTATIONS.label': {
      ATTESTATIONS: {
        id: 'REASSIGNSTEP2.ATTESTATIONS.label',
        defaultMessage: 'Reassign',
      },
    },
    Account_ENDDATE: {
      ATTESTATIONS: {
        id: 'Account_ENDDATE.ATTESTATIONS',
        defaultMessage: 'Account End Date',
      },
    },
    Account_CREATEDON: {
      ATTESTATIONS: {
        id: 'Account_CREATEDON.ATTESTATIONS',
        defaultMessage: 'Account Created On',
      },
    },
    Ent_PRIVILIGED: {
      ATTESTATIONS: {
        id: 'Ent_PRIVILIGED.ATTESTATIONS',
        defaultMessage: 'Entitlement Privileged',
      },
    },
    Ent_SYSCRITICAL: {
      ATTESTATIONS: {
        id: 'Ent_SYSCRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement Sys Critical',
      },
    },
    Ent_ENDDATE: {
      ATTESTATIONS: {
        id: 'Ent_ENDDATE.ATTESTATIONS',
        defaultMessage: 'Entitlement End Date',
      },
    },
    Ent_SOXCRITICAL: {
      ATTESTATIONS: {
        id: 'Ent_SOXCRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement SOX Critical',
      },
    },
    Ent_GLOSSARY: {
      ATTESTATIONS: {
        id: 'Ent_GLOSSARY.ATTESTATIONS',
        defaultMessage: 'Entitlement Glossary',
      },
    },
    YES_BelongsToMe: {
      ATTESTATIONS: {
        id: 'YES_BelongsToMe.ATTESTATIONS',
        defaultMessage: 'Belongs To Me',
      },
    },
    NO_Decommission: {
      ATTESTATIONS: {
        id: 'NO_Decommission.ATTESTATIONS',
        defaultMessage: 'Decommission',
      },
    },
    DOES_NOT_BELONG_TO_ME: {
      ATTESTATIONS: {
        id: 'DOES_NOT_BELONG_TO_ME.ATTESTATIONS',
        defaultMessage: 'Does Not Belong to Me',
      },
    },
    'DoesNotBelongToMe.v2.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'DoesNotBelongToMe.v2.label.ATTESTATIONS',
        defaultMessage: 'Does Not Belong to Me',
      },
    },
    'DoesNotBelong.v2.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'DoesNotBelong.v2.label.ATTESTATIONS',
        defaultMessage: 'Does Not Belong to Me',
      },
    },
    'Decommissioned.v2.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Decommissioned.v2.label.ATTESTATIONS',
        defaultMessage: 'Decommissioned',
      },
    },
    CONSULT: {
      ATTESTATIONS: {
        id: 'CONSULT.ATTESTATIONS',
        defaultMessage: 'Consult',
      },
    },
    YES_Approve: {
      ATTESTATIONS: {
        id: 'YES_Approve.ATTESTATIONS',
        defaultMessage: 'Approve',
      },
    },
    NO_Reject: {
      ATTESTATIONS: {
        id: 'NO_Reject.ATTESTATIONS',
        defaultMessage: 'Reject',
      },
    },
    User_SECONDARYPHONE: {
      ATTESTATIONS: {
        id: 'User_SECONDARYPHONE.ATTESTATIONS',
        defaultMessage: 'Secondary Phone',
      },
    },
    User_SECONDARYEMAIL: {
      ATTESTATIONS: {
        id: 'User_SECONDARYEMAIL.ATTESTATIONS',
        defaultMessage: 'Secondary Email',
      },
    },
    User_JOBID: {
      ATTESTATIONS: {
        id: 'User_JOBID.ATTESTATIONS',
        defaultMessage: 'User Job ID',
      },
    },
    User_UPDATEDATE: {
      ATTESTATIONS: {
        id: 'User_UPDATEDATE.ATTESTATIONS',
        defaultMessage: 'User Update Date',
      },
    },
    User_CREATEDBY: {
      ATTESTATIONS: {
        id: 'User_CREATEDBY.ATTESTATIONS',
        defaultMessage: 'Created By',
      },
    },
    User_LEAVESTATUS: {
      ATTESTATIONS: {
        id: 'User_LEAVESTATUS.ATTESTATIONS',
        defaultMessage: 'Leave Status',
      },
    },
    User_PREFEREDFIRSTNAME: {
      ATTESTATIONS: {
        id: 'User_PREFEREDFIRSTNAME.ATTESTATIONS',
        defaultMessage: 'Preferred First Name',
      },
    },
    User_CUSTOMER: {
      ATTESTATIONS: {
        id: 'User_CUSTOMER.ATTESTATIONS',
        defaultMessage: 'User Customer',
      },
    },
    User_LOCALE: {
      ATTESTATIONS: {
        id: 'User_LOCALE.ATTESTATIONS',
        defaultMessage: 'User Locale',
      },
    },
    User_CUSTOMPROPERTY41: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY41.ATTESTATIONS',
        defaultMessage: 'User Custom Property 41',
      },
    },
    User_CUSTOMPROPERTY42: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY42.ATTESTATIONS',
        defaultMessage: 'User Custom Property 42',
      },
    },
    User_CUSTOMPROPERTY43: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY43.ATTESTATIONS',
        defaultMessage: 'User Custom Property 43',
      },
    },
    User_CUSTOMPROPERTY44: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY44.ATTESTATIONS',
        defaultMessage: 'User Custom Property 44',
      },
    },
    User_CUSTOMPROPERTY45: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY45.ATTESTATIONS',
        defaultMessage: 'User Custom Property 45',
      },
    },
    User_CUSTOMPROPERTY46: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY46.ATTESTATIONS',
        defaultMessage: 'User Custom Property 46',
      },
    },
    User_CUSTOMPROPERTY47: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY47.ATTESTATIONS',
        defaultMessage: 'User Custom Property 47',
      },
    },
    User_CUSTOMPROPERTY48: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY48.ATTESTATIONS',
        defaultMessage: 'User Custom Property 48',
      },
    },
    User_CUSTOMPROPERTY49: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY49.ATTESTATIONS',
        defaultMessage: 'User Custom Property 49',
      },
    },
    User_CUSTOMPROPERTY50: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY50.ATTESTATIONS',
        defaultMessage: 'User Custom Property 50',
      },
    },
    User_CUSTOMPROPERTY51: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY51.ATTESTATIONS',
        defaultMessage: 'User Custom Property 51',
      },
    },
    User_CUSTOMPROPERTY52: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY52.ATTESTATIONS',
        defaultMessage: 'User Custom Property 52',
      },
    },
    User_CUSTOMPROPERTY53: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY53.ATTESTATIONS',
        defaultMessage: 'User Custom Property 53',
      },
    },
    User_CUSTOMPROPERTY54: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY54.ATTESTATIONS',
        defaultMessage: 'User Custom Property 54',
      },
    },
    User_CUSTOMPROPERTY55: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY55.ATTESTATIONS',
        defaultMessage: 'User Custom Property 55',
      },
    },
    User_CUSTOMPROPERTY56: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY56.ATTESTATIONS',
        defaultMessage: 'User Custom Property 56',
      },
    },
    User_CUSTOMPROPERTY57: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY57.ATTESTATIONS',
        defaultMessage: 'User Custom Property 57',
      },
    },
    User_CUSTOMPROPERTY58: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY58.ATTESTATIONS',
        defaultMessage: 'User Custom Property 58',
      },
    },
    User_CUSTOMPROPERTY59: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY59.ATTESTATIONS',
        defaultMessage: 'User Custom Property 59',
      },
    },
    User_CUSTOMPROPERTY60: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY60.ATTESTATIONS',
        defaultMessage: 'User Custom Property 60',
      },
    },
    User_CUSTOMPROPERTY61: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY61.ATTESTATIONS',
        defaultMessage: 'User Custom Property 61',
      },
    },
    User_CUSTOMPROPERTY62: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY62.ATTESTATIONS',
        defaultMessage: 'User Custom Property 62',
      },
    },
    User_CUSTOMPROPERTY63: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY63.ATTESTATIONS',
        defaultMessage: 'User Custom Property 63',
      },
    },
    User_CUSTOMPROPERTY64: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY64.ATTESTATIONS',
        defaultMessage: 'User Custom Property 64',
      },
    },
    User_CUSTOMPROPERTY65: {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY65.ATTESTATIONS',
        defaultMessage: 'User Custom Property 65',
      },
    },
    serviceAccDefault_NAME: {
      ATTESTATIONS: {
        id: 'serviceAccDefault_NAME.ATTESTATIONS',
        defaultMessage: 'Name',
      },
    },
    serviceAccDefault_DISPLAYNAME: {
      ATTESTATIONS: {
        id: 'serviceAccDefault_DISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'Display Name',
      },
    },
    serviceAccDefault_SECURITYSYSTEM: {
      ATTESTATIONS: {
        id: 'serviceAccDefault_SECURITYSYSTEM.ATTESTATIONS',
        defaultMessage: 'Security System',
      },
    },
    serviceAccDefault_COMMENTS: {
      ATTESTATIONS: {
        id: 'serviceAccDefault_COMMENTS.ATTESTATIONS',
        defaultMessage: 'Comments',
      },
    },
    serviceAccDefault_AUDITTRAIL: {
      ATTESTATIONS: {
        id: 'serviceAccDefault_AUDITTRAIL.ATTESTATIONS',
        defaultMessage: 'Audit Trail',
      },
    },
    serviceAccDefault_ENDPOINTS: {
      ATTESTATIONS: {
        id: 'serviceAccDefault_ENDPOINTS.ATTESTATIONS',
        defaultMessage: 'Endpoints',
      },
    },
    serviceAccDefault_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'serviceAccDefault_DESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Description',
      },
    },
    serviceAccDefault_STATUS: {
      ATTESTATIONS: {
        id: 'serviceAccDefault_STATUS.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    JobControl: {
      ATTESTATIONS: {
        id: 'JobControl.ATTESTATION.label',
        defaultMessage: 'ATTESTATION',
      },
    },
    Account_ACCOUNTSTATUS: {
      ATTESTATIONS: {
        id: 'Account_ACCOUNTSTATUS.ATTESTATIONS',
        defaultMessage: 'Account Status',
      },
    },
    ELEMENTTYPE: {
      ATTESTATIONS: {
        id: 'ELEMENTTYPE.ATTESTATIONS',
        defaultMessage: 'Element Type',
      },
    },
    ENDPOINTNAME: {
      ATTESTATIONS: {
        id: 'ENDPOINTNAME.ATTESTATIONS',
        defaultMessage: 'Endpoint Name',
      },
    },
    Endpoint_ENDPOINTNAME: {
      ATTESTATIONS: {
        id: 'Endpoint_ENDPOINTNAME.ATTESTATIONS',
        defaultMessage: 'Endpointname',
      },
    },
    Endpoint_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'Endpoint_DESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Description',
      },
    },
    Endpoint_CUSTOMPROPERTY1: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY1.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property1',
      },
    },
    Endpoint_CUSTOMPROPERTY2: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY2.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property2',
      },
    },
    Endpoint_CUSTOMPROPERTY3: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY3.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property3',
      },
    },
    Endpoint_CUSTOMPROPERTY4: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY4.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property4',
      },
    },
    Endpoint_CUSTOMPROPERTY5: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY5.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property5',
      },
    },
    Endpoint_CUSTOMPROPERTY6: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY6.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property6',
      },
    },
    Endpoint_CUSTOMPROPERTY7: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY7.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property7',
      },
    },
    Endpoint_CUSTOMPROPERTY8: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY8.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property8',
      },
    },
    Endpoint_CUSTOMPROPERTY9: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY9.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property9',
      },
    },
    Endpoint_CUSTOMPROPERTY10: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY10.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property10',
      },
    },
    Endpoint_CUSTOMPROPERTY11: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY11.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property11',
      },
    },
    Endpoint_CUSTOMPROPERTY12: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY12.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property12',
      },
    },
    Endpoint_CUSTOMPROPERTY13: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY13.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property13',
      },
    },
    Endpoint_CUSTOMPROPERTY14: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY14.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property14',
      },
    },
    Endpoint_CUSTOMPROPERTY15: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY15.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property15',
      },
    },
    Endpoint_CUSTOMPROPERTY16: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY16.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property16',
      },
    },
    Endpoint_CUSTOMPROPERTY17: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY17.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property17',
      },
    },
    Endpoint_CUSTOMPROPERTY18: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY18.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property18',
      },
    },
    Endpoint_CUSTOMPROPERTY19: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY19.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property19',
      },
    },
    Endpoint_CUSTOMPROPERTY20: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY20.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property20',
      },
    },
    Endpoint_CUSTOMPROPERTY21: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY21.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property21',
      },
    },
    Endpoint_CUSTOMPROPERTY22: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY22.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property22',
      },
    },
    Endpoint_CUSTOMPROPERTY23: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY23.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property23',
      },
    },
    Endpoint_CUSTOMPROPERTY24: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY24.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property24',
      },
    },
    Endpoint_CUSTOMPROPERTY25: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY25.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property25',
      },
    },
    Endpoint_CUSTOMPROPERTY26: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY26.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property26',
      },
    },
    Endpoint_CUSTOMPROPERTY27: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY27.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property27',
      },
    },
    Endpoint_CUSTOMPROPERTY28: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY28.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property28',
      },
    },
    Endpoint_CUSTOMPROPERTY29: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY29.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property29',
      },
    },
    Endpoint_CUSTOMPROPERTY30: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY30.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property30',
      },
    },
    Endpoint_CUSTOMPROPERTY31: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY31.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property31',
      },
    },
    Endpoint_CUSTOMPROPERTY32: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY32.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property32',
      },
    },
    Endpoint_CUSTOMPROPERTY33: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY33.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property33',
      },
    },
    Endpoint_CUSTOMPROPERTY34: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY34.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property34',
      },
    },
    Endpoint_CUSTOMPROPERTY35: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY35.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property35',
      },
    },
    Endpoint_CUSTOMPROPERTY36: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY36.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property36',
      },
    },
    Endpoint_CUSTOMPROPERTY37: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY37.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property37',
      },
    },
    Endpoint_CUSTOMPROPERTY38: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY38.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property38',
      },
    },
    Endpoint_CUSTOMPROPERTY39: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY39.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property39',
      },
    },
    Endpoint_CUSTOMPROPERTY40: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY40.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property40',
      },
    },
    Endpoint_CUSTOMPROPERTY41: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY41.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property41',
      },
    },
    Endpoint_CUSTOMPROPERTY42: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY42.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property42',
      },
    },
    Endpoint_CUSTOMPROPERTY43: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY43.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property43',
      },
    },
    Endpoint_CUSTOMPROPERTY44: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY44.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property44',
      },
    },
    Endpoint_CUSTOMPROPERTY45: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY45.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property45',
      },
    },
    Endpoint_CUSTOMPROPERTY1LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY1LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 1 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY2LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY2LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 2 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY3LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY3LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 3 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY4LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY4LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 4 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY5LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY5LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 5 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY6LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY6LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 6 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY7LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY7LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 7 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY8LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY8LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 8 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY9LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY9LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 9 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY10LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY10LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 10 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY11LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY11LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 11 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY12LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY12LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 12 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY13LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY13LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 13 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY14LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY14LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 14 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY15LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY15LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 15 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY16LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY16LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 16 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY17LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY17LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 17 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY18LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY18LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 18 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY19LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY19LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 19 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY20LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY20LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 20 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY21LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY21LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 21 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY22LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY22LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 22 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY23LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY23LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 23 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY24LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY24LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 24 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY25LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY25LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 25 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY26LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY26LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 26 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY27LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY27LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 27 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY28LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY28LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 28 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY29LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY29LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 29 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY30LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY30LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 30 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY31LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY31LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 31 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY32LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY32LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 32 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY33LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY33LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 33 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY34LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY34LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 34 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY35LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY35LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 35 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY36LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY36LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 36 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY37LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY37LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 37 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY38LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY38LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 38 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY39LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY39LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 39 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY40LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY40LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 40 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY41LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY41LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 41 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY42LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY42LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 42 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY43LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY43LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 43 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY44LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY44LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 44 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY45LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY45LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 45 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY46LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY46LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 46 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY47LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY47LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 47 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY48LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY48LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 48 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY49LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY49LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 49 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY50LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY50LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 50 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY51LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY51LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 51 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY52LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY52LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 52 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY53LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY53LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 53 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY54LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY54LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 54 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY55LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY55LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 55 Label',
      },
    },
    Endpoint_CUSTOMPROPERTY56LABEL: {
      ATTESTATIONS: {
        id: 'Endpoint_CUSTOMPROPERTY56LABEL.ATTESTATIONS',
        defaultMessage: 'Endpoint Custom Property 56 Label',
      },
    },
    Endpoint_DISPLAYNAME: {
      ATTESTATIONS: {
        id: 'Endpoint_DISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'Displayname',
      },
    },
    Endpoint_STATUS: {
      ATTESTATIONS: {
        id: 'Endpoint_STATUS.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    Endpoint_ROLETYPEASJSON: {
      ATTESTATIONS: {
        id: 'Endpoint_ROLETYPEASJSON.ATTESTATIONS',
        defaultMessage: 'Role Type as Json',
      },
    },
    Endpoint_CREATEDBY: {
      ATTESTATIONS: {
        id: 'Endpoint_CREATEDBY.ATTESTATIONS',
        defaultMessage: 'Created By',
      },
    },
    Endpoint_UPDATEDATE: {
      ATTESTATIONS: {
        id: 'Endpoint_UPDATEDATE.ATTESTATIONS',
        defaultMessage: 'Update Date',
      },
    },
    Endpoint_CREATEDATE: {
      ATTESTATIONS: {
        id: 'Endpoint_CREATEDATE.ATTESTATIONS',
        defaultMessage: 'Create Date',
      },
    },
    Endpoint_UPDATEDBY: {
      ATTESTATIONS: {
        id: 'Endpoint_UPDATEDBY.ATTESTATIONS',
        defaultMessage: 'Updated By',
      },
    },
    Endpoint_CREATEDFROM: {
      ATTESTATIONS: {
        id: 'Endpoint_CREATEDFROM.ATTESTATIONS',
        defaultMessage: 'Created From',
      },
    },
    Endpoint_LASTREVIEWEDDATE: {
      ATTESTATIONS: {
        id: 'Endpoint_LASTREVIEWEDDATE.ATTESTATIONS',
        defaultMessage: 'Last Reviewed Date',
      },
    },
    Endpoint_LASTREVIEWEDBY: {
      ATTESTATIONS: {
        id: 'Endpoint_LASTREVIEWEDBY.ATTESTATIONS',
        defaultMessage: 'Last Reviewed By',
      },
    },
    Ent_SODDETAILDATA: {
      ATTESTATIONS: {
        id: 'Ent_SODDETAILDATA.ATTESTATIONS',
        defaultMessage: 'SOD Detail Data',
      },
    },
    Ent_CREATEDATE: {
      ATTESTATIONS: {
        id: 'Ent_CREATEDATE.ATTESTATIONS',
        defaultMessage: 'Create  Date',
      },
    },
    Role_ROLE_NAME: {
      ATTESTATIONS: {
        id: 'Role_ROLE_NAME.ATTESTATIONS',
        defaultMessage: 'Role Name',
      },
    },
    Role_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'Role_DESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Description',
      },
    },
    ROW_TYPE: {
      ATTESTATIONS: {
        id: 'ROW_TYPE.ATTESTATIONS',
        defaultMessage: 'Rows',
      },
    },
    'Role_DISPLAYNAME.CERTIFICATIONS': {
      ATTESTATIONS: {
        id: 'Role_DISPLAYNAME.CERTIFICATIONS',
        defaultMessage: 'Role',
      },
    },
    Role_STATUS: {
      ATTESTATIONS: {
        id: 'Role_STATUS.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    Role_CRITICALITY: {
      ATTESTATIONS: {
        id: 'Role_CRITICALITY.ATTESTATIONS',
        defaultMessage: 'Role Crititcality',
      },
    },
    Role_CUSTOMPROPERTY41: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY41.ATTESTATIONS',
        defaultMessage: 'CustomProperty 41',
      },
    },
    Role_CUSTOMPROPERTY42: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY42.ATTESTATIONS',
        defaultMessage: 'CustomProperty 42',
      },
    },
    Role_CUSTOMPROPERTY43: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY43.ATTESTATIONS',
        defaultMessage: 'CustomProperty 43',
      },
    },
    Role_CUSTOMPROPERTY44: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY44.ATTESTATIONS',
        defaultMessage: 'CustomProperty 44',
      },
    },
    Role_CUSTOMPROPERTY45: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY45.ATTESTATIONS',
        defaultMessage: 'CustomProperty 45',
      },
    },
    Role_CUSTOMPROPERTY46: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY46.ATTESTATIONS',
        defaultMessage: 'CustomProperty 46',
      },
    },
    Role_CUSTOMPROPERTY47: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY47.ATTESTATIONS',
        defaultMessage: 'CustomProperty 47',
      },
    },
    Role_CUSTOMPROPERTY48: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY48.ATTESTATIONS',
        defaultMessage: 'CustomProperty 48',
      },
    },
    Role_CUSTOMPROPERTY49: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY49.ATTESTATIONS',
        defaultMessage: 'CustomProperty 49',
      },
    },
    Role_CUSTOMPROPERTY50: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY50.ATTESTATIONS',
        defaultMessage: 'CustomProperty 50',
      },
    },
    Role_CUSTOMPROPERTY51: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY51.ATTESTATIONS',
        defaultMessage: 'CustomProperty 51',
      },
    },
    Role_CUSTOMPROPERTY52: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY52.ATTESTATIONS',
        defaultMessage: 'CustomProperty 52',
      },
    },
    Role_CUSTOMPROPERTY53: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY53.ATTESTATIONS',
        defaultMessage: 'CustomProperty 53',
      },
    },
    Role_CUSTOMPROPERTY54: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY54.ATTESTATIONS',
        defaultMessage: 'CustomProperty 54',
      },
    },
    Role_CUSTOMPROPERTY55: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY55.ATTESTATIONS',
        defaultMessage: 'CustomProperty 55',
      },
    },
    Role_CUSTOMPROPERTY56: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY56.ATTESTATIONS',
        defaultMessage: 'CustomProperty 56',
      },
    },
    Role_CUSTOMPROPERTY57: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY57.ATTESTATIONS',
        defaultMessage: 'CustomProperty 57',
      },
    },
    Role_CUSTOMPROPERTY58: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY58.ATTESTATIONS',
        defaultMessage: 'CustomProperty 58',
      },
    },
    Role_CUSTOMPROPERTY59: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY59.ATTESTATIONS',
        defaultMessage: 'CustomProperty 59',
      },
    },
    Role_CUSTOMPROPERTY60: {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY60.ATTESTATIONS',
        defaultMessage: 'CustomProperty 60',
      },
    },
    EntitlementType_ENTITLEMENTNAME: {
      ATTESTATIONS: {
        id: 'EntitlementType_ENTITLEMENTNAME.ATTESTATIONS',
        defaultMessage: 'Entitlement Name',
      },
    },
    EntitlementType_ENTITLEMENTDESCRIPTION: {
      ATTESTATIONS: {
        id: 'EntitlementType_ENTITLEMENTDESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Entitlement Description',
      },
    },
    EntitlementType_REQUIREDINREQUEST: {
      ATTESTATIONS: {
        id: 'EntitlementType_REQUIREDINREQUEST.ATTESTATIONS',
        defaultMessage: 'Required Inrequest',
      },
    },
    EntitlementType_CREATETASKACTION: {
      ATTESTATIONS: {
        id: 'EntitlementType_CREATETASKACTION.ATTESTATIONS',
        defaultMessage: 'Create Task Action',
      },
    },
    EntitlementType_RECON: {
      ATTESTATIONS: {
        id: 'EntitlementType_RECON.ATTESTATIONS',
        defaultMessage: 'Recon',
      },
    },
    EntitlementType_DISPLAYNAME: {
      ATTESTATIONS: {
        id: 'EntitlementType_DISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'Displayname',
      },
    },
    EntitlementType_CUSTOMPROPERTY1_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY1_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 1 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY2_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY2_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 2 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY3_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY3_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 3 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY4_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY4_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 4 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY5_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY5_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 5 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY6_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY6_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 6 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY7_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY7_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 7 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY8_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY8_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 8 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY9_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY9_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 9 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY10_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY10_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 10 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY11_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY11_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 11 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY12_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY12_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 12 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY13_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY13_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 13 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY14_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY14_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 14 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY15_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY15_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 15 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY16_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY16_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 16 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY17_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY17_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 17 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY18_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY18_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 18 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY19_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY19_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 19 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY20_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY20_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 20 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY21_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY21_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 21 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY22_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY22_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 22 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY23_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY23_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 23 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY24_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY24_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 24 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY25_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY25_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 25 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY26_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY26_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 26 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY27_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY27_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 27 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY28_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY28_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 28 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY29_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY29_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 29 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY30_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY30_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 30 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY31_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY31_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 31 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY32_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY32_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 32 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY33_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY33_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 33 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY34_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY34_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 34 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY35_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY35_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 35 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY36_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY36_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 36 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY37_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY37_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 37 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY38_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY38_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 38 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY39_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY39_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 39 label',
      },
    },
    EntitlementType_CUSTOMPROPERTY40_LABEL: {
      ATTESTATIONS: {
        id: 'EntitlementType_CUSTOMPROPERTY40_LABEL.ATTESTATIONS',
        defaultMessage: 'EntitlementType CustomProperty 40 label',
      },
    },
    ROLE_NAME: {
      ATTESTATIONS: {
        id: 'ROLE_NAME.ATTESTATIONS',
        defaultMessage: 'Role Name',
      },
    },
    ROLETYPE: {
      ATTESTATIONS: {
        id: 'ROLETYPE.ATTESTATIONS',
        defaultMessage: 'Role Type',
      },
    },
    DESCRIPTION: {
      ATTESTATIONS: {
        id: 'DESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Description',
      },
    },
    Ent_APPROVERNAME: {
      ATTESTATIONS: {
        id: 'Ent_APPROVERNAME.ATTESTATIONS',
        defaultMessage: 'Approver Level',
      },
    },
    APPROVERNAME: {
      ATTESTATIONS: {
        id: 'APPROVERNAME.ATTESTATIONS',
        defaultMessage: 'Approver Level',
      },
    },
    NAME: {
      ATTESTATIONS: {
        id: 'NAME.ATTESTATIONS',
        defaultMessage: 'Account Name',
      },
    },
    APPROVERTYPE: {
      ATTESTATIONS: {
        id: 'APPROVERTYPE.ATTESTATIONS',
        defaultMessage: 'Approver Type',
      },
    },
    APPROVERVALUE: {
      ATTESTATIONS: {
        id: 'APPROVERVALUE.ATTESTATIONS',
        defaultMessage: 'Approver Value',
      },
    },
    LASTREVIEWEDDATE: {
      ATTESTATIONS: {
        id: 'LASTREVIEWEDDATE.ATTESTATIONS',
        defaultMessage: 'Last Review Date',
      },
    },
    LASTREVIEWEDBY: {
      ATTESTATIONS: {
        id: 'LASTREVIEWEDBY.ATTESTATIONS',
        defaultMessage: 'Last Reviewed By',
      },
    },
    RE_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'RE_DESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Description',
      },
    },
    RISK: {
      ATTESTATIONS: {
        id: 'RISK.ATTESTATIONS',
        defaultMessage: 'Risk',
      },
    },
    Endpoint_LASTREVIEWEDCAMPAIGNNAME: {
      ATTESTATIONS: {
        id: 'Endpoint_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS',
        defaultMessage: 'Last Reviewed Campaign',
      },
    },
    Ent_LASTREVIEWEDCAMPAIGNNAME: {
      ATTESTATIONS: {
        id: 'Ent_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS',
        defaultMessage: 'Last Reviewed Campaign',
      },
    },
    EntitlementType_LASTREVIEWEDCAMPAIGNNAME: {
      ATTESTATIONS: {
        id: 'EntitlementType_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS',
        defaultMessage: 'Last Reviewed Campaign',
      },
    },
    Role_LASTREVIEWEDCAMPAIGNNAME: {
      ATTESTATIONS: {
        id: 'Role_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS',
        defaultMessage: 'Last Reviewed Campaign',
      },
    },
    Ent_LASTREVIEWEDDATE: {
      ATTESTATIONS: {
        id: 'Ent_LASTREVIEWEDDATE.ATTESTATIONS',
        defaultMessage: 'Last reviewed Date',
      },
    },
    Ent_LASTREVIEWEDBY: {
      ATTESTATIONS: {
        id: 'Ent_LASTREVIEWEDBY.ATTESTATIONS',
        defaultMessage: 'Last Reviewed By',
      },
    },
    Ent_PRIORITY: {
      ATTESTATIONS: {
        id: 'Ent_PRIORITY.ATTESTATIONS',
        defaultMessage: 'Entitlement Priority',
      },
    },
    ELEMENTNAME: {
      ATTESTATIONS: {
        id: 'ELEMENTNAME.ATTESTATIONS',
        defaultMessage: 'Element Name',
      },
    },
    CERTIFICATIONSTATUS: {
      ATTESTATIONS: {
        id: 'CERTIFICATIONSTATUS.ATTESTATIONS',
        defaultMessage: 'Certification Status',
      },
    },
    CERTIFIERNAME: {
      ATTESTATIONS: {
        id: 'CERTIFIERNAME.ATTESTATIONS',
        defaultMessage: 'Certifier Name',
      },
    },
    Account_NEWOWNER: {
      ATTESTATIONS: {
        id: 'Account_NEWOWNER.ATTESTATIONS',
        defaultMessage: 'Account New Owner',
      },
    },
    Account_OLDOWNER: {
      ATTESTATIONS: {
        id: 'Account_OLDOWNER.ATTESTATIONS',
        defaultMessage: 'Account Old Owner',
      },
    },
    Ent_OLDENTITLEMENTOWNER: {
      ATTESTATIONS: {
        id: 'Ent_OLDENTITLEMENTOWNER.ATTESTATIONS',
        defaultMessage: 'Entitlement Old Owner',
      },
    },
    User_CREATEDATE: {
      ATTESTATIONS: {
        id: 'User_CREATEDATE.ATTESTATIONS',
        defaultMessage: 'User Create Date',
      },
    },
    totalAccounts: {
      ATTESTATIONS: {
        id: 'totalAccounts.ATTESTATIONS',
        defaultMessage: 'Total Accounts',
      },
    },
    extendedendDate: {
      ATTESTATIONS: {
        id: 'extendedendDate.ATTESTATIONS',
        defaultMessage: 'Extended End Date',
      },
    },
    updateuser: {
      ATTESTATIONS: {
        id: 'updateuser.ATTESTATIONS',
        defaultMessage: 'Update User',
      },
    },
    certified: {
      ATTESTATIONS: {
        id: 'certified.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    CERT_USERKEY: {
      ATTESTATIONS: {
        id: 'CERT_USERKEY.ATTESTATIONS',
        defaultMessage: 'Certification User Key',
      },
    },
    DISPLAYNAME: {
      ATTESTATIONS: {
        id: 'DISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'User Display Name',
      },
    },
    USERKEY: {
      ATTESTATIONS: {
        id: 'USERKEY.ATTESTATIONS',
        defaultMessage: 'User Key',
      },
    },
    TERMDATE: {
      ATTESTATIONS: {
        id: 'TERMDATE.ATTESTATIONS',
        defaultMessage: 'User Term Date',
      },
    },
    FIRSTNAME: {
      ATTESTATIONS: {
        id: 'FIRSTNAME.ATTESTATIONS',
        defaultMessage: 'User First Name',
      },
    },
    TOTALACCOUNTS: {
      ATTESTATIONS: {
        id: 'TOTALACCOUNTS.ATTESTATIONS',
        defaultMessage: 'Total Accounts',
      },
    },
    AUDITTRAIL: {
      ATTESTATIONS: {
        id: 'AUDITTRAIL.ATTESTATIONS',
        defaultMessage: 'History',
      },
    },
    UPDATEUSER: {
      ATTESTATIONS: {
        id: 'UPDATEUSER.ATTESTATIONS',
        defaultMessage: 'Update User',
      },
    },
    LASTNAME: {
      ATTESTATIONS: {
        id: 'LASTNAME.ATTESTATIONS',
        defaultMessage: 'User Last Name',
      },
    },
    MIDDLENAME: {
      ATTESTATIONS: {
        id: 'MIDDLENAME.ATTESTATIONS',
        defaultMessage: 'User Middle Name',
      },
    },
    STREET: {
      ATTESTATIONS: {
        id: 'STREET.ATTESTATIONS',
        defaultMessage: 'User Street',
      },
    },
    CITY: {
      ATTESTATIONS: {
        id: 'CITY.ATTESTATIONS',
        defaultMessage: 'City',
      },
    },
    EMAIL: {
      ATTESTATIONS: {
        id: 'EMAIL.ATTESTATIONS',
        defaultMessage: 'User Email',
      },
    },
    STATUSKEY: {
      ATTESTATIONS: {
        id: 'STATUSKEY.ATTESTATIONS',
        defaultMessage: 'User Status',
      },
    },
    STARTDATE: {
      ATTESTATIONS: {
        id: 'STARTDATE.ATTESTATIONS',
        defaultMessage: 'User Start Date',
      },
    },
    ENDDATE: {
      ATTESTATIONS: {
        id: 'ENDDATE.ATTESTATIONS',
        defaultMessage: 'End Date',
      },
    },
    MANAGER: {
      ATTESTATIONS: {
        id: 'MANAGER.ATTESTATIONS',
        defaultMessage: 'User Manager',
      },
    },
    PASSWORD: {
      ATTESTATIONS: {
        id: 'PASSWORD.ATTESTATIONS',
        defaultMessage: 'User Password',
      },
    },
    ENABLED: {
      ATTESTATIONS: {
        id: 'ENABLED.ATTESTATIONS',
        defaultMessage: 'User Enabled',
      },
    },
    LOCATION: {
      ATTESTATIONS: {
        id: 'LOCATION.ATTESTATIONS',
        defaultMessage: 'User Location',
      },
    },
    JOBCODE: {
      ATTESTATIONS: {
        id: 'JOBCODE.ATTESTATIONS',
        defaultMessage: 'User Job Code',
      },
    },
    JOBDESCRIPTION: {
      ATTESTATIONS: {
        id: 'JOBDESCRIPTION.ATTESTATIONS',
        defaultMessage: 'User Job Description',
      },
    },
    EMPLOYEETYPE: {
      ATTESTATIONS: {
        id: 'EMPLOYEETYPE.ATTESTATIONS',
        defaultMessage: 'User Employee Type',
      },
    },
    SYSTEMUSERNAME: {
      ATTESTATIONS: {
        id: 'SYSTEMUSERNAME.ATTESTATIONS',
        defaultMessage: 'User System Username',
      },
    },
    DEPARTMENTNUMBER: {
      ATTESTATIONS: {
        id: 'DEPARTMENTNUMBER.ATTESTATIONS',
        defaultMessage: 'User Department Number',
      },
    },
    TITLE: {
      ATTESTATIONS: {
        id: 'TITLE.ATTESTATIONS',
        defaultMessage: 'User Title',
      },
    },
    STATE: {
      ATTESTATIONS: {
        id: 'STATE.ATTESTATIONS',
        defaultMessage: 'User State',
      },
    },
    COMPANYNAME: {
      ATTESTATIONS: {
        id: 'COMPANYNAME.ATTESTATIONS',
        defaultMessage: 'User Company Name',
      },
    },
    COSTCENTER: {
      ATTESTATIONS: {
        id: 'COSTCENTER.ATTESTATIONS',
        defaultMessage: 'User Cost Centre',
      },
    },
    DEPARTMENTNAME: {
      ATTESTATIONS: {
        id: 'DEPARTMENTNAME.ATTESTATIONS',
        defaultMessage: 'User Department Name',
      },
    },
    EMPLOYEECLASS: {
      ATTESTATIONS: {
        id: 'EMPLOYEECLASS.ATTESTATIONS',
        defaultMessage: 'User Employee Class',
      },
    },
    ENTITY: {
      ATTESTATIONS: {
        id: 'ENTITY.ATTESTATIONS',
        defaultMessage: 'User Entity',
      },
    },
    JOBCODEDESC: {
      ATTESTATIONS: {
        id: 'JOBCODEDESC.ATTESTATIONS',
        defaultMessage: 'User Job Code Description',
      },
    },
    LOCATIONDESC: {
      ATTESTATIONS: {
        id: 'LOCATIONDESC.ATTESTATIONS',
        defaultMessage: 'User Location Description',
      },
    },
    LOCATIONNUMBER: {
      ATTESTATIONS: {
        id: 'LOCATIONNUMBER.ATTESTATIONS',
        defaultMessage: 'User Location Number',
      },
    },
    SITEID: {
      ATTESTATIONS: {
        id: 'SITEID.ATTESTATIONS',
        defaultMessage: 'User Site',
      },
    },
    ORGUNITID: {
      ATTESTATIONS: {
        id: 'ORGUNITID.ATTESTATIONS',
        defaultMessage: 'User Organization Unit',
      },
    },
    REGION: {
      ATTESTATIONS: {
        id: 'REGION.ATTESTATIONS',
        defaultMessage: 'User Region',
      },
    },
    REGIONCODE: {
      ATTESTATIONS: {
        id: 'REGIONCODE.ATTESTATIONS',
        defaultMessage: 'User Region Code',
      },
    },
    OWNER: {
      ATTESTATIONS: {
        id: 'OWNER.ATTESTATIONS',
        defaultMessage: 'User Owner',
      },
    },
    EMPLOYEEID: {
      ATTESTATIONS: {
        id: 'EMPLOYEEID.ATTESTATIONS',
        defaultMessage: 'User Employee',
      },
    },
    LASTSYNCDATE: {
      ATTESTATIONS: {
        id: 'LASTSYNCDATE.ATTESTATIONS',
        defaultMessage: 'User Last Sync Date',
      },
    },
    PHONENUMBER: {
      ATTESTATIONS: {
        id: 'PHONENUMBER.ATTESTATIONS',
        defaultMessage: 'User Phone Number',
      },
    },
    COUNTRY: {
      ATTESTATIONS: {
        id: 'COUNTRY.ATTESTATIONS',
        defaultMessage: 'User Country',
      },
    },
    ACCOUNTEXPIRED: {
      ATTESTATIONS: {
        id: 'ACCOUNTEXPIRED.ATTESTATIONS',
        defaultMessage: 'User Account Expired',
      },
    },
    ACCOUNTLOCKED: {
      ATTESTATIONS: {
        id: 'ACCOUNTLOCKED.ATTESTATIONS',
        defaultMessage: 'User Account Locked',
      },
    },
    PASSWORDEXPIRED: {
      ATTESTATIONS: {
        id: 'PASSWORDEXPIRED.ATTESTATIONS',
        defaultMessage: 'User Password Expired',
      },
    },
    JOB_FUNCTION: {
      ATTESTATIONS: {
        id: 'JOB_FUNCTION.ATTESTATIONS',
        defaultMessage: 'User Job Function',
      },
    },
    DONOTDISTURBDELEGATE: {
      ATTESTATIONS: {
        id: 'DONOTDISTURBDELEGATE.ATTESTATIONS',
        defaultMessage: 'User Do Not Disturb Delegate',
      },
    },
    CUSTOMPROPERTY1: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY1.ATTESTATIONS',
        defaultMessage: 'User Custom Property 1',
      },
    },
    CUSTOMPROPERTY2: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY2.ATTESTATIONS',
        defaultMessage: 'User Custom Property 2',
      },
    },
    CUSTOMPROPERTY3: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY3.ATTESTATIONS',
        defaultMessage: 'User Custom Property 3',
      },
    },
    CUSTOMPROPERTY4: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY4.ATTESTATIONS',
        defaultMessage: 'User Custom Property 4',
      },
    },
    CUSTOMPROPERTY5: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY5.ATTESTATIONS',
        defaultMessage: 'User Custom Property 5',
      },
    },
    CUSTOMPROPERTY6: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY6.ATTESTATIONS',
        defaultMessage: 'User Custom Property 6',
      },
    },
    CUSTOMPROPERTY7: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY7.ATTESTATIONS',
        defaultMessage: 'User Custom Property 7',
      },
    },
    CUSTOMPROPERTY8: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY8.ATTESTATIONS',
        defaultMessage: 'User Custom Property 8',
      },
    },
    CUSTOMPROPERTY9: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY9.ATTESTATIONS',
        defaultMessage: 'User Custom Property 9',
      },
    },
    CUSTOMPROPERTY10: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY10.ATTESTATIONS',
        defaultMessage: 'User Custom Property 10',
      },
    },
    CUSTOMPROPERTY11: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY11.ATTESTATIONS',
        defaultMessage: 'User Custom Property 11',
      },
    },
    CUSTOMPROPERTY12: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY12.ATTESTATIONS',
        defaultMessage: 'User Custom Property 12',
      },
    },
    CUSTOMPROPERTY13: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY13.ATTESTATIONS',
        defaultMessage: 'User Custom Property 13',
      },
    },
    CUSTOMPROPERTY14: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY14.ATTESTATIONS',
        defaultMessage: 'User Custom Property 14',
      },
    },
    CUSTOMPROPERTY15: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY15.ATTESTATIONS',
        defaultMessage: 'User Custom Property 15',
      },
    },
    CUSTOMPROPERTY16: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY16.ATTESTATIONS',
        defaultMessage: 'User Custom Property 16',
      },
    },
    CUSTOMPROPERTY17: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY17.ATTESTATIONS',
        defaultMessage: 'User Custom Property 17',
      },
    },
    CUSTOMPROPERTY18: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY18.ATTESTATIONS',
        defaultMessage: 'User Custom Property 18',
      },
    },
    CUSTOMPROPERTY19: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY19.ATTESTATIONS',
        defaultMessage: 'User Custom Property 19',
      },
    },
    CUSTOMPROPERTY20: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY20.ATTESTATIONS',
        defaultMessage: 'User Custom Property 20',
      },
    },
    CUSTOMPROPERTY21: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY21.ATTESTATIONS',
        defaultMessage: 'User Custom Property 21',
      },
    },
    CUSTOMPROPERTY22: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY22.ATTESTATIONS',
        defaultMessage: 'User Custom Property 22',
      },
    },
    CUSTOMPROPERTY23: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY23.ATTESTATIONS',
        defaultMessage: 'User Custom Property 23',
      },
    },
    CUSTOMPROPERTY24: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY24.ATTESTATIONS',
        defaultMessage: 'User Custom Property 24',
      },
    },
    CUSTOMPROPERTY25: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY25.ATTESTATIONS',
        defaultMessage: 'User Custom Property 25',
      },
    },
    CUSTOMPROPERTY26: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY26.ATTESTATIONS',
        defaultMessage: 'User Custom Property 26',
      },
    },
    CUSTOMPROPERTY27: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY27.ATTESTATIONS',
        defaultMessage: 'User Custom Property 27',
      },
    },
    CUSTOMPROPERTY28: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY28.ATTESTATIONS',
        defaultMessage: 'User Custom Property 28',
      },
    },
    CUSTOMPROPERTY29: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY29.ATTESTATIONS',
        defaultMessage: 'User Custom Property 29',
      },
    },
    CUSTOMPROPERTY30: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY30.ATTESTATIONS',
        defaultMessage: 'User Custom Property 30',
      },
    },
    CUSTOMPROPERTY31: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY31.ATTESTATIONS',
        defaultMessage: 'User Custom Property 31',
      },
    },
    CUSTOMPROPERTY32: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY32.ATTESTATIONS',
        defaultMessage: 'User Custom Property 32',
      },
    },
    CUSTOMPROPERTY33: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY33.ATTESTATIONS',
        defaultMessage: 'User Custom Property 33',
      },
    },
    CUSTOMPROPERTY34: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY34.ATTESTATIONS',
        defaultMessage: 'User Custom Property 34',
      },
    },
    CUSTOMPROPERTY35: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY35.ATTESTATIONS',
        defaultMessage: 'User Custom Property 35',
      },
    },
    CUSTOMPROPERTY36: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY36.ATTESTATIONS',
        defaultMessage: 'User Custom Property 36',
      },
    },
    CUSTOMPROPERTY37: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY37.ATTESTATIONS',
        defaultMessage: 'User Custom Property 37',
      },
    },
    CUSTOMPROPERTY38: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY38.ATTESTATIONS',
        defaultMessage: 'User Custom Property 38',
      },
    },
    CUSTOMPROPERTY39: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY39.ATTESTATIONS',
        defaultMessage: 'User Custom Property 39',
      },
    },
    CUSTOMPROPERTY40: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY40.ATTESTATIONS',
        defaultMessage: 'User Custom Property 40',
      },
    },
    CUSTOMPROPERTY41: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY41.ATTESTATIONS',
        defaultMessage: 'User Custom Property 41',
      },
    },
    CUSTOMPROPERTY42: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY42.ATTESTATIONS',
        defaultMessage: 'User Custom Property 42',
      },
    },
    CUSTOMPROPERTY43: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY43.ATTESTATIONS',
        defaultMessage: 'User Custom Property 43',
      },
    },
    CUSTOMPROPERTY44: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY44.ATTESTATIONS',
        defaultMessage: 'User Custom Property 44',
      },
    },
    CUSTOMPROPERTY45: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY45.ATTESTATIONS',
        defaultMessage: 'User Custom Property 45',
      },
    },
    CUSTOMPROPERTY46: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY46.ATTESTATIONS',
        defaultMessage: 'User Custom Property 46',
      },
    },
    CUSTOMPROPERTY47: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY47.ATTESTATIONS',
        defaultMessage: 'User Custom Property 47',
      },
    },
    CUSTOMPROPERTY48: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY48.ATTESTATIONS',
        defaultMessage: 'User Custom Property 48',
      },
    },
    CUSTOMPROPERTY49: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY49.ATTESTATIONS',
        defaultMessage: 'User Custom Property 49',
      },
    },
    CUSTOMPROPERTY50: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY50.ATTESTATIONS',
        defaultMessage: 'User Custom Property 50',
      },
    },
    CUSTOMPROPERTY51: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY51.ATTESTATIONS',
        defaultMessage: 'User Custom Property 51',
      },
    },
    CUSTOMPROPERTY52: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY52.ATTESTATIONS',
        defaultMessage: 'User Custom Property 52',
      },
    },
    CUSTOMPROPERTY53: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY53.ATTESTATIONS',
        defaultMessage: 'User Custom Property 53',
      },
    },
    CUSTOMPROPERTY54: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY54.ATTESTATIONS',
        defaultMessage: 'User Custom Property 54',
      },
    },
    CUSTOMPROPERTY55: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY55.ATTESTATIONS',
        defaultMessage: 'User Custom Property 55',
      },
    },
    CUSTOMPROPERTY56: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY56.ATTESTATIONS',
        defaultMessage: 'User Custom Property 56',
      },
    },
    CUSTOMPROPERTY57: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY57.ATTESTATIONS',
        defaultMessage: 'User Custom Property 57',
      },
    },
    CUSTOMPROPERTY58: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY58.ATTESTATIONS',
        defaultMessage: 'User Custom Property 58',
      },
    },
    CUSTOMPROPERTY59: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY59.ATTESTATIONS',
        defaultMessage: 'User Custom Property 59',
      },
    },
    CUSTOMPROPERTY60: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY60.ATTESTATIONS',
        defaultMessage: 'User Custom Property 60',
      },
    },
    CUSTOMPROPERTY61: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY61.ATTESTATIONS',
        defaultMessage: 'User Custom Property 61',
      },
    },
    CUSTOMPROPERTY62: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY62.ATTESTATIONS',
        defaultMessage: 'User Custom Property 62',
      },
    },
    CUSTOMPROPERTY63: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY63.ATTESTATIONS',
        defaultMessage: 'User Custom Property 63',
      },
    },
    CUSTOMPROPERTY64: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY64.ATTESTATIONS',
        defaultMessage: 'User Custom Property 64',
      },
    },
    CUSTOMPROPERTY65: {
      ATTESTATIONS: {
        id: 'CUSTOMPROPERTY65.ATTESTATIONS',
        defaultMessage: 'User Custom Property 65',
      },
    },
    RISKSCORE: {
      ATTESTATIONS: {
        id: 'RISKSCORE.ATTESTATIONS',
        defaultMessage: 'User Risk Score',
      },
    },
    EXTENDEDENDDATE: {
      ATTESTATIONS: {
        id: 'EXTENDEDENDDATE.ATTESTATIONS',
        defaultMessage: 'User Extended Date',
      },
    },
    LASTCERTIFIEDDATE: {
      ATTESTATIONS: {
        id: 'LASTCERTIFIEDDATE.ATTESTATIONS',
        defaultMessage: 'Last Certified Date',
      },
    },
    CREATEDATE: {
      ATTESTATIONS: {
        id: 'CREATEDATE.ATTESTATIONS',
        defaultMessage: 'User Create Date',
      },
    },
    CREATEDBY: {
      ATTESTATIONS: {
        id: 'CREATEDBY.ATTESTATIONS',
        defaultMessage: 'created By',
      },
    },
    SECONDARYPHONE: {
      ATTESTATIONS: {
        id: 'SECONDARYPHONE.ATTESTATIONS',
        defaultMessage: 'User Secondary Phone',
      },
    },
    SECONDARYEMAIL: {
      ATTESTATIONS: {
        id: 'SECONDARYEMAIL.ATTESTATIONS',
        defaultMessage: 'User Secondary Email',
      },
    },
    PREFEREDFIRSTNAME: {
      ATTESTATIONS: {
        id: 'PREFEREDFIRSTNAME.ATTESTATIONS',
        defaultMessage: 'User Prefered First Name',
      },
    },
    LEAVESTATUS: {
      ATTESTATIONS: {
        id: 'LEAVESTATUS.ATTESTATIONS',
        defaultMessage: 'User Leave Status',
      },
    },
    OLDVALUE: {
      ATTESTATIONS: {
        id: 'OLDVALUE.ATTESTATIONS',
        defaultMessage: 'Old Value',
      },
    },
    NEWVALUE: {
      ATTESTATIONS: {
        id: 'NEWVALUE.ATTESTATIONS',
        defaultMessage: 'New Value',
      },
    },
    FIELDNAME: {
      ATTESTATIONS: {
        id: 'FIELDNAME.ATTESTATIONS',
        defaultMessage: 'Field Name',
      },
    },
    MODIFIEDON: {
      ATTESTATIONS: {
        id: 'MODIFIEDON.ATTESTATIONS',
        defaultMessage: 'Modified On',
      },
    },
    User_USERCOMMENTS: {
      ATTESTATIONS: {
        id: 'User_USERCOMMENTS.ATTESTATIONS',
        defaultMessage: 'User Comments',
      },
    },
    User_CERTCOMMENTS: {
      ATTESTATIONS: {
        id: 'User_CERTCOMMENTS.ATTESTATIONS',
        defaultMessage: 'Comments',
      },
    },
    Account_CUSTOMPROPERTY57: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY57.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 57',
      },
    },
    Account_CUSTOMPROPERTY58: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY58.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 58',
      },
    },
    Account_CUSTOMPROPERTY59: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY59.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 59',
      },
    },
    Account_CUSTOMPROPERTY60: {
      ATTESTATIONS: {
        id: 'Account_CUSTOMPROPERTY60.ATTESTATIONS',
        defaultMessage: 'Account Custom Property 60',
      },
    },
    ACTN: {
      ATTESTATIONS: {
        id: 'ACTN.ATTESTATIONS',
        defaultMessage: 'ACTION',
      },
    },
    ENTSTATUS: {
      ATTESTATIONS: {
        id: 'ENTSTATUS.ATTESTATIONS',
        defaultMessage: 'Entitlement Status',
      },
    },
    ACCOUNTCERTFIED: {
      ATTESTATIONS: {
        id: 'ACCOUNTCERTFIED.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    ENT2CERTIFIED: {
      ATTESTATIONS: {
        id: 'ENT2CERTIFIED.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    ENTDISPLAYNAME: {
      ATTESTATIONS: {
        id: 'ENTDISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'Entitlement Display Name',
      },
    },
    ENTCERTIFIED: {
      ATTESTATIONS: {
        id: 'ENTCERTIFIED.ATTESTATIONS',
        defaultMessage: 'Status',
      },
    },
    Ent_SODFLAG: {
      ATTESTATIONS: {
        id: 'Ent_SODFLAG.ATTESTATIONS',
        defaultMessage: 'Entitlement SOD Flag',
      },
    },
    Ent2_SODFLAG: {
      ATTESTATIONS: {
        id: 'Ent2_SODFLAG.ATTESTATIONS',
        defaultMessage: 'Entitlement SOD Flag',
      },
    },
    Ent2_CERT_ENTITLEMEnt2_VALUEKEY: {
      ATTESTATIONS: {
        id: 'Ent2_CERT_ENTITLEMEnt2_VALUEKEY.ATTESTATIONS',
        defaultMessage: 'Certification Entitlement Value Key',
      },
    },
    Ent2_ENTITLEMEnt2_VALUEKEY: {
      ATTESTATIONS: {
        id: 'Ent2_ENTITLEMEnt2_VALUEKEY.ATTESTATIONS',
        defaultMessage: 'Entitlement Value Key',
      },
    },
    Ent2_ENTITLEMEnt2_VALUE: {
      ATTESTATIONS: {
        id: 'Ent2_ENTITLEMEnt2_VALUE.ATTESTATIONS',
        defaultMessage: 'Entitlement Value',
      },
    },
    Ent2_ENTITLEMENTTYPEKEY: {
      ATTESTATIONS: {
        id: 'Ent2_ENTITLEMENTTYPEKEY.ATTESTATIONS',
        defaultMessage: 'Entitlement Type Key',
      },
    },
    Ent2_CUSTOMPROPERTY1: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY1.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 1',
      },
    },
    Ent2_CUSTOMPROPERTY2: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY2.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 2',
      },
    },
    Ent2_CUSTOMPROPERTY3: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY3.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 3',
      },
    },
    Ent2_CUSTOMPROPERTY4: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY4.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 4',
      },
    },
    Ent2_CUSTOMPROPERTY5: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY5.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 5',
      },
    },
    Ent2_CUSTOMPROPERTY6: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY6.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 6',
      },
    },
    Ent2_CUSTOMPROPERTY7: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY7.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 7',
      },
    },
    Ent2_CUSTOMPROPERTY8: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY8.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 8',
      },
    },
    Ent2_CUSTOMPROPERTY9: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY9.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 9',
      },
    },
    Ent2_CUSTOMPROPERTY10: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY10.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 10',
      },
    },
    Ent2_CUSTOMPROPERTY11: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY11.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 11',
      },
    },
    Ent2_CUSTOMPROPERTY12: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY12.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 12',
      },
    },
    Ent2_CUSTOMPROPERTY13: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY13.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 13',
      },
    },
    Ent2_CUSTOMPROPERTY14: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY14.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 14',
      },
    },
    Ent2_CUSTOMPROPERTY15: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY15.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 15',
      },
    },
    Ent2_CUSTOMPROPERTY16: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY16.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 16',
      },
    },
    Ent2_CUSTOMPROPERTY17: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY17.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 17',
      },
    },
    Ent2_CUSTOMPROPERTY18: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY18.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 18',
      },
    },
    Ent2_CUSTOMPROPERTY19: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY19.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 19',
      },
    },
    Ent2_CUSTOMPROPERTY20: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY20.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 20',
      },
    },
    Ent2_CUSTOMPROPERTY21: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY21.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 21',
      },
    },
    Ent2_CUSTOMPROPERTY22: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY22.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 22',
      },
    },
    Ent2_CUSTOMPROPERTY23: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY23.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 23',
      },
    },
    Ent2_CUSTOMPROPERTY24: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY24.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 24',
      },
    },
    Ent2_CUSTOMPROPERTY25: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY25.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 25',
      },
    },
    Ent2_CUSTOMPROPERTY26: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY26.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 26',
      },
    },
    Ent2_CUSTOMPROPERTY27: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY27.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 27',
      },
    },
    Ent2_CUSTOMPROPERTY28: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY28.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 28',
      },
    },
    Ent2_CUSTOMPROPERTY29: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY29.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 29',
      },
    },
    Ent2_CUSTOMPROPERTY30: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY30.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 30',
      },
    },
    Ent2_CUSTOMPROPERTY31: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY31.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 31',
      },
    },
    Ent2_CUSTOMPROPERTY32: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY32.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 32',
      },
    },
    Ent2_CUSTOMPROPERTY33: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY33.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 33',
      },
    },
    Ent2_CUSTOMPROPERTY34: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY34.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 34',
      },
    },
    Ent2_CUSTOMPROPERTY35: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY35.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 35',
      },
    },
    Ent2_CUSTOMPROPERTY36: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY36.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 36',
      },
    },
    Ent2_CUSTOMPROPERTY37: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY37.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 37',
      },
    },
    Ent2_CUSTOMPROPERTY38: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY38.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 38',
      },
    },
    Ent2_CUSTOMPROPERTY39: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY39.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 39',
      },
    },
    Ent2_CUSTOMPROPERTY40: {
      ATTESTATIONS: {
        id: 'Ent2_CUSTOMPROPERTY40.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 40',
      },
    },
    Ent2_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'Ent2_DESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Entitlement Description',
      },
    },
    Ent2_ENTITLEMENT_GLOSSARY: {
      ATTESTATIONS: {
        id: 'Ent2_ENTITLEMENT_GLOSSARY.ATTESTATIONS',
        defaultMessage: 'Entitlement Glossary',
      },
    },
    Ent2_STATUS: {
      ATTESTATIONS: {
        id: 'Ent2_STATUS.ATTESTATIONS',
        defaultMessage: 'Entitlement Status',
      },
    },
    Ent2_UPDATEUSER: {
      ATTESTATIONS: {
        id: 'Ent2_UPDATEUSER.ATTESTATIONS',
        defaultMessage: 'Entitlement Update User',
      },
    },
    Ent2_RISK: {
      ATTESTATIONS: {
        id: 'Ent2_RISK.ATTESTATIONS',
        defaultMessage: 'Entitlement Risk',
      },
    },
    Ent2_SOX_CRITICAL: {
      ATTESTATIONS: {
        id: 'Ent2_SOX_CRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement SOX Critical',
      },
    },
    Ent2_SOXCRITICAL: {
      ATTESTATIONS: {
        id: 'Ent2_SOXCRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement SOX Critical',
      },
    },
    Ent2_SYS_CRITICAL: {
      ATTESTATIONS: {
        id: 'Ent2_SYS_CRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement Sys Critical',
      },
    },
    Ent2_SYSCRITICAL: {
      ATTESTATIONS: {
        id: 'Ent2_SYSCRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement Sys Critical',
      },
    },
    Ent2_ORPHAN: {
      ATTESTATIONS: {
        id: 'Ent2_ORPHAN.ATTESTATIONS',
        defaultMessage: 'Entitlement Orphan',
      },
    },
    Ent2_UPDATEDATE: {
      ATTESTATIONS: {
        id: 'Ent2_UPDATEDATE.ATTESTATIONS',
        defaultMessage: 'Entitlement Update Date',
      },
    },
    Ent2_SAVLEVEL: {
      ATTESTATIONS: {
        id: 'Ent2_SAVLEVEL.ATTESTATIONS',
        defaultMessage: 'Entitlement SAV Level',
      },
    },
    Ent2_LEVEL: {
      ATTESTATIONS: {
        id: 'Ent2_LEVEL.ATTESTATIONS',
        defaultMessage: 'Entitlement SAV Level',
      },
    },
    Ent2_PRIVILEGED: {
      ATTESTATIONS: {
        id: 'Ent2_PRIVILEGED.ATTESTATIONS',
        defaultMessage: 'Entitlement Privileged',
      },
    },
    Ent2_PRIVILIGED: {
      ATTESTATIONS: {
        id: 'Ent2_PRIVILIGED.ATTESTATIONS',
        defaultMessage: 'Entitlement Privileged',
      },
    },
    Ent2_CONFIDENTIALITY: {
      ATTESTATIONS: {
        id: 'Ent2_CONFIDENTIALITY.ATTESTATIONS',
        defaultMessage: 'Entitlement Confidentiality',
      },
    },
    Ent2_SOD: {
      ATTESTATIONS: {
        id: 'Ent2_SOD.ATTESTATIONS',
        defaultMessage: 'Entitlement SOD',
      },
    },
    Ent2_DISPLAYNAME: {
      ATTESTATIONS: {
        id: 'Ent2_DISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'Entitlement Display Name',
      },
    },
    'Ent2_DISPLAYNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent2_DISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'Entitlement Display Name',
      },
    },
    Ent2_ENTITLEMENTID: {
      ATTESTATIONS: {
        id: 'Ent2_ENTITLEMENTID.ATTESTATIONS',
        defaultMessage: 'Entitlement ID',
      },
    },
    Ent2_PROGRAM: {
      ATTESTATIONS: {
        id: 'Ent2_PROGRAM.ATTESTATIONS',
        defaultMessage: 'Entitlement Program',
      },
    },
    Ent2_MODULE: {
      ATTESTATIONS: {
        id: 'Ent2_MODULE.ATTESTATIONS',
        defaultMessage: 'Entitlement Module',
      },
    },
    Ent2_ACCESS: {
      ATTESTATIONS: {
        id: 'Ent2_ACCESS.ATTESTATIONS',
        defaultMessage: 'Entitlement Access',
      },
    },
    Ent2_SCHEMANAME: {
      ATTESTATIONS: {
        id: 'Ent2_SCHEMANAME.ATTESTATIONS',
        defaultMessage: 'Entitlement Schema Name',
      },
    },
    Ent2_ENTCLASS: {
      ATTESTATIONS: {
        id: 'Ent2_ENTCLASS.ATTESTATIONS',
        defaultMessage: 'Entitlement Classification',
      },
    },
    Ent2_LASTSCANDATE: {
      ATTESTATIONS: {
        id: 'Ent2_LASTSCANDATE.ATTESTATIONS',
        defaultMessage: 'Entitlement Last Scan Date',
      },
    },
    Ent2_ENTITLEMGLOSSARY: {
      ATTESTATIONS: {
        id: 'Ent2_ENTITLEMGLOSSARY.ATTESTATIONS',
        defaultMessage: 'Entitlement Glossary',
      },
    },
    Ent2_JOBID: {
      ATTESTATIONS: {
        id: 'Ent2_JOBID.ATTESTATIONS',
        defaultMessage: 'Entitlement Job ID',
      },
    },
    Ent2_LASTREVIEWEDDATE: {
      ATTESTATIONS: {
        id: 'Ent2_LASTREVIEWEDDATE.ATTESTATIONS',
        defaultMessage: 'Last reviewed Date',
      },
    },
    Ent2_LASTREVIEWEDBY: {
      ATTESTATIONS: {
        id: 'Ent2_LASTREVIEWEDBY.ATTESTATIONS',
        defaultMessage: 'Last Reviewed By',
      },
    },
    Ent2_LASTREVIEWEDCAMPAIGNNAME: {
      ATTESTATIONS: {
        id: 'Ent2_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS',
        defaultMessage: 'Last Reviewed Campaign',
      },
    },
    User_NEWMANAGER: {
      ATTESTATIONS: {
        id: 'User_NEWMANAGER.ATTESTATIONS',
        defaultMessage: 'User New Manager',
      },
    },
    USERCOUNT: {
      ATTESTATIONS: {
        id: 'USERCOUNT.ATTESTATIONS',
        defaultMessage: 'Accounts',
      },
    },
    CHILDCOUNT: {
      ATTESTATIONS: {
        id: 'CHILDCOUNT.ATTESTATIONS',
        defaultMessage: 'Child Entitlements',
      },
    },
    ENTCOMMENTS: {
      ATTESTATIONS: {
        id: 'ENTCOMMENTS.ATTESTATIONS',
        defaultMessage: 'Comments',
      },
    },
    ACCCOMMENT: {
      ATTESTATIONS: {
        id: 'ACCCOMMENT.ATTESTATIONS',
        defaultMessage: 'Comments',
      },
    },
    ACC_AUDIT_TRAIL: {
      ATTESTATIONS: {
        id: 'ACC_AUDIT_TRAIL.ATTESTATIONS',
        defaultMessage: 'History',
      },
    },
    ENT2COMMENTS: {
      ATTESTATIONS: {
        id: 'ENT2COMMENTS.ATTESTATIONS',
        defaultMessage: 'Comments',
      },
    },
    ENT2_AUDIT_TRAIL: {
      ATTESTATIONS: {
        id: 'ENT2_AUDIT_TRAIL.ATTESTATIONS',
        defaultMessage: 'History',
      },
    },
    ENT2NAME: {
      ATTESTATIONS: {
        id: 'ENT2NAME.ATTESTATIONS',
        defaultMessage: 'Child Entitlement',
      },
    },
    ENTTYPE: {
      ATTESTATIONS: {
        id: 'ENTTYPE.ATTESTATIONS',
        defaultMessage: 'Entitlement Type',
      },
    },
    User_ENTSODRISKS: {
      ATTESTATIONS: {
        id: 'User_ENTSODRISKS.ATTESTATIONS',
        defaultMessage: 'SOD Risks',
      },
    },
    SODRISKCOUNT: {
      ATTESTATIONS: {
        id: 'SODRISKCOUNT.ATTESTATIONS',
        defaultMessage: 'SOD Risks',
      },
    },
    Account_TOTALUSAGE: {
      ATTESTATIONS: {
        id: 'Account_TOTALUSAGE.ATTESTATIONS',
        defaultMessage: 'Total Usage',
      },
    },
    Account_UPDATEUSER: {
      ATTESTATIONS: {
        id: 'Account_UPDATEUSER.ATTESTATIONS',
        defaultMessage: 'Account Update User',
      },
    },
    Account_LASTCERTIFIEDACTION: {
      ATTESTATIONS: {
        id: 'Account_LASTCERTIFIEDACTION.ATTESTATIONS',
        defaultMessage: 'Last Certified Action',
      },
    },
    Account_LASTCERTIFIEDCOMMENT: {
      ATTESTATIONS: {
        id: 'Account_LASTCERTIFIEDCOMMENT.ATTESTATIONS',
        defaultMessage: 'Last Certified Comment',
      },
    },
    Role_NEWROLEOWNER: {
      ATTESTATIONS: {
        id: 'Role_NEWROLEOWNER.ATTESTATIONS',
        defaultMessage: 'New Role Owner',
      },
    },
    Role_OLDROLEOWNER: {
      ATTESTATIONS: {
        id: 'Role_OLDROLEOWNER.ATTESTATIONS',
        defaultMessage: 'Old Role Owner',
      },
    },
    User_USERSOURCE: {
      ATTESTATIONS: {
        id: 'User_USERSOURCE.ATTESTATIONS',
        defaultMessage: 'User Source',
      },
    },
    User_SOURCELASTLOGINDATE: {
      ATTESTATIONS: {
        id: 'User_SOURCELASTLOGINDATE.ATTESTATIONS',
        defaultMessage: 'Source Last Login Date',
      },
    },
    SOURCELASTLOGINDATE: {
      ATTESTATIONS: {
        id: 'SOURCELASTLOGINDATE.ATTESTATIONS',
        defaultMessage: 'Source Last Login Date',
      },
    },
    User_JRMRULES: {
      ATTESTATIONS: {
        id: 'User_JRMRULES.ATTESTATIONS',
        defaultMessage: 'Outlier Analysis',
      },
    },
    JSON_JRMRULESAVAILABLE: {
      ATTESTATIONS: {
        id: 'JSON_JRMRULESAVAILABLE.ATTESTATIONS',
        defaultMessage: 'Outlier Analysis',
      },
    },
    CUSTOMER: {
      ATTESTATIONS: {
        id: 'CUSTOMER.ATTESTATIONS',
        defaultMessage: 'User Customer',
      },
    },
    Ent_ENDPOINT: {
      ATTESTATIONS: {
        id: 'Ent_ENDPOINT.ATTESTATIONS',
        defaultMessage: 'Endpoint Name',
      },
    },
    Ent_ENTTYPE: {
      ATTESTATIONS: {
        id: 'Ent_ENTTYPE.ATTESTATIONS',
        defaultMessage: 'Entitlement Type',
      },
    },
    User_ENTDISPLAYNAME: {
      ATTESTATIONS: {
        id: 'User_ENTDISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'Entitlement Display Name',
      },
    },
    User_ENDPOINT: {
      ATTESTATIONS: {
        id: 'User_ENDPOINT.ATTESTATIONS',
        defaultMessage: 'Endpoint Name',
      },
    },
    User_ENTTYPE: {
      ATTESTATIONS: {
        id: 'User_ENTTYPE.ATTESTATIONS',
        defaultMessage: 'Entitlement Type',
      },
    },
    Ent2_ENDPOINT: {
      ATTESTATIONS: {
        id: 'Ent2_ENDPOINT.ATTESTATIONS',
        defaultMessage: 'Endpoint Name',
      },
    },
    Ent2_ENTTYPE: {
      ATTESTATIONS: {
        id: 'Ent2_ENTTYPE.ATTESTATIONS',
        defaultMessage: 'Entitlement Type',
      },
    },
    NoActionRequired: {
      ATTESTATIONS: {
        id: 'NoActionRequired.v2.label.ATTESTATIONS',
        defaultMessage: 'No Action Required',
      },
    },
    'No Action Required': {
      ATTESTATIONS: {
        id: 'NoActionRequired.v2.label.ATTESTATIONS',
        defaultMessage: 'No Action Required',
      },
    },
    'Done.v2.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Done.v2.label.ATTESTATIONS',
        defaultMessage: 'Done',
      },
    },
    Done: {
      ATTESTATIONS: {
        id: 'Done.v2.label.ATTESTATIONS',
        defaultMessage: 'Done',
      },
    },
    'Progress.v2.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Progress.v2.label.ATTESTATIONS',
        defaultMessage: 'Progress',
      },
    },
    Progress: {
      ATTESTATIONS: {
        id: 'Progress.v2.label.ATTESTATIONS',
        defaultMessage: 'Progress',
      },
    },
    EndDateChanged: {
      ATTESTATIONS: {
        id: 'EndDateChanged.v2.label.ATTESTATIONS',
        defaultMessage: 'End Date Changed',
      },
    },
    'End Date Changed': {
      ATTESTATIONS: {
        id: 'EndDateChanged.v2.label.ATTESTATIONS',
        defaultMessage: 'End Date Changed',
      },
    },
    Total: {
      ATTESTATIONS: {
        id: 'Total.v2.label.ATTESTATIONS',
        defaultMessage: 'Total',
      },
    },
    'Total.v2.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Total.v2.label.ATTESTATIONS',
        defaultMessage: 'Total',
      },
    },
    Approved: {
      ATTESTATIONS: {
        id: 'Approved.v2.label.ATTESTATIONS',
        defaultMessage: 'Approved',
      },
    },
    ManagerConfirmed: {
      ATTESTATIONS: {
        id: 'ManagerConfirmed.v2.label.ATTESTATIONS',
        defaultMessage: 'Manager Confirmed',
      },
    },
    'Manager Confirmed': {
      ATTESTATIONS: {
        id: 'ManagerConfirmed.v2.label.ATTESTATIONS',
        defaultMessage: 'Manager Confirmed',
      },
    },
    'ManagerConfirmed.v2.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'ManagerConfirmed.v2.label.ATTESTATIONS',
        defaultMessage: 'Manager Confirmed',
      },
    },
    'ManagerConfirmedWithEndDateChanged.v2.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'ManagerConfirmedWithEndDateChanged.v2.label.ATTESTATIONS',
        defaultMessage: 'Manager Confirmed With End Date Changed',
      },
    },
    'Manager Confirmed With End Date Changed': {
      ATTESTATIONS: {
        id: 'ManagerConfirmedWithEndDateChanged.v2.label.ATTESTATIONS',
        defaultMessage: 'Manager Confirmed With End Date Changed',
      },
    },
    Rejected: {
      ATTESTATIONS: {
        id: 'Rejected.v2.label.ATTESTATIONS',
        defaultMessage: 'Rejected',
      },
    },
    'Rejected.v2.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Rejected.v2.label.ATTESTATIONS',
        defaultMessage: 'Rejected',
      },
    },
    'Terminated.v2.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Terminated.v2.label.ATTESTATIONS',
        defaultMessage: 'Terminated',
      },
    },
    'Pending.v2.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Pending.v2.label.ATTESTATIONS',
        defaultMessage: 'Pending',
      },
    },
    Pending: {
      ATTESTATIONS: {
        id: 'Pending.v2.label.ATTESTATIONS',
        defaultMessage: 'Pending',
      },
    },
    Account: {
      ATTESTATIONS: {
        id: 'Account.v2.label.ATTESTATIONS',
        defaultMessage: 'Account',
      },
    },
    Entitlement: {
      ATTESTATIONS: {
        id: 'Entitlement.v2.label.ATTESTATIONS',
        defaultMessage: 'Entitlement',
      },
    },
    Role: {
      ATTESTATIONS: {
        id: 'Role.v2.label.ATTESTATIONS',
        defaultMessage: 'Role',
      },
    },
    User: {
      ATTESTATIONS: {
        id: 'User.v2.label.ATTESTATIONS',
        defaultMessage: 'User',
      },
    },
    'User.v2.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User.v2.label.ATTESTATIONS',
        defaultMessage: 'User',
      },
    },
    'Not Confirmed By Manager': {
      ATTESTATIONS: {
        id: 'NotConfirmedByManager.v2.label.ATTESTATIONS',
        defaultMessage: 'Not Confirmed By Manager',
      },
    },
    'Conditionally Certified': {
      ATTESTATIONS: {
        id: 'ConditionallyCertified.v2.label.ATTESTATIONS',
        defaultMessage: 'Conditionally Certified',
      },
    },
    'Risk.Factor.smart.cards.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Risk.Factor.smart.cards.V2.Attestations.Label',
        defaultMessage: 'Risk Factors',
      },
    },
    'Risk.Factor.smart.cards.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Risk.Factor.smart.cards.Description.V2.Attestations.Label',
        defaultMessage: 'These factors commonly lead to access rejections.',
      },
    },
    'Trust.Factor.smart.cards.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Trust.Factor.smart.cards.V2.Attestations.Label',
        defaultMessage: 'Trust Factors',
      },
    },
    'Trust.Factor.smart.cards.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Trust.Factor.smart.cards.Description.V2.Attestations.Label',
        defaultMessage: 'These factors commonly lead to access approvals.',
      },
    },
    'OutOfBand.Access.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'OutOfBand.Access.V2.Attestations.Label',
        defaultMessage: 'Out of Band Access',
      },
    },
    'OutOfBand.Access.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'OutOfBand.Access.Description.V2.Attestations.Label',
        defaultMessage:
          'Access that was imported from applications connected to Saviynt',
      },
    },
    'OutOfBand.Account.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'OutOfBand.Account.V2.Attestations.Label',
        defaultMessage: 'Out of Band Account',
      },
    },
    'OutOfBand.Account.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'OutOfBand.Account.Description.V2.Attestations.Label',
        defaultMessage:
          'Account that was imported from applications connected to Saviynt',
      },
    },
    'HighRisk.Access.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'HighRisk.Access.V2.Attestations.Label',
        defaultMessage: 'High Risk Entitlements',
      },
    },
    'HighRisk.Access.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'HighRisk.Access.Description.V2.Attestations.Label',
        defaultMessage: 'Entitlements with High or Critical Risk Category',
      },
    },
    'LowRisk.Access.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'LowRisk.Access.V2.Attestations.Label',
        defaultMessage: 'Low Risk Access',
      },
    },
    'LowRisk.Access.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'LowRisk.Access.Description.V2.Attestations.Label',
        defaultMessage: 'Entitlements with No, Low or Medium Risk Category',
      },
    },
    'HighRisk.Users.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'HighRisk.Users.V2.Attestations.Label',
        defaultMessage: 'High Risk Users',
      },
    },
    'HighRisk.Users.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'HighRisk.Users.Description.V2.Attestations.Label',
        defaultMessage: 'Users with High Risk Score',
      },
    },
    'LowRisk.Users.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'LowRisk.Users.V2.Attestations.Label',
        defaultMessage: 'Low Risk Users',
      },
    },
    'LowRisk.Users.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'LowRisk.Users.Description.V2.Attestations.Label',
        defaultMessage: 'Users with Low Risk Score',
      },
    },
    'HighRisk.Account.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'HighRisk.Account.V2.Attestations.Label',
        defaultMessage: 'High Risk Account',
      },
    },
    'HighRisk.Account.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'HighRisk.Account.Description.V2.Attestations.Label',
        defaultMessage:
          'Accounts that are associated to Entitlements with High or Critical Risk Category',
      },
    },
    'LowRisk.Account.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'LowRisk.Account.V2.Attestations.Label',
        defaultMessage: 'Low Risk Account',
      },
    },
    'LowRisk.Account.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'LowRisk.Account.Description.V2.Attestations.Label',
        defaultMessage:
          'Accounts that are associated to Entitlements with No, Low or Medium Risk Category',
      },
    },
    'HighRisk.Roles.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'HighRisk.Roles.V2.Attestations.Label',
        defaultMessage: 'High Risk Roles',
      },
    },
    'HighRisk.Roles.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'HighRisk.Roles.Description.V2.Attestations.Label',
        defaultMessage: 'Roles with High or Critical Risk Category',
      },
    },
    'LowRisk.Roles.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'LowRisk.Roles.V2.Attestations.Label',
        defaultMessage: 'Low Risk Roles',
      },
    },
    'LowRisk.Roles.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'LowRisk.Roles.Description.V2.Attestations.Label',
        defaultMessage: 'Roles with No, Low or Medium Risk Category',
      },
    },
    'Recently.Reviewed.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Recently.Reviewed.V2.Attestations.Label',
        defaultMessage: 'Recently Reviewed in 30 Days',
      },
    },
    'Recently.Reviewed.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Recently.Reviewed.Description.V2.Attestations.Label',
        defaultMessage: 'Access that has been recently reviewed in 30 Days',
      },
    },
    'Inactive.Accounts.60days.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Inactive.Accounts.60days.V2.Attestations.Label',
        defaultMessage: 'Inactive Accounts for 60 days',
      },
    },
    'Inactive.Accounts.60days.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Inactive.Accounts.60days.Description.V2.Attestations.Label',
        defaultMessage:
          'Accounts that are inactive or Manually Suspended for 60 days',
      },
    },
    'Access.SOD.Violations.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Access.SOD.Violations.V2.Attestations.Label',
        defaultMessage: 'Segregation of Duties (SoD)',
      },
    },
    'Access.SOD.Violations.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Access.SOD.Violations.Description.V2.Attestations.Label',
        defaultMessage: 'Entitlements with Access Conflicts',
      },
    },
    'Inactive.Accounts.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Inactive.Accounts.V2.Attestations.Label',
        defaultMessage: 'Inactive Accounts',
      },
    },
    'Inactive.Accounts.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Inactive.Accounts.Description.V2.Attestations.Label',
        defaultMessage: 'Accounts that are inactive or Manually Suspended',
      },
    },
    'Confidence.trust.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Confidence.trust.V2.Attestations.Label',
        defaultMessage: 'Confidence',
      },
    },
    'Confidence.trust.Description.V2.Attestations.Label': {
      ATTESTATIONS: {
        id: 'Confidence.trust.Description.V2.Attestations.Label',
        defaultMessage: 'Access with Low Confidence Score',
      },
    },
    'PERSONALIZATION.DEFAULT_VIEW.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'PERSONALIZATION.DEFAULT_VIEW.ATTESTATIONS',
        defaultMessage: 'Default View',
      },
    },
    'PERSONALIZATION.MY_PERSONALIZED_VIEW.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'PERSONALIZATION.MY_PERSONALIZED_VIEW.ATTESTATIONS',
        defaultMessage: 'My Personalized View',
      },
    },
    'PERSONALIZATION.INFO_BANNER_TITLE_PERSONALIZED': {
      ATTESTATIONS: {
        id: 'PERSONALIZATION.INFO_BANNER_TITLE_PERSONALIZED',
        defaultMessage: 'Enjoy Your Personalized View',
      },
    },
    'PERSONALIZATION.INFO_BANNER_DESCRIPTION_DEFAULT': {
      ATTESTATIONS: {
        id: 'PERSONALIZATION.INFO_BANNER_DESCRIPTION_DEFAULT',
        defaultMessage:
          'Personalization is set to default view. Your personalized view has filters or other configurations that can’t be applied to this certification.',
      },
    },
    'PERSONALIZATION.INFO_BANNER_DESCRIPTION_DEFAULT_VIEW': {
      ATTESTATIONS: {
        id: 'PERSONALIZATION.INFO_BANNER_DESCRIPTION_DEFAULT_VIEW',
        defaultMessage: 'Personalization is set to default view.',
      },
    },
    'PERSONALIZATION.INFO_BANNER_DESCRIPTION_PERSONALIZED_DESKTOP_FIRST': {
      ATTESTATIONS: {
        id: 'PERSONALIZATION.INFO_BANNER_DESCRIPTION_PERSONALIZED_DESKTOP_FIRST',
        defaultMessage:
          'You are viewing your certification with your personalized view applied.',
      },
    },
    'PERSONALIZATION.INFO_BANNER_DESCRIPTION_PERSONALIZED_DESKTOP_ONLY': {
      ATTESTATIONS: {
        id: 'PERSONALIZATION.INFO_BANNER_DESCRIPTION_PERSONALIZED_DESKTOP_ONLY',
        defaultMessage: 'If you need to switch view, do it from the menu.',
      },
    },
    'PERSONALIZATION.INFO_BANNER_DESCRIPTION_PERSONALIZED_DESKTOP_SECOND': {
      ATTESTATIONS: {
        id: 'PERSONALIZATION.INFO_BANNER_DESCRIPTION_PERSONALIZED_DESKTOP_SECOND',
        defaultMessage: 'If you need to switch view, do it from the menu.',
      },
    },
    'PERSONALIZATION.ALERTS.UPDATE_SUCCESS': {
      ATTESTATIONS: {
        id: 'PERSONALIZATION.ALERTS.UPDATE_SUCCESS',
        defaultMessage: 'Personalization update successful.',
      },
    },
    'PERSONALIZATION.ALERTS.UPDATE_FAILED': {
      ATTESTATIONS: {
        id: 'PERSONALIZATION.ALERTS.UPDATE_FAILED',
        defaultMessage: 'Personalization update failed. Please try again.',
      },
    },
    'PERSONALIZATION.ALERTS.UPDATE_FAILED_INVALID_LENGTH': {
      ATTESTATIONS: {
        id: 'PERSONALIZATION.ALERTS.UPDATE_FAILED_INVALID_LENGTH',
        defaultMessage:
          'View could not be saved as the size of the view exceeded threshold limit, Please remove some of the filters/columns/rows items and try again.',
      },
    },
    'PERSONALIZATION.ALERTS.CREATE_SUCCESS': {
      ATTESTATIONS: {
        id: 'PERSONALIZATION.ALERTS.CREATE_SUCCESS',
        defaultMessage: 'Personalization create successful',
      },
    },
    'PERSONALIZATION.ALERTS.CREATE_FAILED': {
      ATTESTATIONS: {
        id: 'PERSONALIZATION.ALERTS.CREATE_FAILED',
        defaultMessage: 'Personalization create failed. Please try later.',
      },
    },
    PERSONALIZATION_VIEW_OPTIONS: {
      ATTESTATIONS: {
        id: 'PERSONALIZATION_VIEW_OPTIONS',
        defaultMessage: 'View Options',
      },
    },
    PERSONALIZATION_POOPOVER_MESSAGE: {
      ATTESTATIONS: {
        id: 'PERSONALIZATION_POOPOVER_MESSAGE',
        defaultMessage:
          'You can switch between the default and your personalized view here.',
      },
    },
    PERSONALIZATION_POOPOVER_CHECKBOX_MESSAGE: {
      ATTESTATIONS: {
        id: 'PERSONALIZATION_POOPOVER_CHECKBOX_MESSAGE',
        defaultMessage: "Don't show this again for this certification.",
      },
    },
    CERTS_CERTIFICTION_DUE: {
      ATTESTATIONS: {
        id: 'CERTS_CERTIFICTION_DUE',
        defaultMessage: 'Certification Due',
      },
    },
    CERTS_CERTIFICTION_DUE_MOBILE: {
      ATTESTATIONS: {
        id: 'CERTS_CERTIFICTION_DUE_MOBILE',
        defaultMessage: 'Due',
      },
    },
    CERTS_SUCCESS: {
      ATTESTATIONS: {
        id: 'CERTS_SUCCESS',
        defaultMessage: 'Success',
      },
    },
    CERTS_FAILED: {
      ATTESTATIONS: {
        id: 'CERTS_FAILED',
        defaultMessage: 'Failed',
      },
    },
    CERTS_SAVE_VIEW: {
      ATTESTATIONS: {
        id: 'CERTS_SAVE_VIEW',
        defaultMessage: 'Save View',
      },
    },
    CERTS_CLEAR: {
      ATTESTATIONS: {
        id: 'CERTS_CLEAR',
        defaultMessage: 'Clear',
      },
    },
    CERTS_LOADING: {
      ATTESTATIONS: {
        id: 'CERTS_LOADING',
        defaultMessage: 'Loading',
      },
    },
    CERTS_EXPORT: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT',
        defaultMessage: 'Export',
      },
    },
    CERTS_EXPORT_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_TITLE',
        defaultMessage: 'Export Your Certification',
      },
    },
    CERTS_EXPORT_SUBTITLE: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_SUBTITLE',
        defaultMessage:
          'Select what you want to export and how you want it organized.',
      },
    },
    CERTS_EXPORT_SELECT_AND_ORGANIZE_YOUR_DATA: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_SELECT_AND_ORGANIZE_YOUR_DATA',
        defaultMessage: 'Select and Organize Your Data',
      },
    },
    CERTS_EXPORT_INCLUDED_IN_EXPORT: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_INCLUDED_IN_EXPORT',
        defaultMessage: 'Included in Export',
      },
    },
    CERTS_EXPORT_ADD_TO_EXPORT: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_ADD_TO_EXPORT',
        defaultMessage: 'Add To Export',
      },
    },
    CERTS_EXPORT_ADD_ALL: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_ADD_ALL',
        defaultMessage: 'Add All',
      },
    },
    CERTS_EXPORT_REMOVE_ALL: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_REMOVE_ALL',
        defaultMessage: 'Remove All',
      },
    },
    CERTS_EXPORT_WHAT_TO_EXPORT: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_WHAT_TO_EXPORT',
        defaultMessage: 'What to Export',
      },
    },
    CERTS_EXPORT_WHAT_TO_EXPORT_ALL_ITEMS: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_WHAT_TO_EXPORT_ALL_ITEMS',
        defaultMessage: 'All Items',
      },
    },
    CERTS_EXPORT_WHAT_TO_EXPORT_ONLY_FILTERED_RESULTS: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_WHAT_TO_EXPORT_ONLY_FILTERED_RESULTS',
        defaultMessage: 'Only Filtered Results',
      },
    },
    CERTS_EXPORT_WHAT_TO_EXPORT_NO_RECORD: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_WHAT_TO_EXPORT_NO_RECORD',
        defaultMessage:
          "The selected filters doesn't have any record. Please remove some of them to export.",
      },
    },
    CERTS_EXPORT_WHAT_TO_EXPORT_SMART_FILTER: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_WHAT_TO_EXPORT_SMART_FILTER',
        defaultMessage: 'Smart Filter',
      },
    },
    CERTS_EXPORT_WHAT_TO_EXPORT_ACTION_FILTERS: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_WHAT_TO_EXPORT_ACTION_FILTERS',
        defaultMessage: 'Action Filters',
      },
    },
    CERTS_EXPORT_WHAT_TO_EXPORT_FILTER_APPLIED: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_WHAT_TO_EXPORT_FILTER_APPLIED',
        defaultMessage: 'Filter applied',
      },
    },
    EXPORT_ALERT_SUCCESS_TITLE: {
      ATTESTATIONS: {
        id: 'EXPORT_ALERT_SUCCESS_TITLE',
        defaultMessage: 'Exporting',
      },
    },
    EXPORT_ALERT_SUCCESS_DESCRIPION: {
      ATTESTATIONS: {
        id: 'EXPORT_ALERT_SUCCESS_DESCRIPION',
        defaultMessage:
          'Your export is running in the background and will be available in the "My Downloads" section once completed.',
      },
    },
    'EXPORT_ALERT_SUCCESS_DESCRIPION.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'EXPORT_ALERT_SUCCESS_DESCRIPION.ATTESTATIONS',
        defaultMessage:
          'Your export is running in the background and will be available in the "My Downloads" section once completed.',
      },
    },
    EXPORT_ALERT_FAILED_TITLE: {
      ATTESTATIONS: {
        id: 'EXPORT_ALERT_FAILED_TITLE',
        defaultMessage: 'Failed',
      },
    },
    EXPORT_ALERT_FAILED_DESCRIPION: {
      ATTESTATIONS: {
        id: 'EXPORT_ALERT_FAILED_DESCRIPION',
        defaultMessage:
          'Export cannot be done now because of some network failure, Please try again later.',
      },
    },
    'EXPORT_ALERT_FAILED_DESCRIPION.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'EXPORT_ALERT_FAILED_DESCRIPION.ATTESTATIONS',
        defaultMessage:
          'Export cannot be done now because of some network failure, Please try again later.',
      },
    },
    EXPORT_ALERT_FAILED412_TITLE: {
      ATTESTATIONS: {
        id: 'EXPORT_ALERT_FAILED412_TITLE',
        defaultMessage: 'Info',
      },
    },
    EXPORT_ALERT_FAILED412_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'EXPORT_ALERT_FAILED412_DESCRIPTION',
        defaultMessage:
          'An export is already running in the background, please wait for it to complete.',
      },
    },
    'EXPORT_ALERT_FAILED412_DESCRIPTION.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'EXPORT_ALERT_FAILED412_DESCRIPTION.ATTESTATIONS',
        defaultMessage:
          'An export is already running in the background, please wait for it to complete.',
      },
    },
    'Approve.Default.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Approve.Default.label.ATTESTATIONS',
        defaultMessage: 'Approve',
      },
    },
    'REQUEST.STATUS.APPROVED': {
      ATTESTATIONS: {
        id: 'REQUEST.STATUS.APPROVED',
        defaultMessage: 'Approved',
      },
    },
    'APPROVE.CANCEL.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'APPROVE.CANCEL.ATTESTATIONS',
        defaultMessage: 'Cancel Approval',
      },
    },
    'APPROVE.POPOVER_TITLE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'APPROVE.POPOVER_TITLE.ATTESTATIONS',
        defaultMessage: 'Approve this',
      },
    },
    'Confirmmanager.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Confirmmanager.label.ATTESTATIONS',
        defaultMessage: 'Confirm Manager',
      },
    },
    'CONFIRMMANAGER.CANCEL.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'CONFIRMMANAGER.CANCEL.ATTESTATIONS',
        defaultMessage: 'Cancel Manager Confirmation',
      },
    },
    'ManagerConfirmed.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'ManagerConfirmed.ATTESTATIONS',
        defaultMessage: 'Manager Confirmed',
      },
    },
    'CONFIRMMANAGER.POPOVER_TITLE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'CONFIRMMANAGER.POPOVER_TITLE.ATTESTATIONS',
        defaultMessage: 'Confirm Manager for this',
      },
    },
    'pt.button.cancel': {
      ATTESTATIONS: {
        id: 'pt.button.cancel',
        defaultMessage: 'Cancel',
      },
    },
    REASSIGN_SELECT_CERTIFIER: {
      ATTESTATIONS: {
        id: 'REASSIGN_SELECT_CERTIFIER',
        defaultMessage: 'Select Certifier',
      },
    },
    REASSSIGN_SELECTED: {
      ATTESTATIONS: {
        id: 'REASSSIGN_SELECTED',
        defaultMessage: 'Selected',
      },
    },
    REASSSIGN_PLACEHOLDER_LABEL: {
      ATTESTATIONS: {
        id: 'REASSSIGN_PLACEHOLDER_LABEL',
        defaultMessage: 'Select a known or default reassignee',
      },
    },
    REASSSIGN_SKIP_CERTIFIER: {
      ATTESTATIONS: {
        id: 'REASSSIGN_SKIP_CERTIFIER',
        defaultMessage: 'Skip selecting certifier',
      },
    },
    CERTS_CANCEL: {
      ATTESTATIONS: {
        id: 'CERTS_CANCEL',
        defaultMessage: 'Cancel',
      },
    },
    CERTS_SUBMIT: {
      ATTESTATIONS: {
        id: 'CERTS_SUBMIT',
        defaultMessage: 'Submit',
      },
    },
    CERTS_REASSIGN: {
      ATTESTATIONS: {
        id: 'CERTS_REASSIGN',
        defaultMessage: 'Reassign',
      },
    },
    REASSIGN_UNDONE: {
      ATTESTATIONS: {
        id: 'REASSIGN_UNDONE',
        defaultMessage: 'Reassignment Can’t Be Undone',
      },
    },
    REASSIGN_WARNING_LABEL: {
      ATTESTATIONS: {
        id: 'REASSIGN_WARNING_LABEL',
        defaultMessage:
          'When you reassign one of your certification items to another certifier, it’ll be removed from your list and can’t be retracted. Do you want to reassign this item?',
      },
    },
    CERTS_DONT_SHOW_LABEL: {
      ATTESTATIONS: {
        id: 'CERTS_DONT_SHOW_LABEL',
        defaultMessage: 'Don’t show this message again',
      },
    },
    CONSULT_ITEMS: {
      ATTESTATIONS: {
        id: 'CONSULT_ITEMS',
        defaultMessage: 'Items to Consult',
      },
    },
    CONSULT_SELECT_CERTIFIER: {
      ATTESTATIONS: {
        id: 'CONSULT_SELECT_CERTIFIER',
        defaultMessage: 'I want to consult with',
      },
    },
    CONSULT_PLACEHOLDER: {
      ATTESTATIONS: {
        id: 'CONSULT_PLACEHOLDER',
        defaultMessage: 'Search by first name, last name, username, or email',
      },
    },
    CONSULT_DONT_SHOW_LABEL: {
      ATTESTATIONS: {
        id: 'CONSULT_DONT_SHOW_LABEL',
        defaultMessage: 'Don’t show this again for this certification',
      },
    },
    CONSULT_WITH_PEERS: {
      ATTESTATIONS: {
        id: 'CONSULT_WITH_PEERS',
        defaultMessage: 'Consult with Peers',
      },
    },
    CONSULT_INVITE_REVIEW_LABEL: {
      ATTESTATIONS: {
        id: 'CONSULT_INVITE_REVIEW_LABEL',
        defaultMessage:
          'Invite another user in your organization to review your certification items and advise on appropriate actions.',
      },
    },
    CERTS_SORT_LABEL: {
      ATTESTATIONS: {
        id: 'CERTS_SORT_LABEL',
        defaultMessage: 'Select an attribute to sort by.',
      },
    },
    CERTS_SORT_PLACEHOLDER: {
      ATTESTATIONS: {
        id: 'CERTS_SORT_PLACEHOLDER',
        defaultMessage: 'Search attributes',
      },
    },
    CERTS_DRAG_REDOREDER_LABEL: {
      ATTESTATIONS: {
        id: 'CERTS_DRAG_REDOREDER_LABEL',
        defaultMessage: 'Drag to Reorder',
      },
    },
    CERTS_COLUMN_FILTER_LABEL: {
      ATTESTATIONS: {
        id: 'CERTS_COLUMN_FILTER_LABEL',
        defaultMessage:
          'The number of visible attributes depends on the size of your browser and screen. Any attributes not shown are visible in the detailed view.',
      },
    },
    CERTS_LIST_HEADER: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_HEADER',
        defaultMessage: 'Certifications',
      },
    },
    CERTS_LIST_ADMIN_MESSAGE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ADMIN_MESSAGE',
        defaultMessage:
          'Review and manage the certification campaigns that you’ve created and assigned to other certifiers.',
      },
    },
    CERTS_LIST_END_USER_MESSAGE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_END_USER_MESSAGE',
        defaultMessage:
          'Review and complete the certifications that have been assigned to you. Your progress will be saved as you go, so that you can pause and continue each certification.',
      },
    },
    CERTS_LIST_ACTION_API_FAILURE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ACTION_API_FAILURE.ATTESTATIONS',
        defaultMessage:
          'Network Error. Something went wrong. Please try again later.',
      },
    },
    CERTS_LIST_ACTION_DISCONTINUE_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ACTION_DISCONTINUE_TITLE.ATTESTATIONS',
        defaultMessage: 'Cancel Certification?',
      },
    },
    CERTS_LIST_ACTION_DISCONTINUE_SUBTITLE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ACTION_DISCONTINUE_SUBTITLE.ATTESTATIONS',
        defaultMessage:
          'If you cancel this certification, any progress that’s been made will be stopped.',
      },
    },

    CERTS_LIST_ACTION_REASSIGN_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ACTION_REASSIGN_TITLE.ATTESTATIONS',
        defaultMessage: 'Reassign',
      },
    },
    CERTS_LIST_ACTION_REASSIGN_SUBTITLE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ACTION_REASSIGN_SUBTITLE.ATTESTATIONS',
        defaultMessage:
          'Assign the certification to another certifier, and provide a reason if needed.',
      },
    },
    CERTS_LIST_ACTION_EMAIL_HISTORY_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ACTION_EMAIL_HISTORY_TITLE.ATTESTATIONS',
        defaultMessage: 'Email History',
      },
    },
    CERTS_LIST_ACTION_EMAIL_HISTORY_SUBTITLE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ACTION_EMAIL_HISTORY_SUBTITLE.ATTESTATIONS',
        defaultMessage: 'View the status of each reminder email',
      },
    },
    CERTS_CHANGE_END_DATE_ERROR: {
      ATTESTATIONS: {
        id: 'CERTS_CHANGE_END_DATE_ERROR',
        defaultMessage: 'Error! Please try again later.',
      },
    },
    CERTS_CHANGE_END_DATE_MESSAGE: {
      ATTESTATIONS: {
        id: 'CERTS_CHANGE_END_DATE_MESSAGE',
        defaultMessage:
          'The end date won&apos;t be changed until you finish the review and submit.',
      },
    },
    CERTS_CHANGE_END_DATE: {
      ATTESTATIONS: {
        id: 'CERTS_CHANGE_END_DATE',
        defaultMessage: 'Change End Date',
      },
    },
    CERTS_NEW_DATE: {
      ATTESTATIONS: {
        id: 'CERTS_NEW_DATE',
        defaultMessage: 'Please select a new end date.',
      },
    },
    CERTS_CURRENT_END_DATE: {
      ATTESTATIONS: {
        id: 'CERTS_CURRENT_END_DATE',
        defaultMessage: 'Current End Date',
      },
    },
    CERTS_NEW_END_DATE: {
      ATTESTATIONS: {
        id: 'CERTS_NEW_END_DATE',
        defaultMessage: 'New End Date',
      },
    },
    CERTS_REJECT_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_REJECT_TITLE',
        defaultMessage: 'Reject this ',
      },
    },
    CERTS_REJECT_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_REJECT_DESCRIPTION',
        defaultMessage:
          'Access won‘t be removed right away. It’ll take effect after you finish your review and submit.',
      },
    },
    CERTS_REJECT_NOTE: {
      ATTESTATIONS: {
        id: 'CERTS_REJECT_NOTE',
        defaultMessage:
          'If you don’t submit by the due date, access will be removed automatically at that time.',
      },
    },
    CERTS_REJECT_PRIMARY_BTN: {
      ATTESTATIONS: {
        id: 'CERTS_REJECT_PRIMARY_BTN',
        defaultMessage: 'Reject',
      },
    },
    CERTS_REJECT_SECONDARY_BTN: {
      ATTESTATIONS: {
        id: 'CERTS_REJECT_SECONDARY_BTN',
        defaultMessage: 'Got it',
      },
    },
    CERTS_REJECT_CANCEL_BTN: {
      ATTESTATIONS: {
        id: 'CERTS_REJECT_CANCEL_BTN',
        defaultMessage: 'Cancel',
      },
    },
    CERTS_TERMINATE_ERROR: {
      ATTESTATIONS: {
        id: 'CERTS_TERMINATE_ERROR',
        defaultMessage: 'Terminate Action failed, please try again.',
      },
    },
    CERTS_TERMINATE_RETRY: {
      ATTESTATIONS: {
        id: 'CERTS_TERMINATE_RETRY',
        defaultMessage: 'Please try again.',
      },
    },
    CERTS_TERMINATE_IMPORTANT: {
      ATTESTATIONS: {
        id: 'CERTS_TERMINATE_IMPORTANT',
        defaultMessage: 'Important:',
      },
    },
    CERTS_TERMINATE_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_TERMINATE_TITLE',
        defaultMessage: 'Terminate User and Access?',
      },
    },
    CERTS_TERMINATE_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_TERMINATE_DESCRIPTION',
        defaultMessage:
          'Do you want to terminate this user and revoke all their access?',
      },
    },
    CERTS_TERMINATE_SUBDESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_TERMINATE_SUBDESCRIPTION',
        defaultMessage:
          'Termination won’t be fulfilled right away. It’ll take effect after you finish your review and submit.',
      },
    },
    CERTS_TERMINATE_NOTE: {
      ATTESTATIONS: {
        id: 'CERTS_TERMINATE_NOTE',
        defaultMessage:
          'If you don’t submit by the due date, termination will occur automatically at that time.',
      },
    },
    CERTS_TERMINATE_PLACEHOLDER: {
      ATTESTATIONS: {
        id: 'CERTS_TERMINATE_PLACEHOLDER',
        defaultMessage: 'Provide a reason for your decision',
      },
    },
    CERTS_TERMINATE_PRIMARY_BTN: {
      ATTESTATIONS: {
        id: 'CERTS_TERMINATE_PRIMARY_BTN',
        defaultMessage: 'Terminate',
      },
    },
    CERTS_TERMINATE_SECONDARY_BTN: {
      ATTESTATIONS: {
        id: 'CERTS_TERMINATE_SECONDARY_BTN',
        defaultMessage: 'Cancel',
      },
    },
    CERTS_SAVI_INTRO_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_INTRO_MSG',
        defaultMessage:
          'I&apos;m here to help make your certification go faster and easier with intelligence-based recommendations.',
      },
    },
    CERTS_SAVI_GOT_IT: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_GOT_IT',
        defaultMessage: 'Got it',
      },
    },
    CERTS_SAVI_OVERWRITE: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_OVERWRITE',
        defaultMessage: 'Overwrite',
      },
    },
    CERTS_SAVI_KEEP_DECISIONS_LABEL: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_KEEP_DECISIONS_LABEL',
        defaultMessage: 'Keep Your Decisions',
      },
    },
    CERTS_SAVI_KEEP_OR_OVERWRITE_LABEL: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_KEEP_OR_OVERWRITE_LABEL',
        defaultMessage: 'Keep or Overwrite Your Decisions?',
      },
    },
    CERTS_SAVI_APPLIED: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_APPLIED',
        defaultMessage: 'Applied',
      },
    },
    CERTS_SAVI_RETRY: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_RETRY',
        defaultMessage: 'Retry',
      },
    },
    CERTS_SAVI_EMPTY_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_EMPTY_MSG',
        defaultMessage: 'You are all caught up! Nothing to see here.',
      },
    },
    CERTS_SAVI_HELP_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_HELP_MSG',
        defaultMessage: 'How can I help with your certification?',
      },
    },
    CERTS_SAVI_RECOMMENDED: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_RECOMMENDED',
        defaultMessage: 'Recommended',
      },
    },
    CERTS_SAVI_LOADING_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_LOADING_MSG',
        defaultMessage:
          'Thank you for your patience! I am working on getting smart decisions together for you.',
      },
    },
    CERTS_SAVI_QUESTION_LABEL: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_QUESTION_LABEL',
        defaultMessage: 'What decisions can I make for you?',
      },
    },
    CERTS_SAVI_APPLY: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_APPLY',
        defaultMessage: 'Apply',
      },
    },
    CERTS_ACTION_VIEW: {
      ATTESTATIONS: {
        id: 'CERTS_ACTION_VIEW',
        defaultMessage: 'View',
      },
    },
    CERTS_ACTION_GET_STARTED: {
      ATTESTATIONS: {
        id: 'CERTS_ACTION_GET_STARTED',
        defaultMessage: 'Get Started',
      },
    },
    CERTS_ACTION_CONTINUE: {
      ATTESTATIONS: {
        id: 'CERTS_ACTION_CONTINUE',
        defaultMessage: 'Continue',
      },
    },
    CERTS_ACTION_ALERTS_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_ACTION_ALERTS_TITLE',
        defaultMessage: 'Network Error',
      },
    },
    CERTS_ACTION_ALERTS_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_ACTION_ALERTS_DESCRIPTION',
        defaultMessage: 'Something went wrong. Please try again.',
      },
    },
    CERTS_ACTION_ALERTS_SUCCESS: {
      ATTESTATIONS: {
        id: 'CERTS_ACTION_ALERTS_SUCCESS',
        defaultMessage: 'Success',
      },
    },
    CERTS_ACTION_MENU_SEE_DETAILS: {
      ATTESTATIONS: {
        id: 'CERTS_ACTION_MENU_SEE_DETAILS',
        defaultMessage: 'See details',
      },
    },
    CERTS_LIST_TILE_INACTIVE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_TILE_INACTIVE',
        defaultMessage: 'Inactive',
      },
    },
    CERTS_LIST_TILE_EXPIRE_SOON: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_TILE_EXPIRE_SOON',
        defaultMessage: 'Expire Soon',
      },
    },
    CERTS_LIST_VIEW_CONTROLS_CERTIFICATION_NAME: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_VIEW_CONTROLS_CERTIFICATION_NAME',
        defaultMessage: 'Certification Name',
      },
    },
    CERTS_LIST_VIEW_CONTROLS_CERTIFICATION_TYPE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_VIEW_CONTROLS_CERTIFICATION_TYPE',
        defaultMessage: 'Certification Type',
      },
    },
    CERTS_LIST_BODY_DISCONTINUE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_BODY_DISCONTINUE',
        defaultMessage: 'discontinued',
      },
    },
    CERTS_CONSULT_WARN_MESSAGE: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULT_WARN_MESSAGE',
        defaultMessage:
          'A consultation with {userinfo} is pending and can’t be cancelled. Do you want to make your decision and move it to Done anyway?',
      },
    },
    CERTS_CONSULT_OTHER_ACTIONS_WARN_MESSAGE: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULT_OTHER_ACTIONS_WARN_MESSAGE',
        defaultMessage:
          'There are consultations pending with {count} peers that can’t be cancelled. Do you want to make your decision and move it to Done anyway?',
      },
    },
    CERTS_CONSULT_ACTION_WARN_MESSAGE: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULT_ACTION_WARN_MESSAGE',
        defaultMessage:
          'There are consultations pending with {count} peers that can’t be cancelled. Do you want to request a new consultation with another user anyway?',
      },
    },
    CERTS_CONSULT_DEFAULT_WARN_MESSAGE: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULT_DEFAULT_WARN_MESSAGE',
        defaultMessage:
          'A consultation with {userinfo} is pending and can’t be cancelled. Do you want to request a new consultation with another user anyway?',
      },
    },
    CERTS_CONSULTATION_IS_PENDING: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULTATION_IS_PENDING',
        defaultMessage: 'Consultation Is Pending',
      },
    },
    CERTS_CONSULTATIONS_ARE_PENDING: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULTATIONS_ARE_PENDING',
        defaultMessage: 'Consultations Are Pending',
      },
    },
    CERTS_CONSULT_MAKE_DECISION: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULT_MAKE_DECISION',
        defaultMessage: 'Make Decision',
      },
    },
    CERTS_CONSULT_NEW_REQUEST: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULT_NEW_REQUEST',
        defaultMessage: 'Request New Consultation',
      },
    },
    CERTS_FOOTER_NOTICE: {
      ATTESTATIONS: {
        id: 'CERTS_FOOTER_NOTICE',
        defaultMessage: 'Progress Saved',
      },
    },
    CERTS_PORTRAIT_MODE_MESSAGE: {
      ATTESTATIONS: {
        id: 'CERTS_PORTRAIT_MODE_MESSAGE',
        defaultMessage:
          'For better experience, please switch to portrait mode.',
      },
    },
    CERTS_ES_CHECK_ALERT_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_ES_CHECK_ALERT_TITLE',
        defaultMessage: 'Loading Failed',
      },
    },
    CERTS_ES_CHECK_ALERT_SUBTITLE: {
      ATTESTATIONS: {
        id: 'CERTS_ES_CHECK_ALERT_SUBTITLE',
        defaultMessage: 'Sorry, we encountered some troubles loading the data.',
      },
    },
    CERTS_SAVI_REVIEW_TEXT: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_REVIEW_TEXT',
        defaultMessage:
          "You've {details} that I will smart {label}. Would you like to maintain your decisions or would you like me to overwrite your decisions with smart {action}?",
      },
    },
    CERTS_LIST_TYPE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_TYPE',
        defaultMessage: 'Type',
      },
    },
    CERTS_LIST_START_DATE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_START_DATE',
        defaultMessage: 'Start Date',
      },
    },
    CERTS_LIST_DUE_DATE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_DUE_DATE',
        defaultMessage: 'Due Date',
      },
    },
    CERTS_LIST_AUTO_REVOKE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_AUTO_REVOKE',
        defaultMessage: 'Auto Revoke',
      },
    },
    CERTS_LIST_CAMPAIGN_OWNER: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_CAMPAIGN_OWNER',
        defaultMessage: 'Campaign Owner',
      },
    },
    CERTS_SEARCH: {
      ATTESTATIONS: {
        id: 'CERTS_SEARCH',
        defaultMessage: 'Search by certification name or username',
      },
    },
    CERTS_SORT: {
      ATTESTATIONS: {
        id: 'CERTS_SORT',
        defaultMessage: 'Sort',
      },
    },
    CERTS_TODO: {
      ATTESTATIONS: {
        id: 'CERTS_TODO',
        defaultMessage: 'To Do',
      },
    },
    CERTS_DONE: {
      ATTESTATIONS: {
        id: 'CERTS_DONE',
        defaultMessage: 'Done',
      },
    },
    CERTS_CONSULTED: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULTED',
        defaultMessage: 'Consulted',
      },
    },
    CERTS_ALL: {
      ATTESTATIONS: {
        id: 'CERTS_ALL',
        defaultMessage: 'All',
      },
    },
    CERTS_CANCELLED: {
      ATTESTATIONS: {
        id: 'CERTS_CANCELLED',
        defaultMessage: 'Cancelled',
      },
    },
    CERTS_EXPIRED: {
      ATTESTATIONS: {
        id: 'CERTS_EXPIRED',
        defaultMessage: 'Expired',
      },
    },
    CERTS_COMPLETE: {
      ATTESTATIONS: {
        id: 'CERTS_COMPLETE',
        defaultMessage: 'Complete',
      },
    },
    CERTS_INCOMPLETE: {
      ATTESTATIONS: {
        id: 'CERTS_INCOMPLETE',
        defaultMessage: 'Incomplete',
      },
    },
    CERTS_LIST_EXPIRED_TOOLTIP_TEXT: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_EXPIRED_TOOLTIP_TEXT',
        defaultMessage:
          'Some access was automatically revoked after the certification due date.',
      },
    },
    CERTS_LIST_CANCELLED_TOOLTIP_TEXT: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_CANCELLED_TOOLTIP_TEXT',
        defaultMessage: 'Discontinued certifications',
      },
    },
    CERTS_LIST_TODO_TOOLTIP_TEXT: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_TODO_TOOLTIP_TEXT',
        defaultMessage: 'Pending certifications that require your action',
      },
    },
    CERTS_LIST_DONE_TOOLTIP_TEXT: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_DONE_TOOLTIP_TEXT',
        defaultMessage: 'Certifications you’ve submitted',
      },
    },
    CERTS_LIST_ADMIN_TODO_TOOLTIP_TEXT: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ADMIN_TODO_TOOLTIP_TEXT',
        defaultMessage:
          'Certifications pending submission by the primary certifiers',
      },
    },
    CERTS_LIST_ADMIN_DONE_TOOLTIP_TEXT: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ADMIN_DONE_TOOLTIP_TEXT',
        defaultMessage: 'Completed and locked certifications',
      },
    },
    CERTS_LIST_ACTIVE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ACTIVE',
        defaultMessage: 'Active',
      },
    },
    CERTS_LIST_INACTIVE: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_INACTIVE',
        defaultMessage: 'Inactive',
      },
    },
    CERTS_LIST_SELECT_ALL: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_SELECT_ALL',
        defaultMessage: 'Select All',
      },
    },
    CERTS_LIST_CLEAR: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_CLEAR',
        defaultMessage: 'Clear',
      },
    },
    CERTS_CERTIFIER_STATUS: {
      ATTESTATIONS: {
        id: 'CERTS_CERTIFIER_STATUS',
        defaultMessage: 'Certifier Status',
      },
    },
    CERTS_ROLE: {
      ATTESTATIONS: {
        id: 'CERTS_ROLE',
        defaultMessage: 'Role',
      },
    },
    CERTS_LIST_PRIMARY_CERTIFIER: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_PRIMARY_CERTIFIER',
        defaultMessage: 'Primary Certifier',
      },
    },
    CERTS_SORT_HEADER_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_SORT_HEADER_TITLE',
        defaultMessage: 'Select an attribute to sort by.',
      },
    },
    CERTS_LIST_NOTIFY: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_NOTIFY',
        defaultMessage: 'Notify',
      },
    },
    CERTS_SUMMARY: {
      ATTESTATIONS: {
        id: 'CERTS_SUMMARY',
        defaultMessage: 'Summary',
      },
    },
    CERTS_HISTORY: {
      ATTESTATIONS: {
        id: 'CERTS_HISTORY',
        defaultMessage: 'History',
      },
    },
    CERTS_PROGRESS: {
      ATTESTATIONS: {
        id: 'CERTS_PROGRESS',
        defaultMessage: 'Progress',
      },
    },
    CERTS_COMMENTS: {
      ATTESTATIONS: {
        id: 'CERTS_COMMENTS',
        defaultMessage: 'Comments',
      },
    },
    CERTS_SECONDARY_CERTIFIER: {
      ATTESTATIONS: {
        id: 'CERTS_SECONDARY_CERTIFIER',
        defaultMessage: 'Secondary Certifier(s)',
      },
    },
    CERTS_LATEST_ACTIVITY: {
      ATTESTATIONS: {
        id: 'CERTS_LATEST_ACTIVITY',
        defaultMessage: 'Latest Activity:',
      },
    },
    CERTS_VIEW_HISTORY: {
      ATTESTATIONS: {
        id: 'CERTS_VIEW_HISTORY',
        defaultMessage: 'View History',
      },
    },
    CERTS_CANCELLED_BY: {
      ATTESTATIONS: {
        id: 'CERTS_CANCELLED_BY',
        defaultMessage: 'Cancelled by',
      },
    },
    CERTS_EXPORTED_BY: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORTED_BY',
        defaultMessage: 'Exported by',
      },
    },
    CERTS_REASSIGNED_FROM: {
      ATTESTATIONS: {
        id: 'CERTS_REASSIGNED_FROM',
        defaultMessage: 'Reassigned from',
      },
    },

    CERTS_COMPLETED_BY: {
      ATTESTATIONS: {
        id: 'CERTS_COMPLETED_BY',
        defaultMessage: 'Completed by',
      },
    },
    CERTS_ACTIONED_BY: {
      ATTESTATIONS: {
        id: 'CERTS_ACTIONED_BY',
        defaultMessage: 'Actioned by',
      },
    },

    CERTS_CANCELLED_ON: {
      ATTESTATIONS: {
        id: 'CERTS_CANCELLED_ON',
        defaultMessage: 'Cancelled on',
      },
    },
    CERTS_EXPORTED_ON: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORTED_ON',
        defaultMessage: 'Exported on',
      },
    },
    CERTS_REASSIGNED_ON: {
      ATTESTATIONS: {
        id: 'CERTS_REASSIGNED_ON',
        defaultMessage: 'Reassigned on',
      },
    },

    CERTS_COMPLETED_ON: {
      ATTESTATIONS: {
        id: 'CERTS_COMPLETED_ON',
        defaultMessage: 'Completed on',
      },
    },
    CERTS_ACTIONED_ON: {
      ATTESTATIONS: {
        id: 'CERTS_ACTIONED_ON',
        defaultMessage: 'Actioned on',
      },
    },
    CERTS_REASSIGNED_TO: {
      ATTESTATIONS: {
        id: 'CERTS_REASSIGNED_TO',
        defaultMessage: 'Reassigned to',
      },
    },
    CERTS_LIST_SUMMARY_WARN: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_SUMMARY_WARN',
        defaultMessage:
          'If you don’t submit your certification by the due date, some access will be revoked automatically.',
      },
    },
    CERTS_SHOW_LESS: {
      ATTESTATIONS: {
        id: 'CERTS_SHOW_LESS',
        defaultMessage: 'Show Less',
      },
    },
    CERTS_SHOW_MORE: {
      ATTESTATIONS: {
        id: 'CERTS_SHOW_MORE',
        defaultMessage: 'Show More',
      },
    },
    CERTS_SUMMARY_INLINE_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_SUMMARY_INLINE_MSG',
        defaultMessage:
          'This campaign has been configured so that the following items will be revoked after the due date:',
      },
    },
    CERTS_UNRESPONDED: {
      ATTESTATIONS: {
        id: 'CERTS_UNRESPONDED',
        defaultMessage: 'Unresponded',
      },
    },
    CERTS_LIST_NO_ACTIONS_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_NO_ACTIONS_MSG',
        defaultMessage:
          'No actions or comments have been recorded for this certification yet.',
      },
    },
    CERTS_LIST_REVIEW_ACTIONS_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_REVIEW_ACTIONS_MSG',
        defaultMessage:
          'Review the actions taken and comments made by certifiers during the current certification.',
      },
    },

    CERTS_BY_DECISION: {
      ATTESTATIONS: {
        id: 'CERTS_BY_DECISION',
        defaultMessage: ' By Decision',
      },
    },
    CERTS_BY_TYPE: {
      ATTESTATIONS: {
        id: 'CERTS_BY_TYPE',
        defaultMessage: ' By Type',
      },
    },
    CERTS_NO_PROGRESS_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_NO_PROGRESS_MSG',
        defaultMessage: 'There is no progress saved for this certification.',
      },
    },
    CERTS_NOT_PROVIDED: {
      ATTESTATIONS: {
        id: 'CERTS_NOT_PROVIDED',
        defaultMessage: 'Not Provided',
      },
    },
    CERTS_OF_LABEL: {
      ATTESTATIONS: {
        id: 'CERTS_OF_LABEL',
        defaultMessage: 'of',
      },
    },
    CERTS_DETALS_LABEL: {
      ATTESTATIONS: {
        id: 'CERTS_DETALS_LABEL',
        defaultMessage: 'Details',
      },
    },
    CERTS_VIEW_ALL_CERTIFICATIONS: {
      ATTESTATIONS: {
        id: 'CERTS_VIEW_ALL_CERTIFICATIONS',
        defaultMessage: 'View All Certifications',
      },
    },
    CERTS_LIST_TODO_NO_RECORDS_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_TODO_NO_RECORDS_MSG',
        defaultMessage: 'You are All Caught Up',
      },
    },

    CERTS_LIST_TODO_NO_RECORDS_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_TODO_NO_RECORDS_DESCRIPTION',
        defaultMessage:
          'There are no certifications requiring your attention right now. \n Check back later for new assignments.',
      },
    },

    CERTS_LIST_TODO_ADMIN_NO_RECORDS_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_TODO_ADMIN_NO_RECORDS_MSG',
        defaultMessage: 'No Incomplete Certifications',
      },
    },

    CERTS_LIST_ADMIN_NO_RECORDS_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ADMIN_NO_RECORDS_DESCRIPTION',
        defaultMessage:
          'There are no certifications in progress for this campaign.',
      },
    },

    CERTS_LIST_DONE_NO_RECORDS_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_DONE_NO_RECORDS_MSG',
        defaultMessage: 'No Completed Certifications',
      },
    },

    CERTS_LIST_DONE_NO_RECORDS_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_DONE_NO_RECORDS_DESCRIPTION',
        defaultMessage:
          'Once you submit a certification, they will get placed here.',
      },
    },

    CERTS_LIST_ADMIN_DONE_NO_RECORDS_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ADMIN_DONE_NO_RECORDS_MSG',
        defaultMessage: 'No Complete Certifications',
      },
    },

    CERTS_LIST_ADMIN_DONE_NO_RECORDS_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ADMIN_DONE_NO_RECORDS_DESCRIPTION',
        defaultMessage:
          'No certifications have been submitted yet. Certifications will appear here after submission.',
      },
    },

    CERTS_LIST_ALL_NO_RECORDS_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ALL_NO_RECORDS_MSG',
        defaultMessage: 'No Certifications Available',
      },
    },

    CERTS_LIST_ALL_NO_RECORDS_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ALL_NO_RECORDS_DESCRIPTION',
        defaultMessage:
          'There are currently no certifications assigned to you. \n Check back later or contact your administrator if this is unexpected.',
      },
    },

    CERTS_LIST_ADMIN_ALL_NO_RECORDS_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ADMIN_ALL_NO_RECORDS_MSG',
        defaultMessage: 'No Certifications Available',
      },
    },

    CERTS_LIST_ADMIN_ALL_NO_RECORDS_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ADMIN_ALL_NO_RECORDS_DESCRIPTION',
        defaultMessage:
          'There are no certifications in this campaign. \n Check the campaign configurations if this is unexpected.',
      },
    },

    CERTS_CONFIGURE_CAMPAIGN: {
      ATTESTATIONS: {
        id: 'CERTS_CONFIGURE_CAMPAIGN',
        defaultMessage: 'Configure Campaign',
      },
    },
    CERTS_CLEAR_FILTERS: {
      ATTESTATIONS: {
        id: 'CERTS_CLEAR_FILTERS',
        defaultMessage: 'Clear Filters',
      },
    },

    CERTS_CLEAR_SEARCH: {
      ATTESTATIONS: {
        id: 'CERTS_CLEAR_SEARCH',
        defaultMessage: 'Clear Search',
      },
    },

    CERTS_FILTERS_NO_RECORDS_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_CLEAR_FILTERS',
        defaultMessage: 'No Records Match Your Filters',
      },
    },
    CERTS_FILTERS_NO_RECORDS_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_FILTERS_NO_RECORDS_DESCRIPTION',
        defaultMessage:
          ' No certifications match the applied filters. \n Modify or clear your filters to view more certifications.',
      },
    },

    CERTS_SEARCH_NO_RECORDS_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_SEARCH_NO_RECORDS_MSG',
        defaultMessage: 'No Records Match Your Search',
      },
    },

    CERTS_SEACRH_NO_RECORDS_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_SEACRH_NO_RECORDS_DESCRIPTION',
        defaultMessage: 'Clear your search or select a different view.',
      },
    },
    CERTS_SMART_FILTERS: {
      ATTESTATIONS: {
        id: 'CERTS_SMART_FILTERS',
        defaultMessage: 'Smart Filters',
      },
    },
    CERTS_TOTAL_RESULTS: {
      ATTESTATIONS: {
        id: 'CERTS_TOTAL_RESULTS',
        defaultMessage: 'Total Results',
      },
    },
    CERTS_SMART_REVIEW_APPLIED: {
      ATTESTATIONS: {
        id: 'CERTS_SMART_REVIEW_APPLIED',
        defaultMessage: 'Smart Review Applied',
      },
    },
    CERTS_SMART_REVIEW_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_SMART_REVIEW_DESCRIPTION',
        defaultMessage:
          'I moved the Smart Review items here. You must confirm all of the decisions I made before submitting your certification.',
      },
    },
    CERTS_TODO_TOOLTIP: {
      ATTESTATIONS: {
        id: 'CERTS_TODO_TOOLTIP',
        defaultMessage: 'Items waiting to be certified',
      },
    },
    CERTS_DONE_TOOLTIP: {
      ATTESTATIONS: {
        id: 'CERTS_DONE_TOOLTIP',
        defaultMessage: 'Items that have been certified',
      },
    },
    CERTS_ALL_TOOLTIP: {
      ATTESTATIONS: {
        id: 'CERTS_ALL_TOOLTIP',
        defaultMessage: 'All items included in the certification',
      },
    },
    CERTS_CONSULTED_TOOLTIP: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULTED_TOOLTIP',
        defaultMessage: 'Items that have been sent for consultation',
      },
    },
    CERTS_ACTION_FAILED: {
      ATTESTATIONS: {
        id: 'CERTS_ACTION_FAILED',
        defaultMessage: 'Action Failed',
      },
    },
    CERTS_SAVI_INTRO_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_INTRO_DESCRIPTION',
        defaultMessage:
          "If you'd like me to save you time and make some intelligence-based decisions for you, I'll be right here.",
      },
    },
    CERTS_FILTER: {
      ATTESTATIONS: {
        id: 'CERTS_FILTER',
        defaultMessage: 'Filter',
      },
    },
    CERTS_GROUP_BY: {
      ATTESTATIONS: {
        id: 'CERTS_GROUP_BY',
        defaultMessage: 'Group By',
      },
    },
    CERTS_ROWS: {
      ATTESTATIONS: {
        id: 'CERTS_ROWS',
        defaultMessage: 'Rows',
      },
    },
    CERTS_COLUMNS: {
      ATTESTATIONS: {
        id: 'CERTS_COLUMNS',
        defaultMessage: 'Columns',
      },
    },
    CERTS_SAVI_FILTERS: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_FILTERS',
        defaultMessage: 'Savi Filters',
      },
    },
    CERTIFIED_ACTION_FILTERS: {
      ATTESTATIONS: {
        id: 'CERTIFIED_ACTION_FILTERS',
        defaultMessage: 'Action Filters',
      },
    },
    CERTS_SAVI_APPROVED: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_APPROVED',
        defaultMessage: 'Savi Approved',
      },
    },
    CERTS_SAVI_REJECTED: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_REJECTED',
        defaultMessage: 'Savi Rejected',
      },
    },
    CERTS_ADD_OR_REMOVE_FILTERS: {
      ATTESTATIONS: {
        id: 'CERTS_ADD_OR_REMOVE_FILTERS',
        defaultMessage: 'Add or Remove Filters',
      },
    },
    CERTS_ADD_FILTER: {
      ATTESTATIONS: {
        id: 'CERTS_ADD_FILTER',
        defaultMessage: 'Add Filter',
      },
    },
    CERTS_REVIEW_DECISION: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_DECISION',
        defaultMessage: 'Review Decision',
      },
    },
    CERTS_CANCEL_TERMINATION: {
      ATTESTATIONS: {
        id: 'CERTS_CANCEL_TERMINATION',
        defaultMessage: 'Cancel Termination',
      },
    },
    CERTS_CANCEL_REJECTION: {
      ATTESTATIONS: {
        id: 'CERTS_CANCEL_REJECTION',
        defaultMessage: 'Cancel Rejection',
      },
    },
    CERTS_CANCEL_END_DATE_CHANGE: {
      ATTESTATIONS: {
        id: 'CERTS_CANCEL_END_DATE_CHANGE',
        defaultMessage: 'Cancel End Date Change',
      },
    },
    CERTS_CONSULT_USERNAME_TEXT: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULT_USERNAME_TEXT',
        defaultMessage: 'Consultations pending with {userInfo}',
      },
    },
    CERTS_CONSULT_MULTIPLE_USERS_TEXT: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULT_MULTIPLE_USERS_TEXT',
        defaultMessage: `Consultations pending with ({count}) peers`,
      },
    },
    CERTS_APPROVE: {
      ATTESTATIONS: {
        id: 'CERTS_APPROVE',
        defaultMessage: 'Approve this',
      },
    },
    CERTS_CONFIRM_MANAGER: {
      ATTESTATIONS: {
        id: 'CERTS_CONFIRM_MANAGER',
        defaultMessage: 'Confirm Manager for this',
      },
    },
    CERTS_EXTEND_END_DATE: {
      ATTESTATIONS: {
        id: 'CERTS_EXTEND_END_DATE',
        defaultMessage: 'Extend End Date',
      },
    },
    CERTS_CONDITIONALLY_CERTIFY: {
      ATTESTATIONS: {
        id: 'CERTS_CONDITIONALLY_CERTIFY',
        defaultMessage: 'Certify Conditionally',
      },
    },
    CERTS_REASSIGN_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_REASSIGN_TITLE',
        defaultMessage:
          'By reassigning this {lineItem}, their associated items will be included. Any approvals or rejections will be cleared upon reassignment.',
      },
    },
    CERTS_REASSIGN_SUBTITLE_USER: {
      ATTESTATIONS: {
        id: 'CERTS_REASSIGN_SUBTITLE_USER',
        defaultMessage:
          'Assign the {lineItem} and their associated items to another certifier, and provide a reason. Any approvals or rejections will be cleared upon reassignment.',
      },
    },
    CERTS_REASSIGN_SUBTITLE: {
      ATTESTATIONS: {
        id: 'CERTS_REASSIGN_SUBTITLE',
        defaultMessage:
          'Assign the {lineItem} to another certifier and provide a reason. Any approvals or rejections will be cleared upon reassignment.',
      },
    },
    CERTS_ATTRIBUTES: {
      ATTESTATIONS: {
        id: 'CERTS_ATTRIBUTES',
        defaultMessage: ' Attributes',
      },
    },
    CERTS_ACCESS_REQUEST: {
      ATTESTATIONS: {
        id: 'CERTS_ACCESS_REQUEST',
        defaultMessage: ' Access Request',
      },
    },
    CERTS_REASSIGNED_BY: {
      ATTESTATIONS: {
        id: 'CERTS_REASSIGNED_BY',
        defaultMessage: ' Reassigned By',
      },
    },
    CERTS_CONSULTED_BY: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULTED_BY',
        defaultMessage: ' Consulted By',
      },
    },
    CERTS_CONSULTED_ON: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULTED_ON',
        defaultMessage: ' Consulted On',
      },
    },
    CERTS_REJECTED: {
      ATTESTATIONS: {
        id: 'CERTS_REJECTED',
        defaultMessage: ' Rejected',
      },
    },
    CERTS_REJECTED_BY: {
      ATTESTATIONS: {
        id: 'CERTS_REJECTED_BY',
        defaultMessage: ' Rejected By',
      },
    },
    CERTS_REJECTED_ON: {
      ATTESTATIONS: {
        id: 'CERTS_REJECTED_ON',
        defaultMessage: ' Rejected On',
      },
    },

    CERTS_APPROVED: {
      ATTESTATIONS: {
        id: 'CERTS_APPROVED',
        defaultMessage: ' Approved',
      },
    },
    CERTS_APPROVED_BY: {
      ATTESTATIONS: {
        id: 'CERTS_APPROVED_BY',
        defaultMessage: ' Approved By',
      },
    },
    CERTS_APPROVED_ON: {
      ATTESTATIONS: {
        id: 'CERTS_APPROVED_ON',
        defaultMessage: ' Approved On',
      },
    },

    CERTS_WORKS_FOR_ME: {
      ATTESTATIONS: {
        id: 'CERTS_WORKS_FOR_ME',
        defaultMessage: ' Works For Me',
      },
    },

    CERTS_RESET: {
      ATTESTATIONS: {
        id: 'CERTS_RESET',
        defaultMessage: ' Reset',
      },
    },
    CERTS_CERTIFIED: {
      ATTESTATIONS: {
        id: 'CERTS_CERTIFIED',
        defaultMessage: ' Certified',
      },
    },
    CERTS_CERTIFIED_BY: {
      ATTESTATIONS: {
        id: 'CERTS_CERTIFIED_BY',
        defaultMessage: ' Certified By',
      },
    },
    CERTS_CERTIFIED_ON: {
      ATTESTATIONS: {
        id: 'CERTS_CERTIFIED_ON',
        defaultMessage: ' Certified On',
      },
    },
    CERTS_BACK: {
      ATTESTATIONS: {
        id: 'CERTS_BACK',
        defaultMessage: 'Back',
      },
    },
    CERTS_COMMENTS_BOX_LABEL: {
      ATTESTATIONS: {
        id: 'CERTS_COMMENTS_BOX_LABEL',
        defaultMessage: 'Comments: ',
      },
    },
    CERTS_BULK_SELECTED: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_SELECTED',
        defaultMessage: 'Selected: ',
      },
    },
    CERTS_BULK_CLEAR_SELECTION: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_CLEAR_SELECTION',
        defaultMessage: 'Clear Selection',
      },
    },
    CERTS_BULK_NOTHING_SELECTED: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_NOTHING_SELECTED',
        defaultMessage: "You've selected nothing",
      },
    },
    CERTS_BULK_USER: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_USER',
        defaultMessage: 'User',
      },
    },
    CERTS_BULK_USERS: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_USERS',
        defaultMessage: 'Users',
      },
    },
    CERTS_BULK_ACCOUNT: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_ACCOUNT',
        defaultMessage: 'Account',
      },
    },
    CERTS_BULK_ACCOUNTS: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_ACCOUNTS',
        defaultMessage: 'Accounts',
      },
    },
    CERTS_BULK_ROLE: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_ROLE',
        defaultMessage: 'Role',
      },
    },
    CERTS_BULK_ROLES: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_ROLES',
        defaultMessage: 'Roles',
      },
    },
    CERTS_BULK_ENTITLEMENT: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_ENTITLEMENT',
        defaultMessage: 'Entitlement',
      },
    },
    CERTS_BULK_ENTITLEMENTS: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_ENTITLEMENTS',
        defaultMessage: 'Entitlements',
      },
    },
    CERTS_BULK_PARENT_ENTITLEMENTS: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_PARENT_ENTITLEMENTS',
        defaultMessage: 'Entitlements',
      },
    },
    CERTS_BULK_PARENT_ENTITLEMENT: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_PARENT_ENTITLEMENT',
        defaultMessage: 'Entitlement',
      },
    },
    CERTS_BULK_CHILD_ENTITLEMENTS: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_CHILD_ENTITLEMENTS',
        defaultMessage: 'Child Entitlements',
      },
    },
    CERTS_BULK_CHILD_ENTITLEMENT: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_CHILD_ENTITLEMENT',
        defaultMessage: 'Child Entitlement',
      },
    },
    CERTS_BULK_WORKS_FOR_ME: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_WORKS_FOR_ME',
        defaultMessage: 'Approve',
      },
    },
    CERTS_BULK_DOES_NOT_WORK_FOR_ME: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_DOES_NOT_WORK_FOR_ME',
        defaultMessage: 'Reassign',
      },
    },
    'Certs.ReassignAccount.Label': {
      ATTESTATIONS: {
        id: 'Certs.ReassignAccount.Label',
        defaultMessage: 'Reassign Account',
      },
    },
    'Certs.ReassignEntitlement.Label': {
      ATTESTATIONS: {
        id: 'Certs.ReassignEntitlement.Label',
        defaultMessage: 'Reassign Entitlement',
      },
    },
    CERTS_BULK_TERMINATE: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_TERMINATE',
        defaultMessage: 'Terminate',
      },
    },
    CERTS_BULK_EXTEND_END_DATE: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_EXTEND_END_DATE',
        defaultMessage: 'Extend End Date For User',
      },
    },
    CERTS_BULK_APPROVE: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_APPROVE',
        defaultMessage: 'Approve',
      },
    },
    CERTS_BULK_REJECT: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_REJECT',
        defaultMessage: 'Reject Access',
      },
    },
    CERTS_BULK_CONDITIONAL_CERTIFIY: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_CONDITIONAL_CERTIFIY',
        defaultMessage: 'Change End Date For Access',
      },
    },
    CERTS_BULK_REASSIGN: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_REASSIGN',
        defaultMessage: 'Reassign Access',
      },
    },
    CERTS_BULK_CONSULT: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_CONSULT',
        defaultMessage: 'Consult',
      },
    },
    CERTS_BULK_DECOMMISSION: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_DECOMMISSION',
        defaultMessage: 'Decommission',
      },
    },
    'CERTS_BULK_DECOMMISSION.all': {
      ATTESTATIONS: {
        id: 'CERTS_BULK_DECOMMISSION.all',
        defaultMessage: 'Decommission All',
      },
    },
    CERTS_BULK_DECOMMISSION_HEADER_ACCESSES: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_DECOMMISSION_HEADER_ACCESSES',
        defaultMessage: 'Decommission for {count} Items?',
      },
    },
    CERTS_BULK_DECOMMISSION_HEADER_ACCESS: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_DECOMMISSION_HEADER_ACCESS',
        defaultMessage: 'Decommission for {count} Item?',
      },
    },
    CERTS_BULK_COMMON_SUB_PRE_DECOMMISSION: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_COMMON_SUB_PRE_DECOMMISSION',
        defaultMessage: 'You are decommissioning {count}',
      },
    },
    CERTS_BULK_BELONGS_TO_ME: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_BELONGS_TO_ME',
        defaultMessage: 'Belongs to Me',
      },
    },
    CERTS_BULK_MORE: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_MORE',
        defaultMessage: 'More',
      },
    },
    CERTS_BULK_LESS: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_LESS',
        defaultMessage: 'Less',
      },
    },
    CERTS_BULK_UNKNOWN_ACTION: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_UNKNOWN_ACTION',
        defaultMessage: 'Unknown Action',
      },
    },
    CERTS_BULK_TERMINATE_HEADER_USERS: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_TERMINATE_HEADER_USERS',
        defaultMessage: 'Terminate Users and Access',
      },
    },
    CERTS_BULK_TERMINATE_HEADER_USER: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_TERMINATE_HEADER_USER',
        defaultMessage: 'Terminate User and Access',
      },
    },
    CERTS_BULK_REJECT_HEADER_ACCESSES: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_REJECT_HEADER_ACCESSES',
        defaultMessage: 'Reject Access for {count} Items?',
      },
    },
    CERTS_BULK_REJECT_HEADER_ACCESS: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_REJECT_HEADER_ACCESS',
        defaultMessage: 'Reject Access for {count} Item?',
      },
    },
    CERTS_BULK_APPROVE_HEADER_ACCESSES: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_APPROVE_HEADER_ACCESSES',
        defaultMessage: 'Approve {count} Items?',
      },
    },
    CERTS_BULK_APPROVE_HEADER_ACCESS: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_APPROVE_HEADER_ACCESS',
        defaultMessage: 'Approve {count} Item?',
      },
    },
    CERTS_BULK_ACTION_HEADER_ACCESSES: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_ACTION_HEADER_ACCESSES',
        defaultMessage: 'Action on {count} Items?',
      },
    },
    CERTS_BULK_ACTION_HEADER_ACCESS: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_ACTION_HEADER_ACCESS',
        defaultMessage: 'Action on {count} Item?',
      },
    },
    CERTS_BULK_TERMINATE_SUB_1: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_TERMINATE_SUB_1',
        defaultMessage:
          "Do you want to terminate these users and revoke all their access? Termination won't be fulfilled right away. It'll take effect after you finish your review and submit.",
      },
    },
    CERTS_BULK_TERMINATE_SUB_2: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_TERMINATE_SUB_2',
        defaultMessage:
          "Do you want to terminate this user and revoke all their access? Termination won't be fulfilled right away. It'll take effect after you finish your review and submit.",
      },
    },
    CERTS_BULK_TERMINATE_SUB_3: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_TERMINATE_SUB_3',
        defaultMessage:
          "Termination won't be fulfilled right away. It'll take effect after you finish your review and submit.",
      },
    },
    CERTS_BULK_COMMON_SUB_PRE_APPROVE: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_COMMON_SUB_PRE_APPROVE',
        defaultMessage: 'You are approving {count}',
      },
    },
    CERTS_BULK_COMMON_SUB_PRE_REJECT: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_COMMON_SUB_PRE_REJECT',
        defaultMessage: 'You are rejecting {count}',
      },
    },
    CERTS_BULK_COMMON_SUB_PRE_TERMINATE: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_COMMON_SUB_PRE_TERMINATE',
        defaultMessage: 'You are terminating {count}',
      },
    },
    CERTS_BULK_COMMON_USERS_SUB: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_COMMON_USERS_SUB',
        defaultMessage:
          'You are confirming that you are the Certifier for {count} Users',
      },
    },
    CERTS_BULK_COMMON_USER_SUB: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_COMMON_USER_SUB',
        defaultMessage:
          'You are confirming that you are the Certifier for {count} User',
      },
    },
    CERTS_BULK_AND: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_AND',
        defaultMessage: 'and',
      },
    },
    CERTS_BULK_ACTION_FAILED: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_ACTION_FAILED',
        defaultMessage: "The {action} for {lineitem} wasn't successful",
      },
    },
    CERT_BULK_ITEM_TO_CONSULT: {
      ATTESTATIONS: {
        id: 'CERT_BULK_ITEM_TO_CONSULT',
        defaultMessage: 'Items to Consult',
      },
    },
    CERT_BULK_CONSULT_TOOLTIP_MULTIPLE: {
      ATTESTATIONS: {
        id: 'CERT_BULK_CONSULT_TOOLTIP_MULTIPLE',
        defaultMessage: 'Access items associated with these users are included',
      },
    },
    CERT_BULK_CONSULT_TOOLTIP_SINGLE: {
      ATTESTATIONS: {
        id: 'CERT_BULK_CONSULT_TOOLTIP_SINGLE',
        defaultMessage: 'Access items associated with this user are included',
      },
    },
    CERT_BULK_CONSULT_TOOLTIP_MULTIPLE_EO: {
      ATTESTATIONS: {
        id: 'CERT_BULK_CONSULT_TOOLTIP_MULTIPLE_EO',
        defaultMessage:
          'Access items associated with these entitlements are included',
      },
    },
    CERT_BULK_CONSULT_TOOLTIP_SINGLE_EO: {
      ATTESTATIONS: {
        id: 'CERT_BULK_CONSULT_TOOLTIP_SINGLE_EO',
        defaultMessage:
          'Access items associated with this entitlement are included',
      },
    },
    CERT_BULK_CED_NEW_DATE: {
      ATTESTATIONS: {
        id: 'CERT_BULK_CED_NEW_DATE',
        defaultMessage: 'New End Date',
      },
    },
    CERT_BULK_CED_COUNT_HEADER_MULTIPLE: {
      ATTESTATIONS: {
        id: 'CERT_BULK_CED_COUNT_HEADER_MULTIPLE',
        defaultMessage: "Change {count} Items' End Date?",
      },
    },
    CERT_BULK_CED_COUNT_HEADER_SINGLE: {
      ATTESTATIONS: {
        id: 'CERT_BULK_CED_COUNT_HEADER_SINGLE',
        defaultMessage: "Change {count} Item's End Date?",
      },
    },
    CERT_BULK_ENDDATE_SUFFIX_MESSAGE: {
      ATTESTATIONS: {
        id: 'CERT_BULK_ENDDATE_SUFFIX_MESSAGE',
        defaultMessage:
          "The end date won't be changed until you finish the review and submit.",
      },
    },
    CERTS_BULK_CED_SELECTED: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_CED_SELECTED',
        defaultMessage: "You've selected",
      },
    },
    CERT_BULK_REASSIGN_SKIP_CERTIFIER: {
      ATTESTATIONS: {
        id: 'CERT_BULK_REASSIGN_SKIP_CERTIFIER',
        defaultMessage: 'Skip selecting certifier',
      },
    },
    CERT_BULK_REASSIGN_SELECT_CERTIFIER: {
      ATTESTATIONS: {
        id: 'CERT_BULK_REASSIGN_SELECT_CERTIFIER',
        defaultMessage: 'Select certifier',
      },
    },
    CERT_BULK_REASSIGN_DEPENDENT_MSG: {
      ATTESTATIONS: {
        id: 'CERT_BULK_REASSIGN_DEPENDENT_MSG',
        defaultMessage: 'Dependent parent will be approved',
      },
    },
    CERT_BULK_REASSIGN_SELECTED_USERS: {
      ATTESTATIONS: {
        id: 'CERT_BULK_REASSIGN_SELECTED_USERS',
        defaultMessage: 'Selected Users',
      },
    },
    CERT_BULK_REASSIGN_SELECTED_ITEMS: {
      ATTESTATIONS: {
        id: 'CERT_BULK_REASSIGN_SELECTED_ITEMS',
        defaultMessage: 'Selected Items',
      },
    },
    CERT_BULK_REASSIGN_HEADER: {
      ATTESTATIONS: {
        id: 'CERT_BULK_REASSIGN_HEADER',
        defaultMessage: 'Reassign {count} {title}',
      },
    },
    CERTS_BULK_ITEMS: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_ITEMS',
        defaultMessage: 'Items',
      },
    },
    CERTS_BULK_ITEM: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_ITEM',
        defaultMessage: 'Item',
      },
    },
    CERTS_BULK_REASSIGN_SUB_1: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_REASSIGN_SUB_1',
        defaultMessage:
          'You are confirming that you are NOT the Certifier for the {count} User(s) selected.',
      },
    },
    CERTS_BULK_REASSIGN_SUB_2: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_REASSIGN_SUB_2',
        defaultMessage:
          'You are confirming that you are NOT the Certifier for the {count} User(s) selected.',
      },
    },
    CERTS_BULK_REASSIGN_SUB_3: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_REASSIGN_SUB_3',
        defaultMessage:
          'You are confirming that you are NOT the Certifier for the {count}',
      },
    },
    CERTS_BULK_REASSIGN_SUB_1_EO: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_REASSIGN_SUB_1_EO',
        defaultMessage:
          'You are confirming that you are NOT the Certifier for the {count} Entitlement(s) selected.',
      },
    },
    CERTS_BULK_REASSIGN_SUB_2_EO: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_REASSIGN_SUB_2_EO',
        defaultMessage:
          'You are confirming that you are NOT the Certifier for the {count} Entitlement(s) selected.',
      },
    },
    CERTS_BULK_REASSIGN_SUB_3_EO: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_REASSIGN_SUB_3_EO',
        defaultMessage:
          'You are confirming that you are NOT the Certifier for the {count}',
      },
    },
    CERTS_BULK_REASSIGN_ACC_1: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_REASSIGN_ACC_1',
        defaultMessage:
          'You are confirming that you are NOT the Certifier for the {count} Account(s) selected.',
      },
    },
    CERTS_BULK_REASSIGN_ACC_2: {
      ATTESTATIONS: {
        id: 'CERTS_BULK_REASSIGN_ACC_2',
        defaultMessage:
          'You are confirming that you are NOT the Certifier for the {count} Account(s) selected.',
      },
    },
    CERTS_DETAILS_CAUGHT_UP_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_CAUGHT_UP_TITLE',
        defaultMessage: "You're All Caught Up",
      },
    },
    CERTS_DETAILS_CAUGHT_UP_BODY: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_CAUGHT_UP_BODY',
        defaultMessage:
          'Your certification is all caught up. Click here to continue!',
      },
    },
    CERTS_DETAILS_CAUGHT_UP_BUTTON: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_CAUGHT_UP_BUTTON',
        defaultMessage: 'Go Back',
      },
    },
    CERTS_DETAILS_NO_MATCH_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_NO_MATCH_TITLE',
        defaultMessage: 'No Records Match Your Search',
      },
    },
    CERTS_DETAILS_NO_MATCH_BODY: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_NO_MATCH_BODY',
        defaultMessage:
          "If you can't see your items, try clearing your search or selecting a different view.",
      },
    },
    CERTS_DETAILS_NO_MATCH_BUTTON: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_NO_MATCH_BUTTON',
        defaultMessage: 'Clear Search',
      },
    },
    CERTS_DETAILS_CLEAR_FILTER_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_CLEAR_FILTER_TITLE',
        defaultMessage: 'Need to Clear Your Filters?',
      },
    },
    CERTS_DETAILS_CLEAR_FILTER_BODY_1: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_CLEAR_FILTER_BODY_1',
        defaultMessage:
          'To see your ({count}) remaining to-do items, make sure to clear the filters you applied.',
      },
    },
    CERTS_DETAILS_CLEAR_FILTER_BODY_2: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_CLEAR_FILTER_BODY_2',
        defaultMessage:
          "If you can't see your items, try clearing your filters or selecting a different view.",
      },
    },
    CERTS_DETAILS_CLEAR_FILTER_BUTTON: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_CLEAR_FILTER_BUTTON',
        defaultMessage: 'Clear Filters',
      },
    },
    CERTS_DETAILS_CERT_READY_TITLE_1: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_CERT_READY_TITLE_1',
        defaultMessage: 'Your Certification Is Ready to Be Submitted',
      },
    },
    CERTS_DETAILS_CERT_READY_TITLE_2: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_CERT_READY_TITLE_2',
        defaultMessage: 'Your Certification Is Ready to Be Completed',
      },
    },
    CERTS_DETAILS_CERT_READY_BODY_1: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_CERT_READY_BODY_1',
        defaultMessage:
          "Now that you've completed your certification, you can review a summary of the items you're certifying and submit your certification review.",
      },
    },
    CERTS_DETAILS_CERT_READY_BODY_2: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_CERT_READY_BODY_2',
        defaultMessage:
          "Now that you've taken action on all items in your certification, you can review a summary of the items you're certifying and complete your certification review.",
      },
    },
    CERTS_DETAILS_PEND_CONSULT_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_PEND_CONSULT_TITLE',
        defaultMessage: 'Pending Items For Consultation',
      },
    },
    CERTS_DETAILS_PEND_CONSULT_BODY: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_PEND_CONSULT_BODY',
        defaultMessage:
          "You have pending items that are being consulted with another certifier. Once completed, you can review a summary of the items you're certifying and submit your certification.",
      },
    },
    CERTS_DETAILS_PEND_CONSULT_BUTTON: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_PEND_CONSULT_BUTTON',
        defaultMessage: 'View Consulted List',
      },
    },
    CERTS_DETAILS_ALL_DONE_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_ALL_DONE_TITLE',
        defaultMessage: "You're All Done!",
      },
    },
    CERTS_DETAILS_ALL_DONE_BODY: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_ALL_DONE_BODY',
        defaultMessage:
          'Your certification has been submitted. If you want a report of your certification for your records, you can export a summary now.',
      },
    },
    CERTS_DETAILS_NOT_CERTIFIED_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_NOT_CERTIFIED_TITLE',
        defaultMessage: 'No Items Certified Yet',
      },
    },
    CERTS_DETAILS_NOT_CERTIFIED_BODY: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_NOT_CERTIFIED_BODY',
        defaultMessage:
          "Once you start approving or rejecting items in your to-do list, they'll get placed here for you to review as you complete your certification.",
      },
    },
    CERTS_DETAILS_NOT_CERTIFIED_BUTTON: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_NOT_CERTIFIED_BUTTON',
        defaultMessage: 'View To-Do List',
      },
    },
    CERTS_DETAILS_MOV_CONSULT_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_MOV_CONSULT_TITLE',
        defaultMessage: 'No Items Moved To Consult Yet',
      },
    },
    CERTS_DETAILS_MOV_CONSULT_BODY: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_MOV_CONSULT_BODY',
        defaultMessage:
          "Once you start consulting items from your to-do list, they'll get placed here.",
      },
    },
    CERTS_DETAILS_ALL_LIST_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_ALL_LIST_TITLE',
        defaultMessage: 'No Items Available To Show',
      },
    },
    CERTS_DETAILS_ALL_LIST_BODY: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_ALL_LIST_BODY',
        defaultMessage:
          'You do not have any items here for action. Go to All tab to view your items.',
      },
    },
    CERTS_DETAILS_ALL_LIST_BUTTON: {
      ATTESTATIONS: {
        id: 'CERTS_DETAILS_ALL_LIST_BUTTON',
        defaultMessage: 'View All List',
      },
    },
    CERTS_REVIEW_AND_SUBMIT: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_AND_SUBMIT',
        defaultMessage: 'Review and Submit',
      },
    },
    CERTS_PROGRESS_DECISION_LOAD_ERROR: {
      ATTESTATIONS: {
        id: 'CERTS_PROGRESS_DECISION_LOAD_ERROR',
        defaultMessage:
          'Couldn&apos;t load decision progress breakdown data. Please refresh or try again later.',
      },
    },
    CERTS_PROGRESS_TYPE_LOAD_ERROR: {
      ATTESTATIONS: {
        id: 'CERTS_PROGRESS_TYPE_LOAD_ERROR',
        defaultMessage:
          'Couldn&apos;t load type progress breakdown data. Please refresh or try again later.',
      },
    },
    CERTS_STEP1_NO_DATE_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_STEP1_NO_DATE_MSG',
        defaultMessage: 'Not able to show summary for this certification.',
      },
    },
    CERTS_PROGRESS_DETAILS: {
      ATTESTATIONS: {
        id: 'CERTS_PROGRESS_DETAILS',
        defaultMessage: 'Progress Details',
      },
    },
    CERTS_SAVI_RECOMMENDATIONS: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_RECOMMENDATIONS',
        defaultMessage: ' Recommendations',
      },
    },
    CERTS_SAVI_BRAND_NAME: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_BRAND_NAME',
        defaultMessage: 'Savi',
      },
    },

    CERTS_SAVI_AI_COMPANION_LABEL: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_AI_COMPANION_LABEL',
        defaultMessage: 'your AI Companion',
      },
    },
    CERTS_SAVI_HI_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_HI_MSG',
        defaultMessage: "Hi, I'm",
      },
    },

    CERTS_SAVI_MAKE_SMART_DECISIONS: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_MAKE_SMART_DECISIONS',
        defaultMessage: 'Make Smart Decisions for You',
      },
    },

    CERTS_SAVI_TRUST_RISK_RECOMMENDATION: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_HI_MSG',
        defaultMessage:
          " I'll recommend decisions based on multiple trust and risk factors and you can review the reasons and change the decisions before you submit.",
      },
    },

    CERTS_SAVI_REVIEW_ON_OWN: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_REVIEW_ON_OWN',
        defaultMessage: ' Review on Your Own',
      },
    },

    CERTS_SAVI_REVIEW_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_REVIEW_MSG',
        defaultMessage:
          'Go ahead and conduct your certification review without intelligence-based assistance.',
      },
    },

    CERTS_SAVI_APPROVE_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_APPROVE_MSG',
        defaultMessage:
          'Includes items identified as High Peer Match Score, Approved in Saviynt, Low Risk Entitlements and Birthright Access Origins.',
      },
    },

    CERTS_SAVI_APPROVALS: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_APPROVALS',
        defaultMessage: ' Approvals',
      },
    },

    CERTS_SAVI_REJECTIONS: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_REJECTIONS',
        defaultMessage: 'Rejections',
      },
    },
    CERTS_SAVI_REVOKE_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_REVOKE_MSG',
        defaultMessage:
          'Includes items with Low Peer Match, Unused Accounts, Access Conflicts (SoD)',
      },
    },
    CERTS_EXPORT_SEARCH_APPLIED: {
      ATTESTATIONS: {
        id: 'CERTS_EXPORT_SEARCH_APPLIED',
        defaultMessage: 'Search applied',
      },
    },
    CERTS_INCLUDE_ASSOCIATED_ITEMS: {
      ATTESTATIONS: {
        id: 'CERTS_INCLUDE_ASSOCIATED_ITEMS',
        defaultMessage: 'Include Associated Items',
      },
    },
    CERTS_INCLUDE_ALL_ASSOCIATED_ITEMS: {
      ATTESTATIONS: {
        id: 'CERTS_INCLUDE_ALL_ASSOCIATED_ITEMS',
        defaultMessage:
          'Include Associated Items (Account, Entitlements and Application Roles)',
      },
    },
    CERTS_INCLUDE_ENT_ROLE_ITEMS: {
      ATTESTATIONS: {
        id: 'CERTS_INCLUDE_ENT_ROLE_ITEMS',
        defaultMessage:
          'Include Associated Items (Entitlements and Application Roles)',
      },
    },
    CERTS_DEPENDENT_PARENT_APPROVED: {
      ATTESTATIONS: {
        id: 'CERTS_DEPENDENT_PARENT_APPROVED',
        defaultMessage: 'Dependent parent will be approved',
      },
    },
    CERTS_LIST_USER_SUMMARY_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_USER_SUMMARY_MSG',
        defaultMessage: "There's no summary available for this user.",
      },
    },
    CERTS_CHILDREN: {
      ATTESTATIONS: {
        id: 'CERTS_CHILDREN',
        defaultMessage: 'Children',
      },
    },
    CERTS_DEPENDENTS: {
      ATTESTATIONS: {
        id: 'CERTS_DEPENDENTS',
        defaultMessage: 'Dependents',
      },
    },
    CERTS_TRUST: {
      ATTESTATIONS: {
        id: 'CERTS_TRUST',
        defaultMessage: 'Trust',
      },
    },
    CERTS_HIGH: {
      ATTESTATIONS: {
        id: 'CERTS_HIGH',
        defaultMessage: 'High',
      },
    },
    CERTS_CONFLICTS: {
      ATTESTATIONS: {
        id: 'CERTS_CONFLICTS',
        defaultMessage: 'Conflicts',
      },
    },
    CERTS_PRIVILEGE: {
      ATTESTATIONS: {
        id: 'CERTS_PRIVILEGE',
        defaultMessage: 'Privilege',
      },
    },
    CERTS_RISK_PRIORITY: {
      ATTESTATIONS: {
        id: 'CERTS_RISK_PRIORITY',
        defaultMessage: 'Risk Priority',
      },
    },
    CERTS_CONFLICT_JOB_FUNCTIONS: {
      ATTESTATIONS: {
        id: 'CERTS_CONFLICT_JOB_FUNCTIONS',
        defaultMessage: 'Conflicting Job Functions',
      },
    },
    CERTS_LOAD_MORE: {
      ATTESTATIONS: {
        id: 'CERTS_LOAD_MORE',
        defaultMessage: 'Load More',
      },
    },
    CERTS_SIDEPANEL_TAB_HISTORY: {
      ATTESTATIONS: {
        id: 'CERTS_SIDEPANEL_TAB_HISTORY',
        defaultMessage:
          "The History tab didn't load properly due to a network issue. Please refresh or try again later.",
      },
    },
    CERTS_SIDEPANEL_TAB_SUMMARY: {
      ATTESTATIONS: {
        id: 'CERTS_SIDEPANEL_TAB_SUMMARY',
        defaultMessage:
          "The Summary tab didn't load properly due to a network issue. Please refresh or try again later.",
      },
    },
    CERTS_SIDEPANEL_TAB_SOD: {
      ATTESTATIONS: {
        id: 'CERTS_SIDEPANEL_TAB_SOD',
        defaultMessage:
          "The Access Conflicts tab didn't load properly due to a network issue. Please refresh or try again later.",
      },
    },
    CERTS_SIDEPANEL_TAB_PRIVILEGE: {
      ATTESTATIONS: {
        id: 'CERTS_SIDEPANEL_TAB_PRIVILEGE',
        defaultMessage:
          "The Privilege tab didn't load properly due to a network issue. Please refresh or try again later.",
      },
    },
    CERTS_SIDEPANEL_TAB_CHILDREN: {
      ATTESTATIONS: {
        id: 'CERTS_SIDEPANEL_TAB_CHILDREN',
        defaultMessage:
          "The Child Entitlements tab didn't load properly due to a network issue. Please refresh or try again later.",
      },
    },
    CERTS_SIDEPANEL_TAB_DEPENDENT: {
      ATTESTATIONS: {
        id: 'CERTS_SIDEPANEL_TAB_DEPENDENT',
        defaultMessage:
          "The Dependent Entitlements tab didn't load properly due to a network issue. Please refresh or try again later.",
      },
    },
    CERTS_SIDEPANEL_TAB_ENTITLEMENT: {
      ATTESTATIONS: {
        id: 'CERTS_SIDEPANEL_TAB_ENTITLEMENT',
        defaultMessage:
          "The Child Roles tab didn't load properly due to a network issue. Please refresh or try again later.",
      },
    },
    CERTS_SIDEPANEL_CHILD_ENT_PERMISSION_LABEL: {
      ATTESTATIONS: {
        id: 'CERTS_SIDEPANEL_CHILD_ENT_PERMISSION_LABEL',
        defaultMessage:
          'Dependent entitlements are subsets of access and permissions that are directly mapped to a parent entitlement. If the parent entitlement is revoked, these are also revoked.',
      },
    },
    CERTS_NEXT: {
      ATTESTATIONS: {
        id: 'CERTS_NEXT',
        defaultMessage: 'Next',
      },
    },
    CERTS_REMOVE_FILTER: {
      ATTESTATIONS: {
        id: 'CERTS_REMOVE_FILTER',
        defaultMessage: 'Remove Filter',
      },
    },
    CERTS_NO_DATA_AVAILABLE: {
      ATTESTATIONS: {
        id: 'CERTS_NO_DATA_AVAILABLE',
        defaultMessage: 'No data available',
      },
    },
    CERTS_SORT_DISABLED_ROLE_AND_ACC_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_SORT_DISABLED_ROLE_AND_ACC_MSG',
        defaultMessage:
          'Sorting is disabled because both Roles and Accounts are selected as top-level items in the Rows filter. To enable sorting, select only one top-level option in the filter.',
      },
    },
    CERTS_SORT_DISABLED_ROLE_AND_ENT_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_SORT_DISABLED_ROLE_AND_ENT_MSG',
        defaultMessage:
          'Sorting is disabled because both Roles and Entitlements are selected as top-level items in the Rows filter. To enable sorting, select only one top-level option in the filter.',
      },
    },
    CERTS_SAVI_RECOMMENDED_LABEL: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_RECOMMENDED_LABEL',
        defaultMessage: 'Recommended',
      },
    },
    REVIEW_CONSULTED_ITEMS: {
      ATTESTATIONS: {
        id: 'REVIEW_CONSULTED_ITEMS',
        defaultMessage: 'Consulted items that must be completed',
      },
    },
    REVIEW_TODO_ITEMS: {
      ATTESTATIONS: {
        id: 'REVIEW_TODO_ITEMS',
        defaultMessage: 'To-Do items that you must complete',
      },
    },
    REVIEW_SUBMIT_STEP1: {
      ATTESTATIONS: {
        id: 'REVIEW_SUBMIT_STEP1',
        defaultMessage: 'Step 1 of 2',
      },
    },
    REVIEW_SUBMIT_STEP2: {
      ATTESTATIONS: {
        id: 'REVIEW_SUBMIT_STEP2',
        defaultMessage: 'Step 2 of 2',
      },
    },
    REVIEW_TODO_DESCRIPTION: {
      ATTESTATIONS: {
        id: 'REVIEW_TODO_DESCRIPTION',
        defaultMessage:
          'You still have {reviewinfo} before your certification can be submitted.',
      },
    },
    REVIEW_CERTIFIED_DETAILS: {
      ATTESTATIONS: {
        id: 'REVIEW_CERTIFIED_DETAILS',
        defaultMessage:
          "Review the items you've certified, and send them to the primary certifier {name} who'll complete and submit the certification.",
      },
    },
    CERTIFICATION_LOCKED: {
      ATTESTATIONS: {
        id: 'CERTIFICATION_LOCKED',
        defaultMessage: 'Locked by User',
      },
    },
    REVIEW_CERTIFICTAION_NAME: {
      ATTESTATIONS: {
        id: 'REVIEW_CERTIFICTAION_NAME',
        defaultMessage:
          'Your certification {certificationName} has been submitted.',
      },
    },
    REVIEW_CERTIFICATION_SUBMITTED: {
      ATTESTATIONS: {
        id: 'REVIEW_CERTIFICATION_SUBMITTED',
        defaultMessage: 'Certification successfully submitted',
      },
    },
    CERTS_CANCEL_ACTION: {
      ATTESTATIONS: {
        id: 'CERTS_CANCEL_ACTION',
        defaultMessage: 'Cancel Action',
      },
    },
    CERTS_LOADER: {
      ATTESTATIONS: {
        id: 'CERTS_LOADER',
        defaultMessage: 'Loading',
      },
    },
    CERTS_CLEAR_FILTER: {
      ATTESTATIONS: {
        id: 'CERTS_CLEAR_FILTER',
        defaultMessage: 'Clear Filter',
      },
    },
    CERTS_CLEAR_ALL: {
      ATTESTATIONS: {
        id: 'CERTS_CLEAR_ALL',
        defaultMessage: 'Clear All',
      },
    },
    CERTS_FILTER_RESULTS: {
      ATTESTATIONS: {
        id: 'CERTS_FILTER_RESULTS',
        defaultMessage: 'See Results ({totalItems})',
      },
    },
    CERTS_APPLIED_TO_TYPES: {
      ATTESTATIONS: {
        id: 'CERTS_APPLIED_TO_TYPES',
        defaultMessage: 'Applied to: {types}',
      },
    },
    CERTS_LIST_ON: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_ON',
        defaultMessage: 'On',
      },
    },
    CERTS_LIST_OFF: {
      ATTESTATIONS: {
        id: 'CERTS_LIST_OFF',
        defaultMessage: 'Off',
      },
    },
    'COULD_NOT_LOAD.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'COULD_NOT_LOAD.ATTESTATIONS',
        defaultMessage: "Couldn't Load",
      },
    },
    CERTS_SIDEPANEL_TAB_PROGRESS: {
      ATTESTATIONS: {
        id: 'CERTS_SIDEPANEL_TAB_PROGRESS',
        defaultMessage:
          "The Progress tab didn't load properly due to a network issue. Please refresh or try again later.",
      },
    },
    CERTS_SAVI_ACTION_ITEMS_INFO: {
      ATTESTATIONS: {
        id: 'CERTS_SAVI_ACTION_ITEMS_INFO',
        defaultMessage: 'Smart {action} {count} {pluralizeItems}',
      },
    },
    SAVI_REVIEW_ACTION_CONFIRMATION: {
      ATTESTATIONS: {
        id: 'SAVI_REVIEW_ACTION_CONFIRMATION',
        defaultMessage:
          'All Smart {reviewedActionConfirmation} will be cancelled',
      },
    },
    SAVI_MANUALLY_REVIEWED_ITEMS: {
      ATTESTATIONS: {
        id: 'SAVI_MANUALLY_REVIEWED_ITEMS',
        defaultMessage:
          'You have manually reviewed {manuallyReviewedTotal} {pluralizeItems}',
      },
    },
    SAVI_KEEP_YOUR_ITEMS: {
      ATTESTATIONS: {
        id: 'SAVI_KEEP_YOUR_ITEMS',
        defaultMessage: 'Keep Your {manuallyReviewedTotal} {pluralizeItems}',
      },
    },
    SAVI_CANCEL_SMART_ACTIONS: {
      ATTESTATIONS: {
        id: 'SAVI_CANCEL_SMART_ACTIONS',
        defaultMessage: 'Cancel Smart {manuallyReviewedActionConfirmation}',
      },
    },
    REVIEW_AND_SUBMIT_CERTIFICATION: {
      ATTESTATIONS: {
        id: 'REVIEW_AND_SUBMIT_CERTIFICATION',
        defaultMessage: 'Review and Submit Your Certification',
      },
    },
    REVIEW_YOUR_CERTIFICATION_INCOMPLETE: {
      ATTESTATIONS: {
        id: 'REVIEW_YOUR_CERTIFICATION_INCOMPLETE',
        defaultMessage: 'Your Certification Is Incomplete',
      },
    },
    REVIEW_COMPLETE_CERTIFICATION: {
      ATTESTATIONS: {
        id: 'REVIEW_COMPLETE_CERTIFICATION',
        defaultMessage: 'Complete Your Certification',
      },
    },
    CERTS_NETWORK_ERROR: {
      ATTESTATIONS: {
        id: 'CERTS_NETWORK_ERROR',
        defaultMessage: 'Network Error , Please retry after sometime',
      },
    },
    CERTS_DONT_SHOW_ME_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_DONT_SHOW_ME_MSG',
        defaultMessage:
          'Don’t show me this message again for this certification',
      },
    },
    CERTS_REVOKE_DATE_DETAIL: {
      ATTESTATIONS: {
        id: 'CERTS_REVOKE_DATE_DETAIL',
        defaultMessage:
          'This campaign has been configured so that the following items will be revoked after the due date:',
      },
    },
    CERTS_REVOKE_TITLE: {
      ATTESTATIONS: {
        id: 'CERTS_REVOKE_TITLE',
        defaultMessage: 'Automatic Access Revocation Notice',
      },
    },
    CERTS_REVOKE_AUTO_MSG: {
      ATTESTATIONS: {
        id: 'CERTS_REVOKE_AUTO_MSG',
        defaultMessage:
          'If you don’t submit your certification by the due date ({revokeDueDate}), some access will be automatically revoked.',
      },
    },
    CERTS_CONSULTATION_REQUESTED: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULTATION_REQUESTED',
        defaultMessage: 'Consultation Requested',
      },
    },
    CERTS_CONSULTATION_INFO: {
      ATTESTATIONS: {
        id: 'CERTS_CONSULTATION_INFO',
        defaultMessage:
          'You can wait for responses to your consultations, consult with other peers, or go ahead and make decisions. Once all decisions are made, you can review and submit your certification.',
      },
    },
    CERTS_REVIEW_STEP2_REQUIRED_FIELD: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_REQUIRED_FIELD',
        defaultMessage: 'Required field is missing.',
      },
    },
    CERTS_REVIEW_STEP2_REQUIRED_FIELDS: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_REQUIRED_FIELDS',
        defaultMessage: 'Required fields ({count}) are missing.',
      },
    },
    CERTS_REVIEW_STEP2_PWD: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_PWD',
        defaultMessage: 'Password',
      },
    },
    CERTS_REVIEW_STEP2_TYPE: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_TYPE',
        defaultMessage: 'Type',
      },
    },
    CERTS_REVIEW_STEP2_DRAW: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_DRAW',
        defaultMessage: 'Draw',
      },
    },
    CERTS_REVIEW_STEP2_UPLOAD: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_UPLOAD',
        defaultMessage: 'Upload',
      },
    },
    CERTS_REVIEW_STEP2_PLEASE_ENTER_APPLICABLE: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_PLEASE_ENTER_APPLICABLE',
        defaultMessage: 'Please enter {attribute} if applicable else enter N/A',
      },
    },
    CERTS_REVIEW_STEP2_ESIGNATURE: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_ESIGNATURE',
        defaultMessage: 'E-Signature',
      },
    },
    CERTS_REVIEW_STEP2_FIELD_INCOMPLETE: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_FIELD_INCOMPLETE',
        defaultMessage: 'This required field is incomplete',
      },
    },
    CERTS_REVIEW_STEP2_TYPE_PWD: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_TYPE_PWD',
        defaultMessage: 'Type your password',
      },
    },
    CERTS_REVIEW_STEP2_TYPE_NAME_TO_SIGN: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_TYPE_NAME_TO_SIGN',
        defaultMessage: 'Type your name to sign',
      },
    },
    CERTS_REVIEW_STEP2_DRAW_SIGNATURE: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_DRAW_SIGNATURE',
        defaultMessage: 'Draw your signature',
      },
    },
    CERTS_REVIEW_STEP2_TERMS_AND_CONDITIONS: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_TERMS_AND_CONDITIONS',
        defaultMessage: 'Terms and Conditions',
      },
    },
    CERTS_REVIEW_STEP2_CLEAR: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_CLEAR',
        defaultMessage: 'Clear',
      },
    },
    CERTS_REVIEW_STEP2_VIEW: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_VIEW',
        defaultMessage: 'View',
      },
    },
    CERTS_REVIEW_STEP2_ENTER: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_ENTER',
        defaultMessage: 'Enter',
      },
    },
    CERTS_REVIEW_STEP2_AGREE: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_STEP2_AGREE',
        defaultMessage: 'I agree',
      },
    },
    CERTS_REVIEW_SUMMARY_LOAD_ERROR: {
      ATTESTATIONS: {
        id: 'CERTS_REVIEW_SUMMARY_LOAD_ERROR',
        defaultMessage:
          "The Summary didn't load properly due to a network issue. Please refresh or try again later.",
      },
    },
    CERTS_MIN_SEARCH_CHARACTERS: {
      ATTESTATIONS: {
        id: 'CERTS_MIN_SEARCH_CHARACTERS',
        defaultMessage: 'Type more than 2 characters to see results.',
      },
    },
    CERTS_UPDATE_ACCOUNT_OWNER: {
      ATTESTATIONS: {
        id: 'CERTS_UPDATE_ACCOUNT_OWNER',
        defaultMessage: 'Update Account Owner',
      },
    },
    // RO campaign Keys
    'ACCOUNTNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'ACCOUNTNAME.ATTESTATIONS',
        defaultMessage: 'Account Name',
      },
    },
    'CERT_USERKEY.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'CERT_USERKEY.ATTESTATIONS',
        defaultMessage: 'Certification User Key',
      },
    },
    'DEFAULTACCOUNTNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'DEFAULTACCOUNTNAME.ATTESTATIONS',
        defaultMessage: 'Account',
      },
    },
    'DEFAULTENTITLEMENTNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'DEFAULTENTITLEMENTNAME.ATTESTATIONS',
        defaultMessage: 'Entitlement',
      },
    },
    'ENDPOINT.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'ENDPOINT.ATTESTATIONS',
        defaultMessage: 'Endpoint Name',
      },
    },
    'ENTITLEMENT_VALUE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'ENTITLEMENT_VALUE.ATTESTATIONS',
        defaultMessage: 'Entitlement Value',
      },
    },
    'ENTTYPE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'ENTTYPE.ATTESTATIONS',
        defaultMessage: 'Entitlement Type',
      },
    },
    'Ent_ACCESS.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_ACCESS.ATTESTATIONS',
        defaultMessage: 'Entitlement Access',
      },
    },
    'Ent_CONFIDENTIALITY.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CONFIDENTIALITY.ATTESTATIONS',
        defaultMessage: 'Entitlement Confidentiality',
      },
    },
    'Ent_CUSTOMPROPERTY1.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY1.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 1',
      },
    },
    'Ent_CUSTOMPROPERTY10.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY10.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 10',
      },
    },
    'Ent_CUSTOMPROPERTY11.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY11.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 11',
      },
    },
    'Ent_CUSTOMPROPERTY12.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY12.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 12',
      },
    },
    'Ent_CUSTOMPROPERTY13.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY13.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 13',
      },
    },
    'Ent_CUSTOMPROPERTY14.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY14.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 14',
      },
    },
    'Ent_CUSTOMPROPERTY15.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY15.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 15',
      },
    },
    'Ent_CUSTOMPROPERTY16.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY16.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 16',
      },
    },
    'Ent_CUSTOMPROPERTY17.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY17.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 17',
      },
    },
    'Ent_CUSTOMPROPERTY18.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY18.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 18',
      },
    },
    'Ent_CUSTOMPROPERTY19.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY19.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 19',
      },
    },
    'Ent_CUSTOMPROPERTY2.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY2.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 2',
      },
    },
    'Ent_CUSTOMPROPERTY20.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY20.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 20',
      },
    },
    'Ent_CUSTOMPROPERTY21.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY21.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 21',
      },
    },
    'Ent_CUSTOMPROPERTY22.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY22.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 22',
      },
    },
    'Ent_CUSTOMPROPERTY23.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY23.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 23',
      },
    },
    'Ent_CUSTOMPROPERTY24.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY24.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 24',
      },
    },
    'Ent_CUSTOMPROPERTY25.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY25.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 25',
      },
    },
    'Ent_CUSTOMPROPERTY26.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY26.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 26',
      },
    },
    'Ent_CUSTOMPROPERTY27.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY27.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 27',
      },
    },
    'Ent_CUSTOMPROPERTY28.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY28.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 28',
      },
    },
    'Ent_CUSTOMPROPERTY29.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY29.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 29',
      },
    },
    'Ent_CUSTOMPROPERTY3.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY3.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 3',
      },
    },
    'Ent_CUSTOMPROPERTY30.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY30.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 30',
      },
    },
    'Ent_CUSTOMPROPERTY31.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY31.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 31',
      },
    },
    'Ent_CUSTOMPROPERTY32.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY32.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 32',
      },
    },
    'Ent_CUSTOMPROPERTY33.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY33.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 33',
      },
    },
    'Ent_CUSTOMPROPERTY34.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY34.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 34',
      },
    },
    'Ent_CUSTOMPROPERTY35.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY35.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 35',
      },
    },
    'Ent_CUSTOMPROPERTY36.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY36.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 36',
      },
    },
    'Ent_CUSTOMPROPERTY37.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY37.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 37',
      },
    },
    'Ent_CUSTOMPROPERTY38.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY38.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 38',
      },
    },
    'Ent_CUSTOMPROPERTY39.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY39.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 39',
      },
    },
    'Ent_CUSTOMPROPERTY4.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY4.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 4',
      },
    },
    'Ent_CUSTOMPROPERTY40.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY40.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 40',
      },
    },
    'Ent_CUSTOMPROPERTY5.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY5.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 5',
      },
    },
    'Ent_CUSTOMPROPERTY6.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY6.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 6',
      },
    },
    'Ent_CUSTOMPROPERTY7.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY7.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 7',
      },
    },
    'Ent_CUSTOMPROPERTY8.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY8.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 8',
      },
    },
    'Ent_CUSTOMPROPERTY9.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_CUSTOMPROPERTY9.ATTESTATIONS',
        defaultMessage: 'Entitlement Custom Property 9',
      },
    },
    'Ent_DESCRIPTION.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_DESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Entitlement Description',
      },
    },
    'Ent_DISPLAYNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_DISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'Entitlement Display Name',
      },
    },
    'Ent_ENTITLEMENT_GLOSSARY.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_ENTITLEMENT_GLOSSARY.ATTESTATIONS',
        defaultMessage: 'Entitlement Glossary',
      },
    },
    'Ent_LASTREVIEWEDBY.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_LASTREVIEWEDBY.ATTESTATIONS',
        defaultMessage: 'Last Reviewed By',
      },
    },
    'Ent_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS',
        defaultMessage: 'Last Reviewed Campaign',
      },
    },
    'Ent_LASTREVIEWEDDATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_LASTREVIEWEDDATE.ATTESTATIONS',
        defaultMessage: 'Last reviewed Date',
      },
    },
    'Ent_LASTSCANDATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_LASTSCANDATE.ATTESTATIONS',
        defaultMessage: 'Entitlement Last Scan Date',
      },
    },
    'Ent_PRIVILEGED.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_PRIVILEGED.ATTESTATIONS',
        defaultMessage: 'Entitlement Privileged',
      },
    },
    'Ent_RISK.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_RISK.ATTESTATIONS',
        defaultMessage: 'Entitlement Risk',
      },
    },
    'Ent_SOX_CRITICAL.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_SOX_CRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement SOX Critical',
      },
    },
    'Ent_STATUS.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_STATUS.ATTESTATIONS',
        defaultMessage: 'Entitlement Status',
      },
    },
    'Ent_SYS_CRITICAL.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_SYS_CRITICAL.ATTESTATIONS',
        defaultMessage: 'Entitlement Sys Critical',
      },
    },
    'JRMRULES.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'JRMRULES.ATTESTATIONS',
        defaultMessage: 'Outlier Analysis',
      },
    },
    'JSON_JRMRULESAVAILABLE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'JSON_JRMRULESAVAILABLE.ATTESTATIONS',
        defaultMessage: 'Outlier Analysis',
      },
    },
    'REASSIGNED.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'REASSIGNED.ATTESTATIONS',
        defaultMessage: 'Consulted',
      },
    },
    'Role_CUSTOMPROPERTY1.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY1.ATTESTATIONS',
        defaultMessage: 'CustomProperty 1',
      },
    },
    'Role_CUSTOMPROPERTY10.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY10.ATTESTATIONS',
        defaultMessage: 'CustomProperty 10',
      },
    },
    'Role_CUSTOMPROPERTY11.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY11.ATTESTATIONS',
        defaultMessage: 'CustomProperty 11',
      },
    },
    'Role_CUSTOMPROPERTY12.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY12.ATTESTATIONS',
        defaultMessage: 'CustomProperty 12',
      },
    },
    'Role_CUSTOMPROPERTY13.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY13.ATTESTATIONS',
        defaultMessage: 'CustomProperty 13',
      },
    },
    'Role_CUSTOMPROPERTY14.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY14.ATTESTATIONS',
        defaultMessage: 'CustomProperty 14',
      },
    },
    'Role_CUSTOMPROPERTY15.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY15.ATTESTATIONS',
        defaultMessage: 'CustomProperty 15',
      },
    },
    'Role_CUSTOMPROPERTY16.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY16.ATTESTATIONS',
        defaultMessage: 'CustomProperty 16',
      },
    },
    'Role_CUSTOMPROPERTY17.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY17.ATTESTATIONS',
        defaultMessage: 'CustomProperty 17',
      },
    },
    'Role_CUSTOMPROPERTY18.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY18.ATTESTATIONS',
        defaultMessage: 'CustomProperty 18',
      },
    },
    'Role_CUSTOMPROPERTY19.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY19.ATTESTATIONS',
        defaultMessage: 'CustomProperty 19',
      },
    },
    'Role_CUSTOMPROPERTY2.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY2.ATTESTATIONS',
        defaultMessage: 'CustomProperty 2',
      },
    },
    'Role_CUSTOMPROPERTY20.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY20.ATTESTATIONS',
        defaultMessage: 'CustomProperty 20',
      },
    },
    'Role_CUSTOMPROPERTY21.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY21.ATTESTATIONS',
        defaultMessage: 'CustomProperty 21',
      },
    },
    'Role_CUSTOMPROPERTY22.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY22.ATTESTATIONS',
        defaultMessage: 'CustomProperty 22',
      },
    },
    'Role_CUSTOMPROPERTY23.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY23.ATTESTATIONS',
        defaultMessage: 'CustomProperty 23',
      },
    },
    'Role_CUSTOMPROPERTY24.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY24.ATTESTATIONS',
        defaultMessage: 'CustomProperty 24',
      },
    },
    'Role_CUSTOMPROPERTY25.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY25.ATTESTATIONS',
        defaultMessage: 'CustomProperty 25',
      },
    },
    'Role_CUSTOMPROPERTY26.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY26.ATTESTATIONS',
        defaultMessage: 'CustomProperty 26',
      },
    },
    'Role_CUSTOMPROPERTY27.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY27.ATTESTATIONS',
        defaultMessage: 'CustomProperty 27',
      },
    },
    'Role_CUSTOMPROPERTY28.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY28.ATTESTATIONS',
        defaultMessage: 'CustomProperty 28',
      },
    },
    'Role_CUSTOMPROPERTY29.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY29.ATTESTATIONS',
        defaultMessage: 'CustomProperty 29',
      },
    },
    'Role_CUSTOMPROPERTY3.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY3.ATTESTATIONS',
        defaultMessage: 'CustomProperty 3',
      },
    },
    'Role_CUSTOMPROPERTY30.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY30.ATTESTATIONS',
        defaultMessage: 'CustomProperty 30',
      },
    },
    'Role_CUSTOMPROPERTY31.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY31.ATTESTATIONS',
        defaultMessage: 'CustomProperty 31',
      },
    },
    'Role_CUSTOMPROPERTY32.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY32.ATTESTATIONS',
        defaultMessage: 'CustomProperty 32',
      },
    },
    'Role_CUSTOMPROPERTY33.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY33.ATTESTATIONS',
        defaultMessage: 'CustomProperty 33',
      },
    },
    'Role_CUSTOMPROPERTY34.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY34.ATTESTATIONS',
        defaultMessage: 'CustomProperty 34',
      },
    },
    'Role_CUSTOMPROPERTY35.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY35.ATTESTATIONS',
        defaultMessage: 'CustomProperty 35',
      },
    },
    'Role_CUSTOMPROPERTY36.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY36.ATTESTATIONS',
        defaultMessage: 'CustomProperty 36',
      },
    },
    'Role_CUSTOMPROPERTY37.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY37.ATTESTATIONS',
        defaultMessage: 'CustomProperty 37',
      },
    },
    'Role_CUSTOMPROPERTY38.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY38.ATTESTATIONS',
        defaultMessage: 'CustomProperty 38',
      },
    },
    'Role_CUSTOMPROPERTY39.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY39.ATTESTATIONS',
        defaultMessage: 'CustomProperty 39',
      },
    },
    'Role_CUSTOMPROPERTY4.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY4.ATTESTATIONS',
        defaultMessage: 'CustomProperty 4',
      },
    },
    'Role_CUSTOMPROPERTY40.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY40.ATTESTATIONS',
        defaultMessage: 'CustomProperty 40',
      },
    },
    'Role_CUSTOMPROPERTY41.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY41.ATTESTATIONS',
        defaultMessage: 'CustomProperty 41',
      },
    },
    'Role_CUSTOMPROPERTY42.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY42.ATTESTATIONS',
        defaultMessage: 'CustomProperty 42',
      },
    },
    'Role_CUSTOMPROPERTY43.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY43.ATTESTATIONS',
        defaultMessage: 'CustomProperty 43',
      },
    },
    'Role_CUSTOMPROPERTY44.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY44.ATTESTATIONS',
        defaultMessage: 'CustomProperty 44',
      },
    },
    'Role_CUSTOMPROPERTY45.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY45.ATTESTATIONS',
        defaultMessage: 'CustomProperty 45',
      },
    },
    'Role_CUSTOMPROPERTY46.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY46.ATTESTATIONS',
        defaultMessage: 'CustomProperty 46',
      },
    },
    'Role_CUSTOMPROPERTY47.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY47.ATTESTATIONS',
        defaultMessage: 'CustomProperty 47',
      },
    },
    'Role_CUSTOMPROPERTY48.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY48.ATTESTATIONS',
        defaultMessage: 'CustomProperty 48',
      },
    },
    'Role_CUSTOMPROPERTY49.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY49.ATTESTATIONS',
        defaultMessage: 'CustomProperty 49',
      },
    },
    'Role_CUSTOMPROPERTY5.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY5.ATTESTATIONS',
        defaultMessage: 'CustomProperty 5',
      },
    },
    'Role_CUSTOMPROPERTY50.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY50.ATTESTATIONS',
        defaultMessage: 'CustomProperty 50',
      },
    },
    'Role_CUSTOMPROPERTY51.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY51.ATTESTATIONS',
        defaultMessage: 'CustomProperty 51',
      },
    },
    'Role_CUSTOMPROPERTY52.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY52.ATTESTATIONS',
        defaultMessage: 'CustomProperty 52',
      },
    },
    'Role_CUSTOMPROPERTY53.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY53.ATTESTATIONS',
        defaultMessage: 'CustomProperty 53',
      },
    },
    'Role_CUSTOMPROPERTY54.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY54.ATTESTATIONS',
        defaultMessage: 'CustomProperty 54',
      },
    },
    'Role_CUSTOMPROPERTY55.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY55.ATTESTATIONS',
        defaultMessage: 'CustomProperty 55',
      },
    },
    'Role_CUSTOMPROPERTY56.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY56.ATTESTATIONS',
        defaultMessage: 'CustomProperty 56',
      },
    },
    'Role_CUSTOMPROPERTY57.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY57.ATTESTATIONS',
        defaultMessage: 'CustomProperty 57',
      },
    },
    'Role_CUSTOMPROPERTY58.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY58.ATTESTATIONS',
        defaultMessage: 'CustomProperty 58',
      },
    },
    'Role_CUSTOMPROPERTY59.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY59.ATTESTATIONS',
        defaultMessage: 'CustomProperty 59',
      },
    },
    'Role_CUSTOMPROPERTY6.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY6.ATTESTATIONS',
        defaultMessage: 'CustomProperty 6',
      },
    },
    'Role_CUSTOMPROPERTY60.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY60.ATTESTATIONS',
        defaultMessage: 'CustomProperty 60',
      },
    },
    'Role_CUSTOMPROPERTY7.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY7.ATTESTATIONS',
        defaultMessage: 'CustomProperty 7',
      },
    },
    'Role_CUSTOMPROPERTY8.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY8.ATTESTATIONS',
        defaultMessage: 'CustomProperty 8',
      },
    },
    'Role_CUSTOMPROPERTY9.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_CUSTOMPROPERTY9.ATTESTATIONS',
        defaultMessage: 'CustomProperty 9',
      },
    },
    'Role_DESCRIPTION.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_DESCRIPTION.ATTESTATIONS',
        defaultMessage: 'Role Description',
      },
    },
    'Role_DISPLAYNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_DISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'Role Display Name',
      },
    },
    'Role_GLOSSARY.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_GLOSSARY.ATTESTATIONS',
        defaultMessage: 'Glossary',
      },
    },
    'Role_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS',
        defaultMessage: 'Last Reviewed Campaign',
      },
    },
    'ROLE_NAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'ROLE_NAME.ATTESTATIONS',
        defaultMessage: 'Role Name',
      },
    },
    'Role_NEWROLEOWNER.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_NEWROLEOWNER.ATTESTATIONS',
        defaultMessage: 'New Role Owner',
      },
    },
    'Role_OLDROLEOWNER.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_OLDROLEOWNER.ATTESTATIONS',
        defaultMessage: 'Old Role Owner',
      },
    },
    'Role_RISK.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_RISK.ATTESTATIONS',
        defaultMessage: 'Role Risk',
      },
    },
    'Role_ROLESTATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_ROLESTATE.ATTESTATIONS',
        defaultMessage: 'Role State',
      },
    },
    'Role_ROLETYPE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_ROLETYPE.ATTESTATIONS',
        defaultMessage: 'Role type',
      },
    },
    'ROW_TYPE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'ROW_TYPE.ATTESTATIONS',
        defaultMessage: 'Row Type',
      },
    },
    'SYSTEMNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'SYSTEMNAME.ATTESTATIONS',
        defaultMessage: 'System Name',
      },
    },
    'USERNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'USERNAME.ATTESTATIONS',
        defaultMessage: 'Username',
      },
    },
    'User_ACCOUNTEXPIRED.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_ACCOUNTEXPIRED.ATTESTATIONS',
        defaultMessage: 'User Account Expired',
      },
    },
    'User_ACCOUNTLOCKED.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_ACCOUNTLOCKED.ATTESTATIONS',
        defaultMessage: 'User Account Locked',
      },
    },
    'User_CERTCOMMENTS.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CERTCOMMENTS.ATTESTATIONS',
        defaultMessage: 'Comments',
      },
    },
    'User_CITY.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CITY.ATTESTATIONS',
        defaultMessage: 'User My City',
      },
    },
    'User_COMPANYNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_COMPANYNAME.ATTESTATIONS',
        defaultMessage: 'User Company Name',
      },
    },
    'User_COSTCENTER.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_COSTCENTER.ATTESTATIONS',
        defaultMessage: 'User Cost Centre',
      },
    },
    'User_COUNTRY.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_COUNTRY.ATTESTATIONS',
        defaultMessage: 'User Country',
      },
    },
    'User_CREATEDATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CREATEDATE.ATTESTATIONS',
        defaultMessage: 'User Create Date',
      },
    },
    'User_CREATEDBY.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CREATEDBY.ATTESTATIONS',
        defaultMessage: 'Created By',
      },
    },
    'User_CUSTOMER.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMER.ATTESTATIONS',
        defaultMessage: 'User Customer',
      },
    },
    'User_CUSTOMPROPERTY1.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY1.ATTESTATIONS',
        defaultMessage: 'My Manager Location',
      },
    },
    'User_CUSTOMPROPERTY10.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY10.ATTESTATIONS',
        defaultMessage: 'User Custom Property 10',
      },
    },
    'User_CUSTOMPROPERTY11.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY11.ATTESTATIONS',
        defaultMessage: 'User Custom Property 11',
      },
    },
    'User_CUSTOMPROPERTY12.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY12.ATTESTATIONS',
        defaultMessage: 'User Custom Property 12',
      },
    },
    'User_CUSTOMPROPERTY13.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY13.ATTESTATIONS',
        defaultMessage: 'User Custom Property 13',
      },
    },
    'User_CUSTOMPROPERTY14.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY14.ATTESTATIONS',
        defaultMessage: 'User Custom Property 14',
      },
    },
    'User_CUSTOMPROPERTY15.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY15.ATTESTATIONS',
        defaultMessage: 'User Custom Property 15',
      },
    },
    'User_CUSTOMPROPERTY16.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY16.ATTESTATIONS',
        defaultMessage: 'User Custom Property 16',
      },
    },
    'User_CUSTOMPROPERTY17.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY17.ATTESTATIONS',
        defaultMessage: 'User Custom Property 17',
      },
    },
    'User_CUSTOMPROPERTY18.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY18.ATTESTATIONS',
        defaultMessage: 'User Custom Property 18',
      },
    },
    'User_CUSTOMPROPERTY19.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY19.ATTESTATIONS',
        defaultMessage: 'User Custom Property 19',
      },
    },
    'User_CUSTOMPROPERTY2.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY2.ATTESTATIONS',
        defaultMessage: 'User Custom Property 2',
      },
    },
    'User_CUSTOMPROPERTY20.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY20.ATTESTATIONS',
        defaultMessage: 'User Custom Property 20',
      },
    },
    'User_CUSTOMPROPERTY21.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY21.ATTESTATIONS',
        defaultMessage: 'User Custom Property 21',
      },
    },
    'User_CUSTOMPROPERTY22.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY22.ATTESTATIONS',
        defaultMessage: 'My custom property',
      },
    },
    'User_CUSTOMPROPERTY23.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY23.ATTESTATIONS',
        defaultMessage: 'User Custom Property 23',
      },
    },
    'User_CUSTOMPROPERTY24.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY24.ATTESTATIONS',
        defaultMessage: 'User Custom Property 24',
      },
    },
    'User_CUSTOMPROPERTY25.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY25.ATTESTATIONS',
        defaultMessage: 'User Custom Property 25',
      },
    },
    'User_CUSTOMPROPERTY26.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY26.ATTESTATIONS',
        defaultMessage: 'User Custom Property 26',
      },
    },
    'User_CUSTOMPROPERTY27.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY27.ATTESTATIONS',
        defaultMessage: 'User Custom Property 27',
      },
    },
    'User_CUSTOMPROPERTY28.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY28.ATTESTATIONS',
        defaultMessage: 'User Custom Property 28',
      },
    },
    'User_CUSTOMPROPERTY29.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY29.ATTESTATIONS',
        defaultMessage: 'User Custom Property 29',
      },
    },
    'User_CUSTOMPROPERTY3.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY3.ATTESTATIONS',
        defaultMessage: 'User Custom Property 3',
      },
    },
    'User_CUSTOMPROPERTY30.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY30.ATTESTATIONS',
        defaultMessage: 'User Custom Property 30',
      },
    },
    'User_CUSTOMPROPERTY31.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY31.ATTESTATIONS',
        defaultMessage: 'User Custom Property 31',
      },
    },
    'User_CUSTOMPROPERTY32.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY32.ATTESTATIONS',
        defaultMessage: 'User Custom Property 32',
      },
    },
    'User_CUSTOMPROPERTY33.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY33.ATTESTATIONS',
        defaultMessage: 'User Custom Property 33',
      },
    },
    'User_CUSTOMPROPERTY34.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY34.ATTESTATIONS',
        defaultMessage: 'User Custom Property 34',
      },
    },
    'User_CUSTOMPROPERTY35.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY35.ATTESTATIONS',
        defaultMessage: 'User Custom Property 35',
      },
    },
    'User_CUSTOMPROPERTY36.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY36.ATTESTATIONS',
        defaultMessage: 'User Custom Property 36',
      },
    },
    'User_CUSTOMPROPERTY37.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY37.ATTESTATIONS',
        defaultMessage: 'User Custom Property 37',
      },
    },
    'User_CUSTOMPROPERTY38.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY38.ATTESTATIONS',
        defaultMessage: 'User Custom Property 38',
      },
    },
    'User_CUSTOMPROPERTY39.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY39.ATTESTATIONS',
        defaultMessage: 'User Custom Property 39',
      },
    },
    'User_CUSTOMPROPERTY4.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY4.ATTESTATIONS',
        defaultMessage: 'User Custom Property 4',
      },
    },
    'User_CUSTOMPROPERTY40.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY40.ATTESTATIONS',
        defaultMessage: 'User Custom Property 40',
      },
    },
    'User_CUSTOMPROPERTY41.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY41.ATTESTATIONS',
        defaultMessage: 'User Custom Property 41',
      },
    },
    'User_CUSTOMPROPERTY42.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY42.ATTESTATIONS',
        defaultMessage: 'User Custom Property 42',
      },
    },
    'User_CUSTOMPROPERTY43.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY43.ATTESTATIONS',
        defaultMessage: 'User Custom Property 43',
      },
    },
    'User_CUSTOMPROPERTY44.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY44.ATTESTATIONS',
        defaultMessage: 'User Custom Property 44',
      },
    },
    'User_CUSTOMPROPERTY45.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY45.ATTESTATIONS',
        defaultMessage: 'User Custom Property 45',
      },
    },
    'User_CUSTOMPROPERTY46.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY46.ATTESTATIONS',
        defaultMessage: 'User Custom Property 46',
      },
    },
    'User_CUSTOMPROPERTY47.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY47.ATTESTATIONS',
        defaultMessage: 'User Custom Property 47',
      },
    },
    'User_CUSTOMPROPERTY48.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY48.ATTESTATIONS',
        defaultMessage: 'User Custom Property 48',
      },
    },
    'User_CUSTOMPROPERTY49.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY49.ATTESTATIONS',
        defaultMessage: 'User Custom Property 49',
      },
    },
    'User_CUSTOMPROPERTY5.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY5.ATTESTATIONS',
        defaultMessage: 'User Custom Property 5',
      },
    },
    'User_CUSTOMPROPERTY50.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY50.ATTESTATIONS',
        defaultMessage: 'User Custom Property 50',
      },
    },
    'User_CUSTOMPROPERTY51.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY51.ATTESTATIONS',
        defaultMessage: 'User Custom Property 51',
      },
    },
    'User_CUSTOMPROPERTY52.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY52.ATTESTATIONS',
        defaultMessage: 'User Custom Property 52',
      },
    },
    'User_CUSTOMPROPERTY53.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY53.ATTESTATIONS',
        defaultMessage: 'User Custom Property 53',
      },
    },
    'User_CUSTOMPROPERTY54.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY54.ATTESTATIONS',
        defaultMessage: 'User Custom Property 54',
      },
    },
    'User_CUSTOMPROPERTY55.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY55.ATTESTATIONS',
        defaultMessage: 'User Custom Property 55',
      },
    },
    'User_CUSTOMPROPERTY56.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY56.ATTESTATIONS',
        defaultMessage: 'User Custom Property 56',
      },
    },
    'User_CUSTOMPROPERTY57.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY57.ATTESTATIONS',
        defaultMessage: 'User Custom Property 57',
      },
    },
    'User_CUSTOMPROPERTY58.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY58.ATTESTATIONS',
        defaultMessage: 'User Custom Property 58',
      },
    },
    'User_CUSTOMPROPERTY59.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY59.ATTESTATIONS',
        defaultMessage: 'User Custom Property 59',
      },
    },
    'User_CUSTOMPROPERTY6.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY6.ATTESTATIONS',
        defaultMessage: 'User Custom Property 6',
      },
    },
    'User_CUSTOMPROPERTY60.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY60.ATTESTATIONS',
        defaultMessage: 'User Custom Property 60',
      },
    },
    'User_CUSTOMPROPERTY61.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY61.ATTESTATIONS',
        defaultMessage: 'User Custom Property 61',
      },
    },
    'User_CUSTOMPROPERTY62.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY62.ATTESTATIONS',
        defaultMessage: 'User Custom Property 62',
      },
    },
    'User_CUSTOMPROPERTY63.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY63.ATTESTATIONS',
        defaultMessage: 'User Custom Property 63',
      },
    },
    'User_CUSTOMPROPERTY64.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY64.ATTESTATIONS',
        defaultMessage: 'User Custom Property 64',
      },
    },
    'User_CUSTOMPROPERTY65.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY65.ATTESTATIONS',
        defaultMessage: 'User Custom Property 65',
      },
    },
    'User_CUSTOMPROPERTY7.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY7.ATTESTATIONS',
        defaultMessage: 'User Custom Property 7',
      },
    },
    'User_CUSTOMPROPERTY8.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY8.ATTESTATIONS',
        defaultMessage: 'User Custom Property 8',
      },
    },
    'User_CUSTOMPROPERTY9.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_CUSTOMPROPERTY9.ATTESTATIONS',
        defaultMessage: 'User Custom Property 9',
      },
    },
    'User_DEPARTMENTNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_DEPARTMENTNAME.ATTESTATIONS',
        defaultMessage: 'User Department Name',
      },
    },
    'User_DEPARTMENTNUMBER.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_DEPARTMENTNUMBER.ATTESTATIONS',
        defaultMessage: 'User Department Number',
      },
    },
    'User_DISPLAYNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_DISPLAYNAME.ATTESTATIONS',
        defaultMessage: 'User Display Name',
      },
    },
    'User_DONOTDISTURBDELEGATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_DONOTDISTURBDELEGATE.ATTESTATIONS',
        defaultMessage: 'User Do Not Disturb Delegate',
      },
    },
    'User_EMAIL.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_EMAIL.ATTESTATIONS',
        defaultMessage: 'User Email',
      },
    },
    'User_EMPLOYEECLASS.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_EMPLOYEECLASS.ATTESTATIONS',
        defaultMessage: 'User Employee Class',
      },
    },
    'User_EMPLOYEEID.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_EMPLOYEEID.ATTESTATIONS',
        defaultMessage: 'User Employee',
      },
    },
    'User_EMPLOYEETYPE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_EMPLOYEETYPE.ATTESTATIONS',
        defaultMessage: 'User Employee Type',
      },
    },
    'User_ENDDATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_ENDDATE.ATTESTATIONS',
        defaultMessage: 'User End Date',
      },
    },
    'User_ENTITY.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_ENTITY.ATTESTATIONS',
        defaultMessage: 'User Entity',
      },
    },
    'User_EXTENDEDENDDATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_EXTENDEDENDDATE.ATTESTATIONS',
        defaultMessage: 'User Extended Date',
      },
    },
    'User_FIRSTNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_FIRSTNAME.ATTESTATIONS',
        defaultMessage: 'User First Name',
      },
    },
    'User_JOBCODE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_JOBCODE.ATTESTATIONS',
        defaultMessage: 'User Job Code',
      },
    },
    'User_JOBCODEDESC.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_JOBCODEDESC.ATTESTATIONS',
        defaultMessage: 'User Job Code Description',
      },
    },
    'User_JOBDESCRIPTION.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_JOBDESCRIPTION.ATTESTATIONS',
        defaultMessage: 'User Job Description',
      },
    },
    'User_JOB_FUNCTION.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_JOB_FUNCTION.ATTESTATIONS',
        defaultMessage: 'User Job Function',
      },
    },
    'User_LASTCERTIFIEDCAMPAIGNNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_LASTCERTIFIEDCAMPAIGNNAME.ATTESTATIONS',
        defaultMessage: 'User Last Certified Campaign',
      },
    },
    'User_LASTCERTIFIEDDATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_LASTCERTIFIEDDATE.ATTESTATIONS',
        defaultMessage: 'User Last Certified Date',
      },
    },
    'User_LASTCERTIFIEDUSER.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_LASTCERTIFIEDUSER.ATTESTATIONS',
        defaultMessage: 'User Last Certified User',
      },
    },
    'User_LASTNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_LASTNAME.ATTESTATIONS',
        defaultMessage: 'User Last Name',
      },
    },
    'User_LASTSYNCDATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_LASTSYNCDATE.ATTESTATIONS',
        defaultMessage: 'User Last Sync Date',
      },
    },
    'User_LEAVESTATUS.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_LEAVESTATUS.ATTESTATIONS',
        defaultMessage: 'Leave Status',
      },
    },
    'User_LOCATION.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_LOCATION.ATTESTATIONS',
        defaultMessage: 'User Location',
      },
    },
    'User_LOCATIONDESC.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_LOCATIONDESC.ATTESTATIONS',
        defaultMessage: 'User Location Description',
      },
    },
    'User_LOCATIONNUMBER.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_LOCATIONNUMBER.ATTESTATIONS',
        defaultMessage: 'User Location Number',
      },
    },
    'User_MANAGER.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_MANAGER.ATTESTATIONS',
        defaultMessage: 'User Manager',
      },
    },
    'User_MIDDLENAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_MIDDLENAME.ATTESTATIONS',
        defaultMessage: 'User Middle Name',
      },
    },
    'User_ORGUNITID.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_ORGUNITID.ATTESTATIONS',
        defaultMessage: 'User Organization Unit',
      },
    },
    'User_OWNER.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_OWNER.ATTESTATIONS',
        defaultMessage: 'User Owner',
      },
    },
    'User_PHONENUMBER.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_PHONENUMBER.ATTESTATIONS',
        defaultMessage: 'User Phone Number',
      },
    },
    'User_PREFEREDFIRSTNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_PREFEREDFIRSTNAME.ATTESTATIONS',
        defaultMessage: 'Preferred First Name',
      },
    },
    'User_REGION.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_REGION.ATTESTATIONS',
        defaultMessage: 'User Region',
      },
    },
    'User_REGIONCODE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_REGIONCODE.ATTESTATIONS',
        defaultMessage: 'User Region Code',
      },
    },
    'User_RISKSCORE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_RISKSCORE.ATTESTATIONS',
        defaultMessage: 'User Risk Score',
      },
    },
    'User_SECONDARYEMAIL.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_SECONDARYEMAIL.ATTESTATIONS',
        defaultMessage: 'Secondary Email',
      },
    },
    'User_SECONDARYPHONE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_SECONDARYPHONE.ATTESTATIONS',
        defaultMessage: 'Secondary Phone',
      },
    },
    'User_SITEID.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_SITEID.ATTESTATIONS',
        defaultMessage: 'User Site',
      },
    },
    'User_SOURCELASTLOGINDATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_SOURCELASTLOGINDATE.ATTESTATIONS',
        defaultMessage: 'Source Last Login Date',
      },
    },
    'User_STARTDATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_STARTDATE.ATTESTATIONS',
        defaultMessage: 'User Start Date',
      },
    },
    'User_STATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_STATE.ATTESTATIONS',
        defaultMessage: 'User State',
      },
    },
    'User_STATUSKEY.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_STATUSKEY.ATTESTATIONS',
        defaultMessage: 'User Status',
      },
    },
    'User_STREET.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_STREET.ATTESTATIONS',
        defaultMessage: 'User Street',
      },
    },
    'User_SYSTEMUSERNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_SYSTEMUSERNAME.ATTESTATIONS',
        defaultMessage: 'User System Username',
      },
    },
    'User_TERMDATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_TERMDATE.ATTESTATIONS',
        defaultMessage: 'User Term Date',
      },
    },
    'User_TITLE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_TITLE.ATTESTATIONS',
        defaultMessage: 'User Title',
      },
    },
    'User_UPDATEDATE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_UPDATEDATE.ATTESTATIONS',
        defaultMessage: 'User Update Date',
      },
    },
    'User_USERCOMMENTS.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_USERCOMMENTS.ATTESTATIONS',
        defaultMessage: 'User Comments',
      },
    },
    'User_USERNAME.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_USERNAME.ATTESTATIONS',
        defaultMessage: 'Username',
      },
    },
    'User_USERSOURCE.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_USERSOURCE.ATTESTATIONS',
        defaultMessage: 'User Source',
      },
    },
    'ENTITLEMENT_PRIVILEGED.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'ENTITLEMENT_PRIVILEGED.ATTESTATIONS',
        defaultMessage: 'Entitlement Privileged',
      },
    },
    'SkipReassigned.v2.label.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'SkipReassigned.v2.label.ATTESTATIONS',
        defaultMessage: 'Skip Reassigned',
      },
    },
    'User_LABEL.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'User_LABEL.ATTESTATIONS',
        defaultMessage: 'User',
      },
    },
    'Account_LABEL.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Account_LABEL.ATTESTATIONS',
        defaultMessage: 'Account',
      },
    },
    'Ent_LABEL.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent_LABEL.ATTESTATIONS',
        defaultMessage: 'Entitlement',
      },
    },
    'Role_LABEL.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Role_LABEL.ATTESTATIONS',
        defaultMessage: 'Role',
      },
    },
    'Ent2_LABEL.ATTESTATIONS': {
      ATTESTATIONS: {
        id: 'Ent2_LABEL.ATTESTATIONS',
        defaultMessage: 'Child Entitlement',
      },
    },
    User_LABEL: {
      ATTESTATIONS: {
        id: 'User_LABEL',
        defaultMessage: 'User',
      },
    },
    Account_LABEL: {
      ATTESTATIONS: {
        id: 'Account_LABEL',
        defaultMessage: 'Account',
      },
    },
    Ent_LABEL: {
      ATTESTATIONS: {
        id: 'Ent_LABEL',
        defaultMessage: 'Entitlement',
      },
    },
    Role_LABEL: {
      ATTESTATIONS: {
        id: 'Role_LABEL',
        defaultMessage: 'Role',
      },
    },
    Ent2_LABEL: {
      ATTESTATIONS: {
        id: 'Ent2_LABEL',
        defaultMessage: 'Child Entitlement',
      },
    },
  },
};

export const VIEW_OPTIONS = {
  DEFAULT_VIEW: 'PERSONALIZATION.DEFAULT_VIEW.ATTESTATIONS',
  MY_PERSONALIZED_VIEW: 'PERSONALIZATION.MY_PERSONALIZED_VIEW.ATTESTATIONS',
};

export const PERSONALIZATION_STATUS = {
  NO_PERSONALIZATION: 'NO_PERSONALIZATION',
  EXIST_PERSONALIZATION: 'EXIST_PERSONALIZATION',
  ERROR: 'PERSONALIZATION_ERROR',
  NO_VIEW_FOUND: 'No View Found',
};

export const PERSONALIZATION_ALERTS = {
  CREATE_SUCCESS: 'Create successful',
  CREATE_FAILED: 'Create failed',
  UPDATE_SUCCESS: 'Update successful',
  UPDATE_FAILED: 'Update failed',
  UPDATE_FAILED_INVALID_LENGTH: 'Update failed invalid length',
};
